export const translations = {
  fi: {
    // Common
    loading: 'Ladataan...',
    error: 'Virhe',
    retry: 'Yritä uudelleen',
    back: 'Takaisin',
    logout: 'Kirjaudu ulos',
    signIn: 'Kirjaudu sisään',
    signUp: 'Rekisteröidy',
    dashboard: 'Hallintapaneeli',
    close: 'Sulje',
    copy: 'Kopioi',
    or: 'tai',

    // Header/Navigation
    myVideos: 'Omat videot',

    // Dashboard
    createAnimation: 'Luo animaatio',
    createAnimationDesc: 'Generoi opetusvideoita kemiaan, fysiikkaan ja matematiikkaan',
    recentVideos: 'Viimeisimmät videot',
    recentVideosDesc: 'Viimeisimmät luomuksesi',
    viewAllVideos: 'Näytä kaikki videot',
    backToDashboard: 'Takaisin hallintapaneeliin',
	
	// Dashboard subtitle update
    dashboardSubtitle: 'Sisällöntuotanto',
    
    // PIXEL AI Section
    pixelAI: {
      title: 'AnimLearn Tutor',
      subtitle: 'Tekoälyavusteinen opettajasi ongelmien ratkaisuun ja oppimiseen',
      menuTitle: 'AnimLearn Tutor',
      menuSubtitle: 'Tekoälyopettaja ja ongelman ratkaisija',
      solverTitle: 'Kysy PIXELiltä',
      solverSubtitle: 'Lataa ongelma tai esitä kysymys saadaksesi vaiheittaiset ratkaisut',
      historyTitle: 'Viimeaikaiset kysymykset',
      historySubtitle: 'Tarkastele aiempia keskusteluja AnimLearn Tutorin kanssa',
	  transparencyText: 'AnimLearn Tutor auttaa oppimisessa ja ongelmien ratkaisussa. Tarkista aina ratkaisut oppikirjoilla, opettajilla tai virallisilla materiaaleilla ennen luottamista niihin kokeissa.',
    },
	
	contentCreator: {
      title: 'Sisällöntuotanto',
      subtitle: 'Luo opetusvideoita tekoälypohjaisilla animaatioilla kemiaan, fysiikkaan ja matematiikkaan',
      menuTitle: 'Sisällöntuotanto',
      menuSubtitle: 'Luo animoituja videoita',
      
      // Feature badges
      feature1: 'Animoidut selitykset',
      feature2: 'Monikielinen tuki',
      feature3: 'Nopea generointi',
      
      // Responsibility notice
      responsibilityTitle: 'Luo tarkkuudella ja vastuullisesti',
      responsibilityText: 'Videosi laatu riippuu syötteesi tarkkuudesta. Anna oikeita ratkaisuja ja selityksiä. Tekoälymme auttaa visualisoinnissa ja animaatiossa, mutta sinä olet vastuussa opetussisällön tarkkuudesta. Opiskelijat ja opettajat luottavat huolellisuuteesi.',
      point1: 'Tarkista ratkaisusi ennen generointia',
      point2: 'Tarkista kaavat ja laskut huolellisesti',
      point3: 'Tarkista luodun sisällön tarkkuus',
	  privacyWarning: '⚠️ Älä koskaan syötä henkilökohtaisia tietoja (nimiä, terveystietoja, luottamuksellisia tietoja) järjestelmään, erityisesti alle 18-vuotiaiden oppilaiden osalta.',
      
      copyrightNotice: 'Tekijänoikeudet: Säilytät omistajuuden luotuihin videoihin ja voit jakaa niitä vapaasti opetustarkoituksiin.',
      
      contentSafety: 'Sisällön turvallisuus: Kaikki luotu sisältö valvotaan ikäsopivuuden suhteen. Tarkista kuitenkin videot ennen jakamista opiskelijoiden kanssa.',
      
      matricExamFocus: '🎓 Optimoitu suomen, ruotsin ja englannin ylioppilaskokeisiin',
      
      point4: 'Älä koskaan syötä henkilökohtaisia tai luottamuksellisia tietoja',
      point5: 'Omistat tekijänoikeudet - jaa vapaasti opetuskäyttöön'
    },
	 // Featured Videos Section
    featuredVideos: {
      title: 'Esittelyssä koulutusvideot',
      subtitle: 'Tutustu upeisiin opetussisältöihin, jotka on luotu AnimLearnilla',
      loading: 'Ladataan esittelyvideoita...',
      transcript: 'Teksti',
      communityGallery: {
        title: 'Löydä lisää upei luomuksia',
        description: 'Selaa satoja opetusanimaatioita, joita yhteisömme on luonut',
        button: 'Tutki yhteisögalleriaa'
      },
      language: {
        fi: 'Suomi',
        en: 'Englanti',
        sv: 'Ruotsi'
      }
    },
	
	videoLanguageModal: {
      title: 'Valitse ratkaisun kieli',
      subtitle: 'Valitse kieli ratkaisulle',
      finnish: 'Suomi',
      swedish: 'Ruotsi',
      english: 'Englanti',
      infoText: 'Ratkaisu luodaan valitulla kielellä.',
      cancel: 'Peruuta',
      solveProblem: 'Ratkaise tehtävä'
    },
	
	questionHistory: {
	  title: 'Kysymyshistoria',
	  subtitle: 'Tarkastele aiempia kysymyksiä ja ratkaisuja',
	  backToProblemSolver: 'Takaisin',
	  downloadAll: 'Lataa kaikki',
	  
	  // Filters
	  subject: 'Aine',
	  allSubjects: 'Kaikki aineet',
	  chemistry: 'Kemia',
	  physics: 'Fysiikka',
	  mathematics: 'Matematiikka',
	  timeRange: 'Aikaväli',
	  last7Days: 'Viimeiset 7 päivää',
	  last30Days: 'Viimeiset 30 päivää',
	  last90Days: 'Viimeiset 90 päivää',
	  lastYear: 'Viimeinen vuosi',
	  
	  // Question items
	  question: 'Kysymys',
	  solution: 'Ratkaisu',
	  video: 'Opetusvideo',
	  transcript: 'Tekstimuoto',
	  
	  // Actions
	  solveAgain: 'Ratkaise uudelleen',
	  generateVideo: 'Luo video',
	  generatePractice: 'Luo harjoitustehtäviä',
	  viewPracticeProblems: 'Näytä harjoitustehtävät',
	  generatingVideo: 'Luodaan videota...',
	  generatingPractice: 'Luodaan harjoitustehtäviä...',
	  
	  // Status
	  noQuestions: 'Ei kysymyksiä vielä',
	  noQuestionsDesc: 'Aloita ratkaisemalla ensimmäinen tehtäväsi',
	  loading: 'Ladataan historiaa...',

	  // Chat Sessions tab
	  chatSessions: 'Keskustelut',
	  loadingSessions: 'Ladataan keskusteluja...',
	  noSessions: 'Ei keskusteluja vielä. Aloita keskustelu AnimLearn Tutorissa!',
	  openPixelAI: 'Avaa AnimLearn Tutor',
	  untitledSession: 'Nimetön keskustelu',
	  messagesCount: 'viestiä',
	  resume: 'Jatka',
	  videoSolution: 'Videoratkaisu',
	  downloadPDF: 'Lataa PDF',
	  generating: 'Luodaan...',
	  viewPractice: 'Näytä harjoitustehtävät',
	  startSolving: 'Aloita ratkaiseminen',
	  timePeriod: 'Aikaväli',
	  practice: 'Harjoitustehtävää',
	},

	modal: {
		solveProblem: 'Harjoitustehtävä',
		problem: 'Tehtävä',
		showHint: 'Näytä vihje',
		hideHint: 'Piilota vihje',
		yourSolution: 'Sinun ratkaisusi',
		writeSolution: 'Kirjoita ratkaisusi tähän...\n\nVoit käyttää LaTeX-merkintöjä: $x^2 + 5x + 6 = 0$',
		checkYourAnswer: 'Saitko sen oikein?',
		correct: 'Oikein',
		incorrect: 'Väärin',
		showSolution: 'Näytä koko ratkaisu',
		hideSolution: 'Piilota ratkaisu',
		showAnswer: 'Näytä vastaus',
		hideAnswer: 'Piilota vastaus',
		modelAnswer: 'Mallivastaus',
		gradingCriteria: 'Arviointiperusteet',
		completeSolution: 'Täydellinen ratkaisu',
		cancel: 'Sulje',
		skipToNext: 'Ohita',
		submitSolution: 'Lähetä',
		submitted: 'Lähetetty ✓',
		greatJob: 'Hienoa työtä! Ratkaisu lähetetty.',
		keepPracticing: 'Jatka harjoittelua! Ratkaisu tallennettu.',
		movingToNext: 'Siirrytään seuraavaan tehtävään...',
		previousProblem: 'Edellinen tehtävä',
		nextProblem: 'Seuraava tehtävä'
	  },
	 problemSolver: {		 
	  title: 'AI Tehtävien Ratkaisu',
	  subtitle: 'Ratkaise kemian, fysiikan ja matematiikan tehtäviä PIXELin avulla',
	  backToDashboard: 'Hallintapaneeli',
	  history: 'Historia',
	  
	  subjects: {
		chemistry: 'Kemia',
		physics: 'Fysiikka',
		mathematics: 'Matematiikka'
	  },
	  
	  enterProblem: 'Mikä ongelma voin auttaa ratkaisemaan?',
	  problemPlaceholder: 'Kirjoita tehtäväsi tähän...\n\nEsimerkki: Laske 0,1M HCl-liuoksen pH\n\nVoit käyttää LaTeX-merkintöjä: $x^2 + 5x + 6 = 0$',
	  upload: 'Lataa',
	  camera: 'Kamera',
	  solve: 'Ratkaise tehtävä',
	  solving: 'Ratkaistaan...',
	  
	  yourQuestion: 'Sinun kysymyksesi',
	  solution: 'Askel-askeleelta ratkaisu',
	  educationalVideo: 'Opetusvideo',
	  newProblem: 'Uusi tehtävä',
	  
	  createVideo: 'Luo video',
	  createVideoDesc: 'Luo animoitu selitys',
	  generatePractice: 'Luo harjoitustehtäviä',
	  generatePracticeDesc: 'Saa samanlaisia tehtäviä',
	  viewHistory: 'Näytä historia',
	  viewHistoryDesc: 'Katso kaikki aiemmat kysymykset',
	  videoReady: 'Video valmis!',
	  videoReadyDesc: 'Katso yllä tai lataa',
	  generatingVideo: 'Luodaan opetusvideota...',
	  generatingPractice: 'Luodaan harjoitustehtäviä...',
	  generatingPracticeDesc: 'Luodaan harjoitustehtäviä sinulle',
	  creatingVideo: 'Luodaan videota...',
	  videoFailed: 'Videon luonti epäonnistui',
	  
	  practiceProblems: 'Harjoitustehtävät',
	  practiceSubtitle: 'Hallitse tämä aihe samanlaisilla tehtävillä',
	  solveProblem: 'Ratkaise tämä',
      
      // Input
      inputLabel: 'Liitä tai kirjoita tehtäväsi:',
      inputPlaceholder: 'Esim: Laske liuoksen pH, kun HCl-pitoisuus on 0,01 M',
      takePhoto: 'Ota kuva',
      uploadImage: 'Lataa kuva',
      solveButton: 'Ratkaise',
      
      
      // Video Status
      videoStatus: {
        creating: 'Luodaan videota...',
        queued: 'Video jonossa...',
        rendering: 'Video renderöidään...',
        ready: 'Video valmis!',
        failed: 'Videon luonti epäonnistui'
      },
      watchVideo: 'Katso video',
      
      // Next Steps
      nextSteps: 'Mitä haluaisit tehdä seuraavaksi?',
      
      // Actions
      actions: {
        createVideo: 'Luo opetusvideo',
        createVideoDesc: 'Animoitu askel-askeleelta selitys',
        
        moreProblems: 'Harjoitustehtäviä',
        moreProblemsDesc: 'Saa 3 samanlaista tehtävää',
        
        newProblem: 'Uusi tehtävä',
        newProblemDesc: 'Ratkaise toinen tehtävä',
        
        saveNotes: 'Tallenna muistiinpanoihin',
        saveNotesDesc: 'Lisää opiskelumuistiinpanoihin',
        
        explainConcept: 'Selitä käsite',
        explainConceptDesc: 'Opi teoria tämän takana',
        
        examTips: 'Tenttivinkk ejä',
        examTipsDesc: 'Yleisiä virheitä vältettäväksi'
      },
      
      // Similar Problems
      similarProblems: {
        title: 'Harjoitustehtävät',
        subtitle: 'Harjoittele näillä samankaltaisilla tehtävillä',
        solve: 'Ratkaise',
        difficulty: {
          easy: 'Helppo',
          medium: 'Keskivaikea',
          hard: 'Vaikea'
        }
      },
      
      // Errors
      errors: {
        emptyProblem: 'Kirjoita tai lataa tehtävä ensin',
        solveFailed: 'Ratkaisun luominen epäonnistui',
        networkError: 'Verkkovirhe. Tarkista yhteytesi.'
      },
      
      // PIXEL Welcome
		welcomeGreeting: 'Hei! Tervetuloa oppimaan 👋',
		welcomeReady: 'Autan sinua ratkaisemaan kemian, fysiikan ja matematiikan tehtäviä',
		welcomeFeature1: 'Selkeät askel askeleelta etenevät ratkaisut',
		welcomeFeature2: 'Animoidut selitykset vaikeisiin kohtiin',
		welcomeFeature3: 'Harjoittele samankaltaisilla tehtävillä',
		welcomeStart: 'Miten haluat aloittaa?',
		typeQuestion: 'Kirjoita kysymys',
		readyToHelp: 'Valmiina auttamaan',
		pixelAI: 'PIXEL',
		question: 'Kysymys',
		animatedExplanation: 'Animoitu selitys',
		videoStatusMessage: 'Tämä kestää yleensä 1–2 minuuttia',
		problemsGenerated: 'tehtävää luotu',
		analyzing: 'Pohditaan tehtävääsi…',
		analyzingDesc: 'Puretaan tehtävä vaihe vaiheelta',
		selectSubject: 'Valitse oppiaine',
		enterQuestion: 'Kirjoita kysymyksesi',
		questionPlaceholder: 'Kirjoita kemian, fysiikan tai matematiikan tehtävä tähän…',
		uploading: 'Ladataan tehtävää…',
		practiceReady: 'Harjoitukset ovat valmiina! 🎯',
		newChat: 'Uusi keskustelu',
		followUpPlaceholder: 'Kysy jatkokysymys…',
		chemistry: 'Kemia',
		physics: 'Fysiikka',
		mathematics: 'Matematiikka',
		suggestionSolve: 'Näytä askel askeleelta, miten tämä ratkaistaan',
		suggestionExplain: 'Selitä käsite, jota en ymmärrä',
		suggestionVideo: 'Luo animoitu videoselitys aiheesta',
		suggestionPractice: 'Anna harjoitustehtäviä, joilla kehityn',

    },

	pixel: {
      // Navigation
      aiTutor: 'AI-opettaja Pixel',
      backToDashboard: 'Takaisin hallintapaneeliin',
      
      // Welcome / Onboarding
      welcome: '👋 Hei, olen **Pixel**.',
      welcomeDesc: 'Olen täällä auttamassa sinua oppimaan tavalla, joka todella toimii.',
      
      // AnimLearn capabilities intro
      aboutAnimLearn: '**AnimLearn**-sovelluksella voin:',
      capability1: '📚 Selittää vaikeita konsepteja selkeästi',
      capability2: '🎥 Luoda opetusvideoita ymmärryksen tueksi',
      capability3: '🧠 Antaa harjoitustehtäviä',
      capability4: '🎯 Auttaa tenttimateriaalin kanssa',
      capability5: '💡 Tarjota eri syvyystasoja selityksille',
      
      readyMessage: 'Ennen kuin aloitamme, kerro minulle vähän itsestäsi 👇',
      
      // Onboarding questions
      onboarding: {
        step1Question: '📚 Mitä haluat opiskella juuri nyt?',
        step1Options: ['Matematiikka', 'Kemia', 'Fysiikka', 'Biologia', 'Tietotekniikka', 'Vain utelias'],
        
        step2Question: '🎓 Mikä kuvaa sinua parhaiten?',
        step2Options: ['Peruskouluoppilas', 'Lukiolainen', 'Yliopisto-opiskelija', 'Vapaa-ajan oppija'],
        
        step3Question: '🎯 Missä haluat Pixelin auttavan sinua eniten?',
        step3Options: [
          'Käsitteiden ymmärtäminen',
          'Tenttivalmistautuminen',
          'Visuaaliset selitykset',
          'Harjoitustehtävät',
          'Itseluottamuksen rakentaminen'
        ],
        
        processing: 'Asetan mieltymyksesi...',
        allSet: '✅ **Valmista!**',
        preferencesSet: 'Olen asettanut mieltymyksesi. Nyt voin auttaa sinua paremmin.',
        readyToHelp: 'Mitä haluat oppia tänään?',
      },
      
      // Chat interface
      chat: {
        placeholder: 'Kirjoita kysymyksesi tai liitä tehtävä...',
        askQuestion: 'Kysy kysymys',
        uploadImage: 'Lataa kuva',
        takePhoto: 'Ota kuva',
        analyzing: 'Analysoin kysymystäsi...',
        generating: 'Luon vastausta...',
      },
      
      // Action buttons (after answer)
      actions: {
        title: 'Mitä haluaisit tehdä seuraavaksi?',
        diveDeeper: '🔍 Sukella syvemmälle',
        practice: '🧠 Harjoitustehtäviä',
        similar: '🔄 Samanlainen kysymys',
        createVideo: '🎥 Luo opetusvideo',
        askNew: '❓ Kysy jotain muuta',
      },
      
      // Response templates
      responses: {
        dontUnderstand: 'Selvä, ei hätää — tämä hämmentää monia.',
        tryDifferent: 'Kokeillaan eri tapaa.',
        almostRight: 'Olet lähellä — ideasi on hyvä 👍',
        lookAtDetail: 'Katsotaan yhtä pientä yksityiskohtaa yhdessä.',
        pauseMoment: 'Pidetään tauko hetkeksi.',
        focusOne: 'Keskitytään vain yhteen ideaan.',
        whichHardest: 'Mikä osa tuntuu vaikeimmalta juuri nyt?',
        notInstant: 'Oppiminen ei ole heti ymmärtämistä — se on lopulta klikkausta.',
      },
      
      // Learning modes
      modes: {
        examMode: '🎓 Tenttitila',
        exploreMode: '🌱 Tutkimustila',
        examActive: '🎓 **Tenttitila päällä**\nPidän asiat keskitettyinä ja tenttiin liittyvinä.',
        exploreActive: '🌱 **Tutkimustila päällä**\nYmmärretään *miksi* tämä toimii.',
      },
      
      // Status messages
      status: {
        online: 'Verkossa',
        thinking: 'Ajattelen...',
        typing: 'Kirjoitan...',
      },
      
      // Error messages
      errors: {
        failedToLoad: 'Vastauksen lataaminen epäonnistui',
        tryAgain: 'Yritä uudelleen',
        networkError: 'Verkkovirhe. Tarkista yhteytesi.',
      },
    },

    // Authentication
    auth: {
      welcomeBack: 'Tervetuloa takaisin',
      signInToContinue: 'Kirjaudu sisään jatkaaksesi oppimista',
      createAccount: 'Luo tili',
      startLearning: 'Aloita oppiminen animaation avulla',
      continueWithGoogle: 'Jatka Googlella',
      signUpWithGoogle: 'Rekisteröidy Googlella',
      fullName: 'Koko nimi',
      email: 'Sähköposti',
      password: 'Salasana',
      confirmPassword: 'Vahvista salasana',
      signInButton: 'Kirjaudu sisään',
      signUpButton: 'Luo tili',
      signingIn: 'Kirjaudutaan sisään...',
      creatingAccount: 'Luodaan tiliä...',
      dontHaveAccount: 'Eikö sinulla ole tiliä?',
      alreadyHaveAccount: 'Onko sinulla jo tili?',
      passwordRequirements: 'Vähintään 8 merkkiä, isoja ja pieniä kirjaimia sekä numeroita',
      // Error messages
      passwordsNoMatch: 'Salasanat eivät täsmää',
      passwordTooShort: 'Salasanan on oltava vähintään 8 merkkiä',
      passwordRequirementsError: 'Salasanan tulee sisältää isoja ja pieniä kirjaimia sekä numeroita',
      googleSignInFailed: 'Google-kirjautuminen epäonnistui',
      googleSignUpFailed: 'Google-rekisteröityminen epäonnistui',
    },
	share: {
      title: 'Jaa Video',
      directLink: 'Suora Linkki',
      directLinkDesc: 'Jaa tämä linkki avataksesi video AnimLearnissa',
      embedCode: 'Upotuskoodi',
      embedDesc: 'Upota tämä video verkkosivullesi AnimLearn-brändäyksen kanssa',
      preview: 'Esikatselu',
      advancedOptions: 'Lisäasetukset',
      minimalEmbed: 'Minimaalinen upotus (ei alatunnistetta)',
      responsiveEmbed: 'Responsiivinen upotus (16:9)',
      feature1: 'Video toistuu missä tahansa',
      feature2: 'AnimLearn-brändäys mukana',
      feature3: 'Responsiivinen ja mobiiliystävällinen',
    },
	settings: {
      menuTitle: 'Asetukset',
      menuSubtitle: 'Profiili ja turvallisuus',
      title: 'Tiliasetukset',
      subtitle: 'Hallinnoi profiiliasi ja tiliäsi',
      back: 'Takaisin',
      memberSince: 'Jäsen alkaen',
      // Profile section
      profileSection: 'Profiili',
      fullName: 'Koko nimi',
      language: 'Kieli',
      saveChanges: 'Tallenna muutokset',
      saving: 'Tallennetaan...',
      saved: 'Tallennettu!',
      // Password section
      passwordSection: 'Vaihda salasana',
      currentPassword: 'Nykyinen salasana',
      newPassword: 'Uusi salasana',
      confirmPassword: 'Vahvista uusi salasana',
      updatePassword: 'Päivitä salasana',
      updating: 'Päivitetään...',
      passwordUpdated: 'Salasana päivitetty!',
      passwordMismatch: 'Salasanat eivät täsmää',
      passwordTooWeak: 'Vähintään 8 merkkiä: iso kirjain, pieni kirjain ja numero',
      googleAccount: 'Google-tili — salasanan vaihto ei ole käytettävissä',
      // Danger zone
      dangerZone: 'Vaarallinen alue',
      deleteAccount: 'Poista tili',
      deleteWarning: 'Tämä poistaa tilisi ja kaikki tietosi pysyvästi. Tätä toimintoa ei voi peruuttaa.',
      deleteConfirmLabel: 'Kirjoita DELETE vahvistaaksesi',
      deleteConfirmPlaceholder: 'Kirjoita DELETE tähän',
      deleteConfirmBtn: 'Poista tilini pysyvästi',
      deleting: 'Poistetaan...',
    },

	creditHistory: {
      // Menu
      menuTitle: 'Luottohistoria',
      menuSubtitle: 'Näytä tapahtumahistoria',
      
      // Modal header
      title: 'Luottohistoria',
      transactions: 'tapahtumaa',
      
      // Transaction types
      deduction: 'Videon generointi',
      reset: 'Päivittäinen nollaus',
      purchase: 'Krediittien osto',
      bonus: 'Bonuskrediitit',
      refund: 'Palautus',
      
      // Time formatting
      justNow: 'Juuri nyt',
      minsAgo: 'm sitten',
      hoursAgo: 'h sitten',
      daysAgo: 'pv sitten',
      
      // Labels
      balance: 'Saldo',
      page: 'Sivu',
      
      // Empty state
      noTransactions: 'Ei vielä tapahtumia',
      noTransactionsDesc: 'Luottotapahtumasi näkyvät täällä',
    },
	videoCard: {
      // Actions
      share: 'Jaa',
      delete: 'Poista',
      showInfo: 'Näytä tiedot',
      hideInfo: 'Piilota tiedot',
      viewFullDetails: 'Näytä kaikki tiedot',
	  transcript:'Lataa teksti',
      questionImage: 'Tehtäväkuva',
      viewQuestionImage: 'Näytä tehtäväkuva',
      makePublic: 'Julkaise galleriaan',
      makePrivate: 'Piilota galleriasta',
      public: 'Julkinen',
      
      // Labels
      language: 'Kieli',
      quality: 'Laatu',
      subject: 'Aine',
      created: 'Luotu',
      fileSize: 'Koko',
      duration: 'Kesto',
      prompt: 'Kehote',
      
      // Values
      untitled: 'Nimetön video',
      noSubject: 'Yleinen',
      unknown: 'Tuntematon',
      
      // Messages
      linkCopied: 'Videolinkki kopioitu leikepöydälle!',
      confirmDelete: 'Haluatko varmasti poistaa tämän videon?',
      deleteError: 'Videon poistaminen epäonnistui',
      noVideoSupport: 'Selaimesi ei tue videosoitinta.',
    },
	 publicGallery: {
      title: 'Yhteisögalleria',
      subtitle: 'Tutustu yhteisömme julkisiin luomuksiin',
      menuTitle: 'Yhteisögalleria',
      menuSubtitle: 'Tutustu julkisiin luomuksiin',
      publicVideos: 'julkista videota',
      allSubjects: 'Kaikki aineet',
      allLanguages: 'Kaikki kielet',
      mostRecent: 'Viimeisimmät',
      mostPopular: 'Suosituimmat',
      oldest: 'Vanhimmat ensin',
      page: 'Sivu',
      of: '/',
      previous: 'Edellinen',
      next: 'Seuraava',
      today: 'Tänään',
      yesterday: 'Eilen',
      daysAgo: 'päivää sitten',
      weeksAgo: 'viikkoa sitten',
      noVideos: 'Ei vielä julkisia videoita',
      noVideosDesc: 'Ole ensimmäinen luomaan ja jakamaan video!',
      searchPlaceholder: 'Hae videoita...',
      search: 'Hae',
      loading: 'Ladataan videoita...',
      video: 'video',
      videos: 'videota',
      general: 'Yleinen',
      questionImage: 'Tehtäväkuva',
	  creator: 'Luoja',
    uploaded: 'Ladattu',
    views: 'Katselukerrat',
    duration: 'Kesto',
    showDetails: 'Lisätiedot',
    hideDetails: 'Piilota',
    share: 'Jaa',
    },


    // Prompt Input / Video Generation
    prompt: {
		
		
		renderingVideo: "Renderöidään videota, odota hetki...",
		pleaseWait: "Tämä voi kestää hetken...",

      // Duration
		duration: 'Kesto',
		quick: 'Nopea',
		standard: 'Standardi',
		detailed: 'Yksityiskohtainen',
		comprehensive: 'Kattava',
		indepth: 'Syvällinen',
		
		// Settings
		quality: 'Laatu',
		fast: 'Nopea',
		recommended: 'Suositeltu',
		high: 'Korkea',
		best: 'Paras',
		
		aspectRatio: 'Kuvasuhde',
		landscape: 'Vaaka',
		vertical: 'Pysty',
		square: 'Neliö',
		portrait: 'Muotokuva',
		
		voiceoverLanguage: 'Puheäänitys',
		finnish: 'Suomi',
		english: 'Englanti',
		swedish: 'Ruotsi',
		
		estimatedRenderTime: 'Arvioitu renderöintiaika',
		
		// Tab titles and descriptions
		quickGenerateTitle: 'Nopea generointi',
		quickGenerateDesc: 'Välitön tekoälyvideon generointi - kuvaile mitä haluat animoida ja saa videosi sekunneissa',
		
		aiGenerateTitle: 'Tekoäly-generointi',
		aiGenerateDesc: 'Tarkastele ja muokkaa tekoälyn generoimaa koodia ennen videon renderöintiä',
		
		customCodeTitle: 'Oma koodi',
		customCodeDesc: 'Kirjoita oma Manim-koodisi täydellä hallinnalla animaation suhteen',
		
		// Form labels
		whatToAnimate: 'Mitä haluat animoida?',
		describeAnimation: 'Kuvaile animaatiosi',
		sceneName: 'Kohtauksen nimi',
		manimCode: 'Manim-koodi',
		generatedCode: 'Generoitu koodi',
		
		// Placeholders
		quickPlaceholder: 'Esimerkki: Selitä ionisidos natriumin ja kloorin välillä...',
		aiPlaceholder: 'Esimerkki: Luo animaatio, joka näyttää ionisidoksen...',
		codePlaceholder: 'from manim import *\nfrom manim_voiceover import VoiceoverScene\n...',
		
		// Buttons
		generateVideo: '🚀 Generoi video',
		generatingVideo: '🎬 Generoidaan videota...',
		generateCode: '✨ Generoi koodi',
		generatingCode: '⚙️ Generoidaan koodia...',
		renderVideo: '🎬 Renderöi video',
		rendering: '🎬 Renderöidään...',
		backToEdit: 'Takaisin muokkaukseen',
		
		// Examples
		tryExamples: 'Kokeile näitä esimerkkejä',
		exampleWater: 'Selitä vesimolekyylin rakenne',
		examplePH: 'Näytä pH-asteikko 0-14',
		exampleIonic: 'Näytä ionisidos',
		exampleCovalent: 'Selitä kovalenttinen sidos',
		exampleElectron: 'Näytä hapen elektronikonfiguraatio',
		
		// Status
		scene: 'Kohtaus',
		autoDetected: 'Automaattisesti tunnistettu',
		codeRequirement: 'Täytyy sisältää VoiceoverScene ja kaikki vaaditut importit',
		
		// Quota
		quotaReached: 'Päivittäinen videoraja saavutettu',
		videosRemaining: 'videota jäljellä tänään',
		generatedToday: 'Olet generoinut',
		videosToday: 'videota tänään',
		resetsAt: 'Nollautuu klo',
		
		// Service status
		serviceOffline: 'Renderöintipalvelu ei ole käytettävissä',
		
		// Errors
		generateVideoError: 'Videon generointi epäonnistui',
		generateCodeError: 'Koodin generointi epäonnistui',
		renderVideoError: 'Videon renderöinti epäonnistui',
    },

    // Video Details Modal
    videoDetails: {
      title: 'Videon tiedot',
      info: 'Tiedot',
      promptTab: 'Kehote',
      code: 'Koodi',
      sceneName: 'Kohtauksen nimi',
      status: 'Tila',
      quality: 'Laatu',
      language: 'Kieli',
      created: 'Luotu',
      fileSize: 'Tiedostokoko',
      duration: 'Kesto',
      errorMessage: 'Virheviesti',
      originalPrompt: 'Alkuperäinen kehote',
      manimCode: 'Manim-koodi',
      copyCode: 'Kopioi koodi',
      openVideo: 'Avaa video',
      loadingDetails: 'Ladataan tietoja...',
      videoNotFound: 'Videota ei löytynyt',
      failedToLoad: 'Tietojen lataus epäonnistui',
      copiedToClipboard: 'Kopioitu leikepöydälle!',
      // Status values
      pending: 'Odottaa',
      processing: 'Käsitellään',
      completed: 'Valmis',
      failed: 'Epäonnistui',
    },

    // HomePage
	
	// What We Do Section
    whatWeDo: 'Mitä AnimLearn tekee?',
    whatWeDoSubtitle: 'Muuta kokeeseen valmistautuminen PIXEL’s AI-pohjaisilla animoiduilla ratkaisuilla',
    
    uploadProblem: 'Lataa tehtäväsi',
    uploadProblemDesc: 'Ota kuva tai kirjoita kemia-, fysiikka- tai matematiikkatehtäväsi vanhoista ylioppilaskokeista',
    
    aiAnalyzes: 'PIXEL luo ratkaisun',
    aiAnalyzesDesc: 'AnimLearn tuottaa yksityiskohtaisen vaiheittaisen ratkaisun selkeillä selityksillä',
    
    watchAnimation: 'Katso animoitu video',
    watchAnimationDesc: 'Opi visuaalisesti ammattimaisilla animaatioilla ja äänellä suomeksi, ruotsiksi tai englanniksi',
    
    practiceSimilar: 'Harjoittele samanlaisia tehtäviä',
    practiceSimilarDesc: 'Luo variaatioita eri vaikeustasoilla käsitteen hallitsemiseksi',
    
    // Key Results
    result1: 'Täydellinen ylioppilaskokeisiin (YO-kirjoitukset)',
    result2: 'Vaiheittaiset ratkaisut, jotka ymmärrät',
    result3: 'Harjoittele AI:n luomilla samankaltaisilla tehtävillä',
    result4: 'Seuraa edistymistäsi ja tarkastele aiempia ratkaisuja',
    heroTitle: 'Opi visuaalisesti, ymmärrä syvällisesti',
    heroDescription: 'Luo upeita opetusanimaatioita kemiaan, fysiikkaan ja matematiikkaan. Täydellinen ylioppilaita valmistautuville opiskelijoille.',
	
	heroTrustStatement: 'AnimLearn on ilmainen oppimisen tukityökalu ylioppilaskokeisiin valmistautuville opiskelijoille. Käytä sitä yhdessä oppikirjojen ja opettajien kanssa.',
    
    // Transparency Section
    transparencyTitle: 'Mitä AnimLearn on - ja mitä se ei ole',
    transparencySubtitle: 'Olemme avoimia siitä, miten AnimLearn toimii ja mitkä ovat sen rajoitukset',
    whatWeAre: 'AnimLearn ON',
    whatWeAreNot: 'AnimLearn EI OLE',
    isItem1: 'Työkalu, joka visualisoi standardioppikirjojen ja kokeiden ratkaisuja',
    isItem2: 'Suunniteltu auttamaan opiskelijoita ymmärtämään miksi vaiheet tehdään',
    isItem3: 'Keskittynyt fysiikkaan, kemiaan ja matematiikkaan lukio/YO-tasolla',
    isItem4: 'Ilmainen oppimisen tukityökalu käytettäväksi oppikirjojen rinnalla',
    isNotItem1: 'Ei auktoritatiivinen vastausten tarkistaja',
    isNotItem2: 'Ei korvike opettajille tai oppikirjoille',
    isNotItem3: 'Ei taattu olemaan oikein jokaisessa tapauksessa',
    isNotItem4: 'Ei sovellu edistyneeseen kemialliseen synteesiin tai vaarallisiin menettelyihin',
    
    // AI Limitations Section
    aiLimitationsTitle: 'AI:n käyttö ja rajoitukset',
    aiLimitationsIntro: 'AnimLearn käyttää tekoälyä oppimisen tukemiseen. On tärkeää ymmärtää, miten ja milloin luottaa AI-generoituun sisältöön.',
    limitation1Title: 'Opetussuunnitelman mukainen sisältö',
    limitation1Desc: 'AI generoi selityksiä ja animaatioita perustuen standardiopetussuunnitelmiin, mutta se ei aina ole täydellinen',
    limitation2Title: 'Mahdolliset virheet',
    limitation2Desc: 'AI:n tuotteet voivat sisältää virheitä tai yksinkertaistuksia. Tarkista aina vastaukset oppikirjoista tai opettajalta',
    limitation3Title: 'Käsitteiden ymmärtämiseen',
    limitation3Desc: 'AnimLearn on tarkoitettu käsitteiden ymmärtämiseen, ei sokeaan suorittamiseen tai vastausten kopioimiseen',
    limitation4Title: 'Opettaja on tärkein',
    limitation4Desc: 'Käytä AnimLearnia täydentämään, ei korvaamaan, opettajien ohjausta ja virallisia materiaaleja',
    verificationReminder: '💡 Vahvista aina vastaukset oppikirjoilla, opettajilla tai virallisilla koemateriaalleilla ennen luottamista niihin kokeessa',
    
    // Curriculum Section
    curriculumTitle: 'Suomalaisen lukion opetussuunnitelman mukainen',
    curriculumSubtitle: 'Sisältö on suunniteltu tukemaan suomalaisten lukiolaisten oppimista ja YO-kokeiden valmistelua',
    yoExamPrep: 'YO-kokeisiin valmistautuminen',
    yoExamPrepDesc: 'Sisältö keskittyy ylioppilaskokeissa esiintyviin aiheisiin ja tehtävätyyppeihin',
    lukioAligned: 'Lukion opetussuunnitelman mukainen',
    lukioAlignedDesc: 'Aihealueet vastaavat suomalaisen lukion fysiikan, kemian ja matematiikan kursseja',
    standardTopics: 'Standardiaiheet ja teoria',
    standardTopicsDesc: 'Keskittyy teoriaan, visualisointiin ja koetyyppisen päättelyn ymmärtämiseen',
    
    // Safety Notice
    safetyTitle: 'Tärkeä turvallisuushuomautus (erityisesti kemiasta)',
    safetyDescription: 'AnimLearn EI tarjoa kokeellisia tai synteesi-ohjeita. Välttää laboratorio-tasoisia tai todellisia kemiallisia menettelyohjeita. Painottaa teoriaa, visualisointia ja koetyyppistä päättelyä. Älä koskaan yritä suorittaa kemiallisia kokeita AnimLearnin selitysten perusteella.',
    
    // Footer Disclaimer
    footerDisclaimerTitle: '📋 Tärkeä huomautus oppijoille',
    footerDisclaimerText: 'AnimLearn on oppimisen tukityökalu. AI-generoitu sisältö tulee aina varmistaa oppikirjoilla, opettajilla tai virallisilla opetussuunnitelmamateriaaleilla. Käytä AnimLearnia aktiiviseen oppimiseen, ei passiiviseen vastausten kopiointiin.',
	
    continueWithGoogle: 'Jatka Googlella',
    signUpWithEmail: 'Rekisteröidy sähköpostilla',
    goToDashboard: 'Siirry hallintapaneeliin',

    // Featured Section
    chemistry: 'Kemia',
    physics: 'Fysiikka',
    mathematics: 'Matematiikka',

    // Features
    whyAnimLearn: 'Miksi AnimLearn?',
    aiPowered: 'Tekoälyavusteinen generointi',
    aiPoweredDesc: 'Kuvaile käsitteesi ja tekoälymme luo kauniita animaatioita välittömästi',
    examFocused: 'Koelähtöinen sisältö',
    examFocusedDesc: 'Suomalaisen ylioppilaskokeen opetussuunnitelman mukainen',
    multiLanguage: 'Monikielinen tuki',
    multiLanguageDesc: 'Saatavilla suomeksi, englanniksi ja ruotsiksi',
    fastEasy: 'Nopea ja helppo',
    fastEasyDesc: 'Generoi opetusvideoita sekunneissa, ei tunneissa',
    downloadShare: 'Lataa ja jaa',
    downloadShareDesc: 'Vie videoita ja jaa luokkatovereiden kanssa',
    customizable: 'Muokattavissa',
    customizableDesc: 'Muokkaa koodia ja säädä animaatioita tarpeisiisi',

    // How It Works
    howItWorks: 'Miten se toimii',
    step1Title: 'Kuvaile käsitteesi',
    step1Desc: 'Kirjoita mitä haluat oppia: "Näytä vesimolekyylin muodostuminen"',
    step2Title: 'Tekoäly generoi animaation',
    step2Desc: 'Tekoälymme luo ammattimaisen opetusanimaation puheäänityksen kanssa',
    step3Title: 'Katso ja opi',
    step3Desc: 'Toista, lataa tai jaa henkilökohtainen oppimisvideoasi',

    // Subjects
    subjectsWeCover: 'Kattamamme aineet',
    chemistryTopics: {
      molecular: 'Molekyylirakenteet',
      reactions: 'Kemialliset reaktiot',
      ph: 'pH ja hapot/emäkset',
      electro: 'Sähkökemia',
    },
    physicsTopics: {
      motion: 'Liike ja voimat',
      energy: 'Energian muunnokset',
      waves: 'Aallot ja optiikka',
      electricity: 'Sähkö',
    },
    mathTopics: {
      functions: 'Funktiot ja graafit',
      geometry: 'Geometria',
      calculus: 'Analyysi',
      probability: 'Todennäköisyys',
    },

    // Meet the Team Section
    team: {
      title: 'Tutustu tiimiimme',
      subtitle: 'Rakennettu opettajien ja oppijoiden toimesta seuraavalle sukupolvelle suomalaisia opiskelijoita.',
      founder1Role: 'Yhteisperustaja & toimitusjohtaja',
      founder1Bio: 'Intohimoisesti tekemässä laadukkaasta STEM-koulutuksesta saavutettavaa tekoälyn ja animaation avulla. Uskoo, että jokainen opiskelija ansaitsee visualisoida monimutkaiset käsitteet selkeästi.',
      founder2Role: 'Yhteisperustaja & tuotejohtaja',
      founder2Bio: 'Itse opiskelijana Neha tuo aidon oppijan näkökulman AnimLearnin suunnitteluun. Hän varmistaa, että jokainen ominaisuus auttaa opiskelijoita valmistautumaan ylioppilaskokeisiin.',
      linkedIn: 'Ota yhteyttä LinkedInissä',
    },

    // CTA Section
    readyToLearn: 'Valmis oppimaan animaation avulla?',
    joinStudents: 'Liity suomalaisten opiskelijoiden joukkoon, jotka käyttävät AnimLearnia ylioppilaiden ässäämiseen',
    startLearningFree: 'Aloita oppiminen ilmaiseksi',

    // Footer
    learnWithAnimation: 'Opi animaation avulla',
    product: 'Tuote',
    features: 'Ominaisuudet',
    subjects: 'Aineet',
    support: 'Tuki',
    allRightsReserved: '2026 AnimLearn. Kaikki oikeudet pidätetään.',

    // All Videos Page
    allVideos: 'Kaikki videot',
    totalVideos: 'videota yhteensä',
    loadingVideos: 'Ladataan videoita...',
    noVideosYet: 'Ei vielä videoita',
    noVideosDesc: 'Luo ensimmäinen animaatiosi aloittaaksesi!',
    createVideo: 'Luo video',
    previous: 'Edellinen',
    next: 'Seuraava',
    failedToLoad: 'Videoiden lataus epäonnistui',

    // Pricing Plans
    pricing: {
      chooseYourPlan: 'Valitse suunnitelmasi',
      planSubtitle: 'Valitse täydellinen suunnitelma oppimismatkaasi varten',
      mostPopular: 'Suosituin',
      currentPlan: 'Nykyinen suunnitelma',
      getStarted: 'Aloita',
      choosePlan: 'Valitse suunnitelma',
      alreadyFree: 'Aina ilmainen',
      allPlansInclude: 'Kaikki suunnitelmat sisältävät pääsyn opetussisältökirjastoomme',
      cancelAnytime: 'Peruuta milloin tahansa. Ei piilotettuja maksuja.',
      perMonth: '/kk',
      free: 'Ilmainen',
      changePlan: 'Vaihda suunnitelma',
      selectNewPlan: 'Valitse uusi suunnitelma päivittääksesi tai alentaaksesi',
      changeNote: 'Muutokset tulevat voimaan välittömästi. Suhteellisia maksuja voidaan soveltaa.',

      // Credit system
      creditSystem: '1 krediitti = enintään 30 sekuntia videota',
      firstWeek: '1. viikko liittymisen jälkeen',
      creditsReset: 'Krediitit nollautuvat kuukausittain',
      whatsIncluded: 'Mitä sisältyy',
      bestFor: 'Parasta',
      credits: 'krediitit',
      oneTimePurchase: 'Kerta',

      // Free Plan
      freeTagline: 'Kokeile AnimLearnia perusominaisuuksilla',
      freeInitialCredits: '4 krediittiä (ensimmäiset 7 päivää)',
      freeOngoingCredits: '2 krediittiä päivässä',
      freeCreditsNote: '2 videota á 1 min päivässä ensimmäisen viikon, sen jälkeen 1 video päivässä',
      freeBest1: 'Ensikertaiset käyttäjät',
      freeBest2: 'Konsepteja testaavat opiskelijat',
      freeBest3: 'Nopeat esikatselut',

      // Hobby Plan
      hobbyTagline: 'Täydellinen yksityishenkilöille ja opettajille',
      hobbyMonthlyCredits: '200 krediittiä / kuukausi',
      hobbyDaily: 'Jopa 10 videota päivässä',
      hobbyBest1: 'Opettajat',
      hobbyBest2: 'YouTube-tekijät',
      hobbyBest3: 'Säännölliset sisällöntuottajat',

      // Pro Plan
      proTagline: 'Rakennettu tehokäyttäjille ja laitoksille',
      proMonthlyCredits: '800 krediittiä / kuukausi',
      proDaily: 'Jopa 50 videota päivässä',
      proBest1: 'Kurssien tekijät',
      proBest2: 'EdTech-yritykset',
      proBest3: 'Tiimit ja laitokset',

      // Buy Credits
      creditsPlan: 'Osta krediittejä',
      creditsTagline: 'Ei tilausta tarvita',
      creditExplanation: '1 krediitti = enintään 30 sekuntia videota',
      roundingNote: 'Krediitit pyöristetään ylöspäin videon pituuden mukaan',
      creditPacks: 'Krediittipaketteja',
      creditsNeverExpire: 'Krediitit eivät vanhene koskaan',
      creditsAnyPlan: 'Voidaan käyttää minkä tahansa suunnitelman kanssa',
      creditsOccasional: 'Ihanteellinen satunnaiseen käyttöön',

      // Important Notes
      importantNotes: 'Tärkeät huomautukset',
      longerVideosNote: 'Pidemmät videot käyttävät enemmän krediittejä.',
      monthlyResetNote: 'Kuukausittaiset tilauksen krediitit nollautuvat joka laskutusjakso.',
      oneTimeNote: 'Kertaostoksen krediittejä voi käyttää milloin tahansa.',
    },
    studio: {
      menuTitle: 'Oppimiskeskus',
      menuSubtitle: 'Kurssit, tehtävät ja harjoittelu',
      back: 'Takaisin',
      cancel: 'Peruuta',
      save: 'Tallenna',
      delete: 'Poista',
      edit: 'Muokkaa',
      publish: 'Julkaise',
      loading: 'Ladataan...',
      roleTitle: 'Mikä on roolisi?',
      roleTeacher: 'Opettaja',
      roleStudent: 'Opiskelija',
      roleTeacherDesc: 'Luo kursseja ja tehtäviä',
      roleStudentDesc: 'Liity kurssille ja harjoittele',
      teacher: {
        dashboard: 'Opettajan hallintapaneeli',
        myCourses: 'Omat kurssit',
        assignments: 'Tehtävät',
        classes: 'Luokat',
        analytics: 'Analytiikka',
        addCourse: 'Lisää kurssi',
        uploadSyllabus: 'Lähetä opetussuunnitelma',
        courseTitle: 'Kurssin nimi',
        courseDescription: 'Kuvaus',
        language: 'Kieli',
        uploadPdf: 'Lataa PDF',
        dragDrop: 'Vedä ja pudota PDF tähän, tai klikkaa valitaksesi',
        startCreating: 'Aloita luominen',
        extractConcepts: 'Poimi käsitteet',
        generateVideo: 'Luo video',
        generateQuestions: 'Luo kysymyksiä tekoälyllä',
        addQuestion: 'Lisää kysymys',
        approve: 'Hyväksy',
        approved: 'Hyväksytty',
        questionType: 'Kysymystyyppi',
        multipleChoice: 'Monivalinta',
        openEnded: 'Avoin kysymys',
        numeric: 'Numeerinen',
        questionText: 'Kysymysteksti',
        options: 'Vaihtoehdot',
        correctAnswer: 'Oikea vastaus',
        modelAnswer: 'Mallivastaus',
        rubric: 'Arviointikriteerit',
        difficulty: 'Vaikeustaso',
        bloomLevel: 'Bloomin taksonomiataso',
        createAssignment: 'Luo tehtävä',
        assignmentTitle: 'Tehtävän nimi',
        selectCourse: 'Valitse kurssi',
        selectQuestions: 'Valitse kysymykset',
        timeLimit: 'Aikaraja (minuuttia)',
        dueDate: 'Eräpäivä',
        showAnswers: 'Näytä vastaukset lähettämisen jälkeen',
        allowRetry: 'Salli uudelleenyrittäminen',
        inviteCode: 'Kutsukoodi',
        className: 'Luokan nimi',
        createClass: 'Luo luokka',
        copyCode: 'Kopioi koodi',
        students: 'Opiskelijat',
        submissionCount: 'Vastauksia',
        avgScore: 'Keskiarvo',
        exportCsv: 'Vie CSV',
        heatmap: 'Oppimiskartta',
        struggling: 'Vaikeuksia oppimisessa',
        processing: 'Käsitellään...',
        ready: 'Valmis',
        concepts: 'Käsitteet',
        selectConcept: 'Valitse käsite vasemmalta',
        reExtract: 'Pura uudelleen',
        clickExtract: 'Klikkaa "Poimi käsitteet" aloittaaksesi',
        processingWait: 'Odotetaan PDF-käsittelyä...',
        videoRendering: 'Video renderöidään...',
        questions: 'Kysymykset',
        noQuestionsYet: 'Ei vielä kysymyksiä. Luo tekoälyllä tai lisää manuaalisesti.',
        explanation: 'Selitys',
        generatedVideo: 'Luotu video',
        linkedVideos: 'Linkitetyt videot',
        pickVideo: 'Valitse video kirjastosta',
        noVideosInLibrary: 'Ei valmiita videoita kirjastossa',
        addFromLibrary: 'Lisää kirjastosta',
        addToConceptBtn: 'Lisää',
        editAssignment: 'Muokkaa tehtävää',
        assignmentType: 'Tyyppi',
        assignmentTypeAssignment: 'Tehtävä',
        assignmentTypeTest: 'Testi',
        noLimit: 'Ei rajaa',
        noApprovedQuestions: 'Ei hyväksyttyjä kysymyksiä. Hyväksy kysymyksiä kurssin editorissa ensin.',
        saveChanges: 'Tallenna muutokset',
        selected: 'valittu',
        results: 'Tulokset',
        student: 'Opiskelija',
        score: 'Pisteet',
        attempt: 'Yritys',
        timeCol: 'Aika',
        submittedAt: 'Lähetetty',
        viewDetails: 'Tiedot',
        hide: 'Piilota',
        aiFeedback: 'Tekoälypalaute',
        noSubmissionsYet: 'Ei vielä vastauksia',
        masteryHeatmap: 'Opiskelija × Käsite -osaaminen',
        noStudentsYet: 'Ei opiskelijoita vielä',
        strugglingStudents: 'Apua tarvitsevat opiskelijat',
        noAssignments: 'Ei tehtäviä vielä',
        createFirstAssignment: 'Luo ensimmäinen tehtäväsi hyväksytyistä kysymyksistä',
        dashboardTitle: 'Opettajan hallintapaneeli',
        submissions: 'Vastauksia',
        pending: 'Odottaa',
        editQuestion: 'Muokkaa kysymystä',
        cancel: 'Peruuta',
        saveQuestion: 'Tallenna kysymys',
        openCourse: 'Avaa kurssi',
        noCoursesTeacherTitle: 'Ei kursseja vielä',
        noCoursesTeacherDesc: 'Lataa opetussuunnitelma PDF luodaksesi ensimmäisen kurssin',
        statusReady: 'Valmis',
        statusProcessing: 'Käsitellään',
        statusError: 'Virhe',
        videoComprehension: 'Videon ymmärtämisarviot',
        reactionGotIt: 'Ymmärsin',
        reactionMostly: 'Melko hyvin',
        reactionNotQuite: 'Ei aivan',
        reactionLost: 'En ymmärtänyt',
        ratings: 'arvioita',
        rating: 'arvio',
        viewStudents: 'Opiskelijat',
        hideStudents: 'Piilota',
        noStudentsEnrolled: 'Ei opiskelijoita vielä. Jaa kutsukoodi yllä.',
        noClasses: 'Ei luokkia vielä',
        createClassDesc: 'Luo luokka ja jaa kutsukoodi opiskelijoille',
        studentName: 'Nimi',
        email: 'Sähköposti',
        enrolledAt: 'Liittynyt',
        published: 'Julkaistu',
        transcript: 'Käsikirjoitus',
        regenerate: 'Luo uudelleen',
        addAnotherVideo: 'Lisää toinen video',
        primaryVideo: 'Päävideo',
        additionalVideos: 'Lisävideot',
        renderingVideo: 'Video renderöidään… tämä kestää 1–2 minuuttia',
        noVideoYet: 'Ei videota vielä. Näin se toimii:',
        videoStep1: 'Tekoäly kirjoittaa käsikirjoituksen tästä käsitteestä',
        videoStep2: 'Lue, muokkaa tai säädä käsikirjoitusta',
        videoStep3: 'Klikkaa Luo — video renderöidään n. 1 minuutissa',
        previewTranscriptBtn: 'Esikatsele käsikirjoitusta ja luo video',
        starting: 'Aloitetaan…',
        reviewTranscript: 'Tarkista käsikirjoitus',
        aiWritingTranscript: 'Tekoäly kirjoittaa käsikirjoitusta…',
        editor: 'Muokkain',
        preview: 'Esikatselu',
        hidePreview: 'Piilota esikatselu',
        wordsMin: 'sanaa · ~{min} min video',
        selectTextHint: 'Valitse teksti → Paranna tekoälyllä · Aseta kursori → Lisää esimerkki',
        improveSelection: 'Paranna valintaa:',
        improvePlaceholder: 'esim. yksinkertaista oppilaille, laajenna lisätiedolla…',
        improving: 'Parannetaan…',
        improve: 'Paranna',
        addExampleAbout: 'Lisää esimerkki aiheesta:',
        adding: 'Lisätään…',
        add: 'Lisää',
        addExample: 'Lisää esimerkki',
        startingRender: 'Aloitetaan renderöinti…',
        unapprove: 'Peru hyväksyntä',
        extraVideoLabel: 'Mitä tämän videon tulisi erityisesti käsitellä?',
        extraVideoPlaceholder: 'esim. "Näytä laskettu esimerkki numeroilla"\n"Selitä kaavan johtaminen askel askeleelta"\n"Keskity yleisimpiin oppilaiden virheisiin"',
        extraVideoHint: 'Ole tarkka — tämä kertoo tekoälylle tarkalleen, mistä kulmasta lisävideo tehdään.',
        generating: 'Generoidaan…',
        scannedPdfWarning: 'Skannattu PDF havaittu. Tekstin poiminta saattaa olla epätäydellistä tai epätarkkaa. Parhaan tuloksen saamiseksi lataa tekstipohjainen (digitaalisesti luotu) PDF.',
        detectedLanguage: 'PDF:n kieli havaittu',
        detectedLanguageSuffix: 'Käsitteet poimitaan tällä kielellä.',
        pageRange: 'Sivut',
        pageFrom: 'Alku',
        pageTo: 'Loppu',
        exercises: 'Harjoitustehtävät',
        loadExercises: 'Lataa tehtävät',
        noExercises: 'Ei harjoitustehtäviä löydetty tälle käsitteelle opetussuunnitelmasta.',
        pageLabel: 's.',
        viewPdf: 'Näytä PDF',
        hidePdf: 'Piilota PDF',
        noPdfUploaded: 'Tälle kurssille ei ole ladattu opetussuunnitelman PDF-tiedostoa.',
        selectTextPrompt: 'Valitse tekstiä, jota haluat kysyä opetusassistentilta',
        selectRegionPrompt: 'Vedä valitaksesi kaavan tai kaavion',
        askTeachingAssistant: 'Kysy opetusassistentilta',
        chatPlaceholder: 'Kysy mitä tahansa kurssin opettamisesta — videot, tehtävät, opetusstrategiat.',
        starterTeach: 'Kuinka opetan tämän aiheen vaihe vaiheelta?',
        starterQuiz: 'Luo testi opiskelijoilleni',
        starterMisconceptions: 'Mitä väärinkäsityksiä opiskelijoilla on?',
        actionVideo: 'Luo video',
        actionTeach: 'Kuinka opetan tämän?',
        actionMisconceptions: 'Opiskelijoiden väärinkäsitykset',
        actionExamples: 'Esimerkkitehtävät',
        actionAssignment: 'Luo tehtävä',
        actionQuiz: 'Pikakysely',
        teachingAssistant: 'Opetusassistentti',
        askFollowUp: 'Kysy jatkokysymys…',
        saveDraft: 'Tallenna luonnoksiin',
        drafts: 'Luonnokset',
        noDrafts: 'Ei luonnoksia. Valitse teksti tai alue PDF:stä aloittaaksesi.',
        draftTypeVideo: 'Video',
        draftTypeTeach: 'Opetusmuistiinpanot',
        draftTypeMisconceptions: 'Väärinkäsitykset',
        draftTypeExamples: 'Esimerkit',
        draftTypeAssignment: 'Tehtävä',
        draftTypeQuiz: 'Kysely',
        assignToConcept: 'Liitä käsitteeseen',
        assigned: 'Liitetty',
        unassigned: 'Liittämätön',
        discard: 'Hylkää',
        addToConceptVideo: 'Lisää käsitteeseen',
        pushToAssignment: 'Vie tehtäväksi',
        pickConceptFirst: 'Valitse ensin käsite',
        creatingQuestions: 'Luodaan kysymyksiä…',
        questionsCreated: 'Kysymykset luotu!',
        videoQueued: 'Video jonossa',
        generatingVideo: 'Luodaan videota…',
        genQ: {
          title: 'Luo kysymyksiä tekoälyllä',
          questionTypes: 'Kysymystyypit',
          typeMultiple: 'Monivalinta',
          typeNumeric: 'Laskutehtävä',
          typeOpen: 'Avoin kysymys',
          typeTrueFalse: 'Tosi / Epätosi',
          count: 'Määrä',
          difficulty: 'Vaikeustaso',
          easy: 'Helppo',
          mixed: 'Vaihteleva',
          hard: 'Haastava',
          sampleLabel: 'Tyylinäyte',
          optional: 'valinnainen',
          samplePlaceholder: 'Liitä 1–2 omaa koekysymystäsi — tekoäly sovittaa tyylin, syvyyden ja muodon niihin…',
          generate: 'Luo kysymykset',
        },
        assignmentDetails: 'Tehtävän tiedot',
        assignmentTitlePlaceholder: 'esim. Luku 3 testi',
        assignTo: 'Osoita',
        allStudents: 'Kaikki',
        specificStudents: 'Tietyt opiskelijat',
        addStudents: 'Lisää opiskelijoita…',
        addMore: 'Lisää enemmän…',
        searchStudents: 'Hae nimellä tai sähköpostilla…',
        noStudentsMatch: 'Ei osumia haussa',
        allAdded: 'Kaikki opiskelijat jo lisätty',
        studentSingular: 'opiskelija',
        studentPlural: 'opiskelijaa',
        done: 'Valmis',
        attachments: 'Liitteet',
        addFile: 'Lisää tiedosto',
        uploading: 'Ladataan…',
        setIndefinite: 'Tyhjennä',
        available: 'saatavilla',
        enrolledWillReceive: 'ilmoittautunutta opiskelijaa saa tämän',
        selectAtLeastOne: 'Valitse vähintään yksi opiskelija',
        assignmentCreated: 'Tehtävä luotu',
        assignmentUpdated: 'Tehtävä päivitetty',
        assignmentPublished: 'Tehtävä julkaistu!',
        assignmentUnpublished: 'Tehtävä poistettu julkaisusta.',
        uncategorised: 'Luokittelematon',
        assignmentsCount: 'tehtävää',
        live: 'live',
        unpublish: 'Peru julkaisu',
        newClass: 'Uusi ryhmä',
        classNamePlaceholder: 'esim. Fysiikka 2025',
        course: 'Kurssi',
        classCreated: 'Ryhmä luotu!',
        codeCopied: 'Kutsukoodi kopioitu!',
        allStudentsBack: 'Kaikki opiskelijat',
        activityTab: 'Aktiviteetti',
        conversationsTab: 'Keskustelut',
        masteryTab: 'Osaaminen',
        aiChatsTab: 'Tekoälykeskustelut',
        noActivity: 'Ei vielä aktiviteettia.',
        submissionSingular: 'palautus',
        submissionPlural: 'palautusta',
        avgShort: 'ka',
        noMessages: 'Ei vielä viestejä.',
        msgShort: 'viesti',
        replyPlaceholder: 'Vastaa oppilaalle…',
        noMasteryData: 'Ei vielä osaamisdata.',
        attemptSingular: 'yritys',
        attemptPlural: 'yritystä',
        aiChatsDesc: 'Nämä ovat tekoälykeskusteluja, joita opiskelija kävi opiskellessaan kurssisisältöäsi.',
        noAiSessions: 'Ei vielä tekoälykeskusteluja.',
        aiLabel: 'Tekoäly',
        studentLabel: 'Opiskelija',
        noStudentsRoster: 'Ei opiskelijoita vielä',
        studentsEnrollNote: 'Opiskelijat näkyvät tässä kun he liittyvät luokkiisi.',
        newBadge: 'uusi',
        masteryLabel: 'Osaaminen',
        sessions: 'Istunnot',
        submittedCount: 'Lähetetty',
        practiceSessionsLabel: 'Harjoitteluistunnot',
      },
      upload: {
        title: 'Lataa opetussuunnitelma',
        courseTitle: 'Kurssin nimi',
        courseTitlePlaceholder: 'esim. Kemian perusteet',
        description: 'Kuvaus',
        descriptionPlaceholder: 'Valinnainen kuvaus kurssista',
        language: 'Kurssin kieli',
        dropZoneTitle: 'Vedä ja pudota opetussuunnitelma-PDF',
        dropZoneSubtitle: 'tai klikkaa selaa — vain PDF, maks. 20 Mt',
        startProcessing: 'Lataa ja käsittele opetussuunnitelma',
        processing: 'Käsitellään opetussuunnitelmaasi...',
        processingNote: 'Tämä voi kestää 1–3 minuuttia PDF:n koosta riippuen',
        pdfOnly: 'Lataa PDF-tiedosto',
        processingFailed: 'PDF-käsittely epäonnistui. Yritä ladata uudelleen.',
        timeout: 'Käsittely aikakatkaistiin. Yritä uudelleen.',
        selectFile: 'Valitse PDF-tiedosto',
        enterTitle: 'Anna kurssin nimi',
      },
      student: {
        dashboard: 'Opiskelijan hallintapaneeli',
        myCourses: 'Omat kurssit',
        joinCourse: 'Liity kurssille',
        enterCode: 'Syötä kutsukoodi',
        join: 'Liity',
        conceptRoadmap: 'Oppimispolku',
        watchVideo: 'Katso video',
        practice: 'Harjoittele',
        adaptivePractice: 'Mukautuva harjoittelu',
        adaptiveIntro: 'Tulosten perusteella tässä on kohdennettuja harjoitustehtäviä osaamisen vahvistamiseksi.',
        masteryScore: 'Hallintapistemäärä',
        assignments: 'Tehtävät',
        dueDate: 'Eräpäivä',
        submitted: 'Lähetetty',
        notStarted: 'Ei aloitettu',
        startAssignment: 'Aloita tehtävä',
        results: 'Tulokset',
        questions: 'Kysymykset',
        minutes: 'Minuuttia',
        question: 'K',
        previous: 'Edellinen',
        next: 'Seuraava',
        submit: 'Lähetä',
        submitting: 'Lähetetään...',
        confirmSubmitTitle: 'Lähetä tehtävä?',
        allAnswered: 'Kaikki kysymykset vastattu.',
        unanswered: 'kysymykseen ei vastattu.',
        excellent: 'Erinomaista!',
        goodJob: 'Hyvä työ!',
        keepPracticing2: 'Jatka harjoittelua!',
        tryAgain: 'Yritä uudelleen',
        questionBreakdown: 'Kysymyskohtainen palaute',
        masteryUpdated: 'Hallintapistemäärä päivitetty!',
        enterNumber: 'Kirjoita vastauksesi...',
        writeAnswer: 'Kirjoita vastauksesi tähän...',
        sessionNotFound: 'Istuntoa ei löydy. Aloita uusi harjoitteluistunto.',
        locked: 'Lukittu',
        prerequisiteHint: 'Suorita esivaatimuskäsitteet ensin',
        videoProgress: 'Videoedistyminen',
        keepPracticing: 'Jatka harjoittelua',
        dueSoon: 'Pian erääntyvät',
        completedAssignments: 'Tehdyt tehtävät',
        submittedOn: 'Palautettu',
        progress: 'Edistyminen',
        dashboardTitle: 'Oma Studio',
        enterInviteCode: 'Syötä opettajan antama 6-merkkinen kutsukoodi',
        joinBtn: 'Liity kurssille',
        invalidCode: 'Virheellinen kutsukoodi',
        welcome: 'Tervetuloa',
        welcomeDesc: 'Jatka opiskelua ja seuraa edistymistäsi alla',
        noCoursesTitle: 'Ei kursseja vielä',
        noCoursesDesc: 'Liity kurssille opettajan kutsukoodilla',
        overallProgress: 'Edistyminen',
        open: 'Avaa',
        joinAnotherCourse: 'Liity toiselle kurssille',
        courseProgress: 'Kurssin edistyminen',
        concept: 'Käsite',
        mastered: 'Hallittu',
        study: 'Opiskele',
        noConceptsYet: 'Opettaja valmistelee käsitteitä',
        due: 'Eräpäivä',
        stepWatch: 'Katso video',
        stepPractice: 'Harjoittele',
        stepAdaptive: 'Mukautuva',
        mastery: 'Osaaminen',
        watched: 'Katsottu',
        proceedToPractice: 'Siirry harjoitteluun',
        videoNotReady: 'Opettaja valmistelee videota',
        viewTranscript: 'Lue käsikirjoitus',
        transcript: 'Käsikirjoitus',
        transcriptLoading: 'Ladataan käsikirjoitusta…',
        transcriptNotAvailable: 'Käsikirjoitus ei ole vielä saatavilla tälle videolle.',
        noAssignments: 'Tälle kurssille ei ole julkaistu tehtäviä vielä',
        goToAdaptive: 'Mukautuva harjoittelu',
        adaptiveTitle: 'Mukautuva harjoittelu',
        adaptiveDesc: 'Tekoälyn luomat kysymykset kohdistetusti juuri sinun osaamisaukkosi vahvistamiseksi',
        currentMastery: 'Nykyinen osaaminen',
        startAdaptive: 'Aloita mukautuva harjoittelu',
        concepts: 'käsitettä',
        completeAssignmentFirst: 'Suorita tehtävä avataksesi mukautuvan harjoittelun',
        generating: 'Luodaan...',
        chatError: 'Vastauksen hakeminen epäonnistui',
        askPixelAbout: 'Kysy AnimLearn Tutorilta aiheesta',
        haveQuestion: 'Onko sinulla kysymys aiheesta',
        haveQuestionSuffix: '? Kysy mitä tahansa — tai kirjoita "testaa minut" harjoitellaksesi!',
        askAboutPlaceholder: 'Kysy aiheesta',
        start: 'Aloita',
        review: 'Tarkastele',
        howWellDidYouUnderstand: 'Kuinka hyvin ymmärsit?',
        communityRating: 'Yhteisön arvio',
        signInToRate: 'Kirjaudu arvostellaksesi',
        reactionGotIt: 'Ymmärsin',
        reactionMostly: 'Melko hyvin',
        reactionNotQuite: 'Ei aivan',
        reactionLost: 'En ymmärtänyt',
        quizTitle: 'Käsitetesti',
        quizSubtitle: 'Testaa osaamisesi ennen tehtäviä',
        noQuizQuestions: 'Opettaja ei ole vielä lisännyt harjoituskysymyksiä tähän käsitteeseen',
        quizSubmit: 'Tarkista vastaukseni',
        quizSubmitting: 'Tarkistetaan...',
        quizScore: 'Tuloksesi',
        quizMasteryUpdated: 'Osaaminen päivitetty',
        quizCorrect: 'Oikein',
        quizWrong: 'Väärin',
        quizFeedback: 'Palaute',
        quizModelAnswer: 'Mallivastaus',
        quizContinue: 'Jatka mukautuvaan harjoitteluun',
        quizRetry: 'Yritä uudelleen',
        quizAnswerPlaceholder: 'Kirjoita vastauksesi...',
        assignmentsSection: 'Opettajan tehtävät',
        assignmentsSectionToggle: 'näytä tehtävät',
        stepPracticeTab: 'Harjoittele',
        practiceStart: 'Aloita harjoittelu',
        practiceStartDesc: 'Tekoäly esittää sinulle 5 kysymystä yksi kerrallaan ja selittää virheet.',
        practiceQuestion: 'Kysymys',
        practiceOf: '/',
        practiceAnswerPlaceholder: 'Kirjoita vastauksesi...',
        practiceSubmit: 'Lähetä vastaus',
        practiceSubmitting: 'Tarkistetaan...',
        practiceCorrect: 'Oikein! ✓',
        practiceWrong: 'Ei aivan',
        practiceNext: 'Seuraava kysymys',
        practiceStop: 'Lopeta harjoittelu',
        practiceFinish: 'Viimeistele',
        practiceDoneTitle: 'Harjoittelu valmis!',
        practiceScore: 'Tuloksesi',
        practiceMastery: 'Osaaminen päivitetty',
        practiceGoAssignments: 'Siirry tehtäviin',
        practiceTryAgain: 'Harjoittele uudelleen',
        startTutor: 'Aloita tutor',
        goToAssignments: 'Siirry tehtäviin',
        flaggedQuestions: 'Merkitty tarkistettavaksi',
        autoFlagged: 'Automaattisesti merkitty (väärä vastaus)',
        unflagRevision: 'Poista merkintä',
        flaggedForRevision: 'Merkitty tarkistettavaksi',
        askTeacher: 'Kysy opettajalta',
        askTeacherEmpty: 'Ei vielä viestejä. Kysy opettajalta mitä tahansa tästä käsitteestä.',
        askTeacherPlaceholder: 'Kirjoita kysymyksesi...',
        aiNotice: 'Opettajasi voi tarkistaa tekoälyopettajan kanssa käymäsi keskustelut laadun ja asianmukaisen käytön varmistamiseksi.',
        teacherFeedback: 'Opettajan palaute',
        dismiss: 'Sulje',
        studySpace: 'Opiskelutila',
        history: 'Historia',
        uploadPdf: 'Lataa PDF',
        uploadPdfDesc: 'Lataa opiskelumateriaali ja tekoäly luo siitä oppimiskäsitteet',
        processing: 'Käsitellään...',
        ready: 'Valmis',
        studyNow: 'Aloita opiskelu',
        noStudySets: 'Ei vielä opiskelumateriaaleja',
        noStudySetsDesc: 'Lataa PDF-tiedosto aloittaaksesi',
        noHistory: 'Ei istuntoja vielä',
        noHistoryDesc: 'Aloita keskustelu Pixel AI:n kanssa nähdäksesi historian täällä',
        knowledgeLevel: 'Tietotaso',
        beginner: 'Aloittelija',
        intermediate: 'Keskitaso',
        advanced: 'Edistynyt',
        levelSaved: 'Taso tallennettu!',
        studySetLabel: 'Opiskelusetti',
        backToSets: 'Takaisin opiskelusetit',
        extractingConcepts: 'Poimitaan käsitteitä...',
        conceptsReady: 'Käsitteet valmiit!',
        deleteSet: 'Poista',
        uploadingPdf: 'Ladataan...',
        newStudySet: 'Uusi opiskelusetti',
        studySetTitle: 'Opiskelusetin nimi',
        conceptsTab: 'Käsitteet',
        readTab: 'Lue',
        selectTextPrompt: 'Valitse tekstiä PDF:stä kysyäksesi Pixel AI:lta',
        selectRegionPrompt: 'Vedä hiirellä valitaksesi kaavan tai diagrammin',
        capturedRegion: 'Otettu alue',
        askAboutSelection: 'Kysy tästä',
        readingSession: 'Lukuistunto',
        pdfTruncated: 'PDF on liian pitkä – näytetään enimmäistulos (60 sivua / 60 000 merkkiä)',
        pdfTooLarge: 'PDF on liian suuri. Enimmäiskoko on 25 MB.',
        noTextContent: 'Tekstiä ei saatavilla tästä PDF:stä',
        passageLabel: 'Valittu teksti',
        viewHistory: 'Näytä historia',
        closeTranscript: 'Sulje',
        msgCount: 'viestiä',
        askFollowUp: 'Kysy jatkokysymys…',
        continueChat: 'Jatka keskustelua',
        tutorBannerText: 'Saat rikkaampia selityksiä, videoita ja täyden historian AnimLearn Tutor -näkymässä.',
        openInTutor: 'Avaa Tutorissa',
      },
    },
    homepage: {
      nav: {
        forWho: 'Kenelle',
        howItWorks: 'Miten toimii',
        features: 'Ominaisuudet',
        seeItLive: 'Katso demo',
        team: 'Tiimi',
        getStarted: 'Aloita',
      },
      hero: {
        badge: 'Tekoälypohjainen oppimisalusta',
        titleLine1: 'Jossa opettajat',
        titleBuild: 'Rakentavat',
        titleLine2: 'opiskelijat',
        titleMaster: 'Hallitsevat',
        titleLoggedIn: 'Jossa oppiminen herää eloon',
        subtitle: 'Lataa opetussuunnitelmasi, luo tekoälyllä animoituja videooppitunteja, anna mukautuvia harjoituksia — kaikki yhdellä modernille luokalle rakennetulla alustalla.',
        pill1: '📚 Opetussuunnitelman mukainen',
        pill2: '🎬 Tekoälyvideot',
        pill3: '🧠 Mukautuva harjoittelu',
        pill4: '🌍 3 kieltä',
        googleBtn: 'Jatka Googlella',
        startBtn: 'Aloita ilmaiseksi',
        playSound: 'Toista äänellä',
        watchDemo: 'Katso demo',
      },
      stats: {
        subjects: 'Ainetta katettu',
        videos: 'Tekoälyvideot',
        problems: 'Mukautuvat tehtävät',
        languages: 'Kieltä',
        analytics: 'Reaaliaikainen analytiikka',
      },
      forWho: {
        titleNormal: 'Rakennettu',
        titleHighlight: 'jokaiselle luokkahuoneen roolille',
        subtitle: 'Olit sitten opettaja tai opiskelija, AnimLearnissa on sinulle oma työtila',
        teacherTitle: 'Opettajille',
        teacherDesc: 'Rakenna jäsenneltyjä kursseja opetussuunnitelmastasi minuuteissa',
        teacherF1: 'Lataa opetussuunnitelma PDF — tekoäly poimii käsitteet automaattisesti',
        teacherF2: 'Luo animoituja videooppitunteja jokaiselle käsitteelle',
        teacherF3: 'Luo tehtäviä tekoälyn tuottamilla kysymyspankeilla',
        teacherF4: 'Seuraa oppilaiden osaamista reaaliaikaisella analytiikalla',
        teacherF5: 'Näe ymmärryksen luokittelu per video (vihreä/keltainen/punainen)',
        teacherCta: 'Aloita opettaminen',
        studentTitle: 'Opiskelijoille',
        studentDesc: 'Opi videoiden kautta, harjoittele tekoälyn kanssa, hallitse jokainen käsite',
        studentF1: 'Ilmoittaudu opettajan luomille kursseille yksinkertaisella koodilla',
        studentF2: 'Katso tekoälyn animoimia oppitunteja omassa tahdissasi',
        studentF3: 'Harjoittele mukautuvilla tekoälytehtävillä tasoosi sopivasti',
        studentF4: 'Suorita tehtävät ja saa välitön tekoälypalaute',
        studentF5: 'Kysy AnimLearn Tutorilta mitä tahansa käsitteestä — milloin tahansa',
        studentCta: 'Aloita oppiminen',
      },
      hiw: {
        subtitle: 'Opetussuunnitelmasta hallintaan — täydellinen oppimismatka',
        step1Title: 'Opettaja lataa opetussuunnitelman',
        step1Desc: 'Lataa PDF ja tekoäly poimii automaattisesti käsitteet, rakentaa kurssirakennetta ja ehdottaa videoita.',
        step2Title: 'Tekoäly luo videooppitunnit',
        step2Desc: 'Jokainen käsite saa ammattimaisen animoidun videon puheäänityksellä — automaattisesti tai opettajan tarkistamana.',
        step3Title: 'Opiskelijat oppivat ja harjoittelevat',
        step3Desc: 'Opiskelijat ilmoittautuvat, katsovat videoita ja saavat tekoälyn mukautuvia harjoitustehtäviä.',
        step4Title: 'Seuraa ja kehity',
        step4Desc: 'Opettajat näkevät osaamistasoheatmapit, videoreaktiot ja tehtäväpisteet. Opiskelijat näkevät edistymisensä.',
      },
      teacherFeatures: {
        label: '🎓 Opettajille',
        titlePart1: 'Kaikki mitä tarvitset',
        titlePart2: 'täydellisen kurssin rakentamiseen',
        subtitle: 'Opetussuunnitelmasta oppilaiden analytiikkaan — kaikki yhdessä paikassa',
        f1Title: 'Opetussuunnitelman tuonti',
        f1Desc: 'Lataa mikä tahansa PDF-opetussuunnitelma. Tekoäly lukee, poimii käsitteet ja rakentaa kurssirakennetta.',
        f2Title: 'Tekoälyvideot',
        f2Desc: 'Jokainen käsite saa animoidun Manim-videon puheäänityksellä. Esikatsele transkriptit ennen luontia.',
        f3Title: 'Kysymyspankki ja tehtävät',
        f3Desc: 'Tekoäly luo kysymyksiä Bloomin taksonomian tasoilla. Rakenna ajastettuja tehtäviä luokille.',
        f4Title: 'Oppilaiden analytiikka',
        f4Desc: 'Osaamistasoheatmapit, ymmärrysreaktiot, tehtäväpisteet, kamppailevien oppilaiden hälytykset.',
        f5Title: 'Luokkaryhmät',
        f5Desc: 'Luo oppilasryhmiä kutsukoodeilla. Jokainen ryhmä pääsee kurssin sisältöön ja tehtäviin.',
        f6Title: 'Monikielinen',
        f6Desc: 'Luo videoita englanniksi, suomeksi tai ruotsiksi. Tavoita jokainen opiskelija heidän kielellään.',
      },
      studentFeatures: {
        label: '📖 Opiskelijoille',
        titlePart1: 'Opi tavalla,',
        titlePart2: 'josta aivosi pitävät',
        subtitle: 'Visuaalinen, interaktiivinen ja mukautuva — oppiminen, joka todella jää mieleen',
        f1Title: 'Katso ja ymmärrä',
        f1Desc: 'Animoidut käsitevideot puheäänityksellä selittävät monimutkaiset aiheet askel askeleelta.',
        f2Title: 'AnimLearn Tutor',
        f2Desc: 'Keskustele AnimLearn Tutorin kanssa mistä tahansa käsitteestä. Lataa kuvia, kysy jatkokysymyksiä.',
        f3Title: 'Mukautuva harjoittelu',
        f3Desc: 'Tehtävät mukautuvat osaamistasosi mukaan. Vaikeutuvat kehittyessäsi, helpottuvat tarvittaessa.',
        f4Title: 'Opettajan tehtävät',
        f4Desc: 'Suorita opettajan asettamat ajastetut tehtävät. Saa välitön tekoälypalaute jokaiseen vastaukseen.',
        f5Title: 'Osaamisen seuranta',
        f5Desc: 'Näe edistymisesi käsitteittäin — nouseva, tasainen tai kehitystä vaativa. Tiedä mihin keskittyä.',
        f6Title: 'Arvioi ymmärryksesi',
        f6Desc: 'Jokaisen videon jälkeen napauta hymiötä kertoaksesi opettajallesi kuinka hyvin ymmärsit.',
        masteryTitle: 'Osaamisesi',
        masteryTopics: ['Fotosyntees', 'Solunjako', 'Genetiikka', 'Evoluutio'],
        reactionLabel: 'Kuinka hyvin ymmärsit videon?',
        adaptiveTitle: 'Mukautuva harjoittelu',
        adaptiveQuestion: 'Mikä on klorofyllin rooli fotosynteesissa?',
        adaptiveOptions: ['Absorboi valoa', 'Varastoi glukoosia', 'Kuljettaa vettä', 'Tuottaa happea'],
      },
      pixelAcademy: {
        badge: '🏫 Kouluille ja oppilaitoksille',
        title: 'Esittelyssä',
        brand: 'Learning Hub',
        desc: 'Omistettu oppimisympäristö opettaja–opiskelija-suhteille. Opettajat rakentavat kursseja, opiskelijat ilmoittautuvat — kaikki koulusi brändätyssä tilassa.',
        f1: 'Kurssien ja opetussuunnitelman hallinta',
        f2: 'Luokkaryhmät ja ilmoittautuminen',
        f3: 'Koulun laajuinen analytiikka',
        f4: 'Opetussuunnitelman mukainen sisältö',
        cta: 'Siirry Oppimiskeskukseen',
      },
      subjects: {
        title: '3 ainetta,',
        titleHighlight: 'loputtomasti käsitteitä',
        subtitle: 'Kattaa koko opetussuunnitelman lukiosta yliopistotasolle',
        biology: 'Biologia',
        economics: 'Taloustiede',
        bioT1: 'Solubiologia', bioT2: 'Genetiikka', bioT3: 'Evoluutio', bioT4: 'Ekologia',
        ecoT1: 'Mikrotaloustiede', ecoT2: 'Makrotaloustiede', ecoT3: 'Markkinat', ecoT4: 'Rahoitus',
      },
      cta: {
        badge: 'Liity tuhansien oppijoiden joukkoon',
        title: 'Valmis muuttamaan tapasi opettaa ja oppia?',
        subtitle: 'Aloita ilmaiseksi. Ei luottokorttia tarvita.',
        googleBtn: 'Rekisteröidy Googlella',
        primaryBtn: 'Aloita ilmaiseksi',
      },
      footer: {
        tagline: 'Tekoälyllä animoitu oppiminen jokaiselle luokkahuoneelle.',
        product: 'Tuote',
        support: 'Tuki',
        legal: 'Oikeudellinen',
        privacyPolicy: 'Tietosuojakäytäntö',
        termsOfService: 'Käyttöehdot',
        copyright: '© 2026 AnimLearn. Kaikki oikeudet pidätetään.',
        company: 'nordX Labs Oy',
        businessId: 'Y-tunnus: 3615236-4',
      },
    },
  },

  sv: {
    // Common
    loading: 'Laddar...',
    error: 'Fel',
    retry: 'Försök igen',
    back: 'Tillbaka',
    logout: 'Logga ut',
    signIn: 'Logga in',
    signUp: 'Registrera dig',
    dashboard: 'Instrumentpanel',
    close: 'Stäng',
    copy: 'Kopiera',
    or: 'eller',

    // Header/Navigation
    myVideos: 'Mina videor',

    // Dashboard
    createAnimation: 'Skapa animation',
    createAnimationDesc: 'Generera utbildningsvideor för kemi, fysik och matematik',
    recentVideos: 'Senaste videor',
    recentVideosDesc: 'Dina senaste skapelser',
    viewAllVideos: 'Visa alla videor',
    backToDashboard: 'Tillbaka till instrumentpanelen',
	
	// Dashboard subtitle update
    dashboardSubtitle: 'Innehållsskapare',
    
    // PIXEL AI Section
    pixelAI: {
      title: 'AnimLearn Tutor',
      subtitle: 'Din AI-drivna handledare för problemlösning och lärande',
      menuTitle: 'AnimLearn Tutor',
      menuSubtitle: 'AI-handledare och problemlösare',
      solverTitle: 'Fråga PIXEL',
      solverSubtitle: 'Ladda upp ett problem eller ställ en fråga för att få steg-för-steg-lösningar',
      historyTitle: 'Senaste frågorna',
      historySubtitle: 'Granska dina tidigare interaktioner med AnimLearn Tutor',
	  transparencyText: 'AnimLearn Tutor hjälper med lärande och problemlösning. Verifiera alltid lösningar med läroböcker, lärare eller officiella material innan du litar på dem i prov.',
    },
	
	contentCreator: {
      title: 'Innehållsskapare',
      subtitle: 'Skapa utbildningsvideor med AI-drivna animationer för kemi, fysik och matematik',
      menuTitle: 'Innehållsskapare',
      menuSubtitle: 'Skapa animerade videor',
      
      // Feature badges
      feature1: 'Animerade förklaringar',
      feature2: 'Flerspråkigt stöd',
      feature3: 'Snabb generering',
      
      // Responsibility notice
      responsibilityTitle: 'Skapa med noggrannhet och ansvar',
      responsibilityText: 'Kvaliteten på din video beror på noggrannheten i din input. Ge korrekta lösningar och förklaringar. Vår AI hjälper med visualisering och animation, men du är ansvarig för att utbildningsinnehållet är korrekt. Elever och lärare förlitar sig på din omsorg.',
      point1: 'Verifiera dina lösningar innan du genererar',
      point2: 'Dubbelkolla formler och beräkningar',
      point3: 'Granska genererat innehåll för noggrannhet',
	  privacyWarning: '⚠️ Mata aldrig in personlig information (namn, hälsodata, konfidentiell information) i systemet, särskilt för elever under 18 år.',
      
      copyrightNotice: 'Upphovsrätt: Du behåller äganderätten till genererade videor och kan dela dem fritt för utbildningsändamål.',
      
      contentSafety: 'Innehållssäkerhet: Allt genererat innehåll övervakas för ålderslämplighet. Granska dock videor innan du delar dem med elever.',
      
      matricExamFocus: '🎓 Optimerad för finska, svenska och engelska studentexamen',
      
      point4: 'Mata aldrig in personlig eller konfidentiell information',
      point5: 'Du äger upphovsrätten - dela fritt för utbildning',
    },
	
	// Featured Videos Section
    featuredVideos: {
      title: 'Utvalda utbildningsvideor',
      subtitle: 'Upptäck fantastiskt utbildningsinnehåll skapat med AnimLearn',
      loading: 'Laddar utvalda videor...',
      transcript: 'Transkription',
      communityGallery: {
        title: 'Upptäck fler fantastiska skapelser',
        description: 'Bläddra bland hundratals utbildningsanimationer som skapats av vår gemenskap',
        button: 'Utforska gemenskapsgalleriet'
      },
      language: {
        fi: 'Finska',
        en: 'Engelska',
        sv: 'Svenska'
      }
    },
	
	questionHistory: {
	  title: 'Frågehistorik',
	  subtitle: 'Granska dina tidigare frågor och lösningar',
	  backToProblemSolver: 'Tillbaka',
	  downloadAll: 'Ladda ner alla',
	  
	  // Filters
	  subject: 'Ämne',
	  allSubjects: 'Alla ämnen',
	  chemistry: 'Kemi',
	  physics: 'Fysik',
	  mathematics: 'Matematik',
	  timeRange: 'Tidsperiod',
	  last7Days: 'Senaste 7 dagarna',
	  last30Days: 'Senaste 30 dagarna',
	  last90Days: 'Senaste 90 dagarna',
	  lastYear: 'Senaste året',
	  
	  // Question items
	  question: 'Fråga',
	  solution: 'Lösning',
	  video: 'Utbildningsvideo',
	  transcript: 'Textformat',
	  
	  // Actions
	  solveAgain: 'Lös igen',
	  generateVideo: 'Skapa video',
	  generatePractice: 'Skapa övningsuppgifter',
	  viewPracticeProblems: 'Visa övningsuppgifter',
	  generatingVideo: 'Skapar video...',
	  generatingPractice: 'Skapar övningsuppgifter...',
	  
	  // Status
	  noQuestions: 'Inga frågor än',
	  noQuestionsDesc: 'Börja med att lösa ditt första problem',
	  loading: 'Laddar historik...',

	  // Chat Sessions tab
	  chatSessions: 'Chattsessioner',
	  loadingSessions: 'Laddar sessioner...',
	  noSessions: 'Inga chattsessioner än. Starta en konversation i AnimLearn Tutor!',
	  openPixelAI: 'Öppna AnimLearn Tutor',
	  untitledSession: 'Namnlös session',
	  messagesCount: 'meddelanden',
	  resume: 'Fortsätt',
	  videoSolution: 'Videolösning',
	  downloadPDF: 'Ladda ner PDF',
	  generating: 'Skapar...',
	  viewPractice: 'Visa övningsuppgifter',
	  startSolving: 'Börja lösa',
	  timePeriod: 'Tidsperiod',
	  practice: 'Övningsuppgifter',
	},

	modal: {
    solveProblem: 'Övningsuppgift',
    problem: 'Problem',
    showHint: 'Visa tips',
    hideHint: 'Dölj tips',
    yourSolution: 'Din lösning',
    writeSolution: 'Skriv din lösning här...\n\nDu kan använda LaTeX: $x^2 + 5x + 6 = 0$',
    checkYourAnswer: 'Fick du rätt?',
    correct: 'Rätt',
    incorrect: 'Fel',
    showSolution: 'Visa fullständig lösning',
    hideSolution: 'Dölj lösning',
    showAnswer: 'Visa svar',
    hideAnswer: 'Dölj svar',
    modelAnswer: 'Modellsvar',
    gradingCriteria: 'Bedömningskriterier',
    completeSolution: 'Fullständig lösning',
    cancel: 'Stäng',
    skipToNext: 'Hoppa över',
    submitSolution: 'Skicka in',
    submitted: 'Inskickad ✓',
    greatJob: 'Bra jobbat! Lösning inskickad.',
    keepPracticing: 'Fortsätt öva! Lösning registrerad.',
    movingToNext: 'Går vidare till nästa problem...',
    previousProblem: 'Föregående problem',
    nextProblem: 'Nästa problem'
  },

	videoLanguageModal: {
      title: 'Välj lösningsspråk',
      subtitle: 'Välj språk för lösningen',
      finnish: 'Finska',
      swedish: 'Svenska',
      english: 'Engelska',
      infoText: 'Lösningen kommer att skapas på det valda språket.',
      cancel: 'Avbryt',
      solveProblem: 'Lös problem'
    },
	
	problemSolver: {
		title: 'AI Problemlösare',
	  subtitle: 'Lös uppgifter i kemi, fysik och matematik med PIXEL',
	  backToDashboard: 'Instrumentpanel',
	  history: 'Historik',
	  
	  subjects: {
		chemistry: 'Kemi',
		physics: 'Fysik',
		mathematics: 'Matematik'
	  },
	  
	  enterProblem: 'Vilket problem kan jag hjälpa dig att lösa?',
	  problemPlaceholder: 'Skriv ditt problem här...\n\nExempel: Beräkna pH för en 0,1M HCl-lösning\n\nDu kan också använda LaTeX: $x^2 + 5x + 6 = 0$',
	  upload: 'Ladda upp',
	  camera: 'Kamera',
	  solve: 'Lös problem',
	  solving: 'Löser...',
	  
	  yourQuestion: 'Din fråga',
	  solution: 'Steg-för-steg lösning',
	  educationalVideo: 'Utbildningsvideo',
	  newProblem: 'Nytt problem',
	  
	  createVideo: 'Skapa video',
	  createVideoDesc: 'Generera animerad förklaring',
	  generatePractice: 'Skapa övning',
	  generatePracticeDesc: 'Få liknande problem',
	  viewHistory: 'Visa historik',
	  viewHistoryDesc: 'Se alla tidigare frågor',
	  videoReady: 'Video klar!',
	  videoReadyDesc: 'Titta ovan eller ladda ner',
	  generatingVideo: 'Skapar din utbildningsvideo...',
	  generatingPractice: 'Genererar...',
	  generatingPracticeDesc: 'Skapar övningsuppgifter',
	  creatingVideo: 'Skapar video...',
	  videoFailed: 'Videoskapande misslyckades',
	  
	  practiceProblems: 'Övningsuppgifter',
	  practiceSubtitle: 'Bemästra detta ämne med liknande problem',
	  solveProblem: 'Lös detta',
      
      
      // Input
      inputLabel: 'Klistra in eller skriv ditt problem:',
      inputPlaceholder: 'T.ex: Beräkna pH när HCl-koncentrationen är 0,01 M',
      takePhoto: 'Ta foto',
      uploadImage: 'Ladda upp bild',
      solveButton: 'Lös',      
      
      // Video Status
      videoStatus: {
        creating: 'Skapar video...',
        queued: 'Video i kö...',
        rendering: 'Video renderas...',
        ready: 'Video klar!',
        failed: 'Videoskapande misslyckades'
      },
      watchVideo: 'Titta på video',
      
      // Next Steps
      nextSteps: 'Vad vill du göra härnäst?',
      
      // Actions
      actions: {
        createVideo: 'Skapa utbildningsvideo',
        createVideoDesc: 'Animerad steg-för-steg förklaring',
        
        moreProblems: 'Övningsproblem',
        moreProblemsDesc: 'Få 3 liknande problem',
        
        newProblem: 'Nytt problem',
        newProblemDesc: 'Lös ett annat problem',
        
        saveNotes: 'Spara till anteckningar',
        saveNotesDesc: 'Lägg till i studieanteckningar',
        
        explainConcept: 'Förklara koncept',
        explainConceptDesc: 'Lär dig teorin bakom detta',
        
        examTips: 'Tentamenstips',
        examTipsDesc: 'Vanliga misstag att undvika'
      },
      
      // Similar Problems
      similarProblems: {
        title: 'Övningsproblem',
        subtitle: 'Öva med dessa liknande problem',
        solve: 'Lös',
        difficulty: {
          easy: 'Lätt',
          medium: 'Medel',
          hard: 'Svår'
        }
      },
      
      // Errors
      errors: {
        emptyProblem: 'Skriv eller ladda upp ett problem först',
        solveFailed: 'Kunde inte skapa lösning',
        networkError: 'Nätverksfel. Kontrollera din anslutning.'
      },
      
      // Pixel AI Welcome
		welcomeGreeting: 'Hej! Välkommen 👋',
		welcomeReady: 'Jag hjälper dig att lösa uppgifter i kemi, fysik och matematik',
		welcomeFeature1: 'Tydliga steg-för-steg-lösningar',
		welcomeFeature2: 'Animerade förklaringar som gör det lättare att förstå',
		welcomeFeature3: 'Öva med liknande uppgifter',
		welcomeStart: 'Hur vill du börja?',
		typeQuestion: 'Skriv en fråga',
		readyToHelp: 'Redo att hjälpa',
		pixelAI: 'PIXEL',
		question: 'Fråga',
		animatedExplanation: 'Animerad förklaring',
		videoStatusMessage: 'Detta tar vanligtvis 1–2 minuter',
		problemsGenerated: 'uppgifter skapade',
		analyzing: 'Analyserar din uppgift…',
		analyzingDesc: 'Bryter ner problemet steg för steg',
		selectSubject: 'Välj ämne',
		enterQuestion: 'Skriv din fråga',
		questionPlaceholder: 'Skriv din uppgift i kemi, fysik eller matematik här…',
		uploading: 'Laddar upp din uppgift…',
		practiceReady: 'Övningarna är redo! 🎯',
		newChat: 'Ny chatt',
		followUpPlaceholder: 'Ställ en följdfråga…',
		chemistry: 'Kemi',
		physics: 'Fysik',
		mathematics: 'Matematik',
		suggestionSolve: 'Visa mig hur man löser ett problem steg för steg',
		suggestionExplain: 'Förklara ett begrepp jag har svårt med',
		suggestionVideo: 'Skapa en animerad videoförklaring',
		suggestionPractice: 'Ge mig övningsuppgifter för att bygga självförtroende',

    },

	pixel: {
      // Navigation
      aiTutor: 'AI-lärare Pixel',
      backToDashboard: 'Tillbaka till instrumentpanelen',
      
      // Welcome / Onboarding
      welcome: '👋 Hej, jag är **Pixel**.',
      welcomeDesc: 'Jag är här för att hjälpa dig lära dig på ett sätt som faktiskt fungerar.',
      
      // AnimLearn capabilities intro
      aboutAnimLearn: 'Med **AnimLearn**-appen kan jag:',
      capability1: '📚 Förklara svåra koncept tydligt',
      capability2: '🎥 Skapa utbildningsvideor för bättre förståelse',
      capability3: '🧠 Ge övningsuppgifter',
      capability4: '🎯 Hjälpa till med tentamensförberedelser',
      capability5: '💡 Erbjuda olika djupnivåer i förklaringar',
      
      readyMessage: 'Innan vi börjar, berätta lite om dig 👇',
      
      // Onboarding questions
      onboarding: {
        step1Question: '📚 Vad vill du studera just nu?',
        step1Options: ['Matematik', 'Kemi', 'Fysik', 'Biologi', 'Datavetenskap', 'Bara nyfiken'],
        
        step2Question: '🎓 Vad beskriver dig bäst?',
        step2Options: ['Grundskoleelev', 'Gymnasieelev', 'Universitets student', 'Fritidsstudent'],
        
        step3Question: '🎯 Vad vill du att Pixel ska hjälpa dig med mest?',
        step3Options: [
          'Förstå koncept',
          'Tentamensförberedelse',
          'Visuella förklaringar',
          'Övningsuppgifter',
          'Självförtroende'
        ],
        
        processing: 'Ställer in dina preferenser...',
        allSet: '✅ **Klart!**',
        preferencesSet: 'Jag har ställt in dina preferenser. Nu kan jag hjälpa dig bättre.',
        readyToHelp: 'Vad vill du lära dig idag?',
      },
      
      // Chat interface
      chat: {
        placeholder: 'Skriv din fråga eller klistra in uppgiften...',
        askQuestion: 'Ställ en fråga',
        uploadImage: 'Ladda upp bild',
        takePhoto: 'Ta foto',
        analyzing: 'Analyserar din fråga...',
        generating: 'Skapar svar...',
      },
      
      // Action buttons (after answer)
      actions: {
        title: 'Vad vill du göra härnäst?',
        diveDeeper: '🔍 Fördjupa dig',
        practice: '🧠 Övningsuppgifter',
        similar: '🔄 Liknande fråga',
        createVideo: '🎥 Skapa utbildningsvideo',
        askNew: '❓ Fråga något annat',
      },
      
      // Response templates
      responses: {
        dontUnderstand: 'Det är helt okej — detta förvirrar många.',
        tryDifferent: 'Låt oss prova ett annat sätt.',
        almostRight: 'Du är nära — din idé är bra 👍',
        lookAtDetail: 'Låt oss titta på en liten detalj tillsammans.',
        pauseMoment: 'Låt oss pausa ett ögonblick.',
        focusOne: 'Vi fokuserar på bara en idé.',
        whichHardest: 'Vilken del känns svårast just nu?',
        notInstant: 'Lärande handlar inte om att förstå direkt — det handlar om att få det att klicka till slut.',
      },
      
      // Learning modes
      modes: {
        examMode: '🎓 Tentamensläge',
        exploreMode: '🌱 Utforskningsläge',
        examActive: '🎓 **Tentamensläge på**\nJag håller saker fokuserade och tentamensrelevanta.',
        exploreActive: '🌱 **Utforskningsläge på**\nLåt oss förstå *varför* detta fungerar.',
      },
      
      // Status messages
      status: {
        online: 'Online',
        thinking: 'Tänker...',
        typing: 'Skriver...',
      },
      
      // Error messages
      errors: {
        failedToLoad: 'Kunde inte ladda svar',
        tryAgain: 'Försök igen',
        networkError: 'Nätverksfel. Kontrollera din anslutning.',
      },
    },

    // Authentication
    auth: {
      welcomeBack: 'Välkommen tillbaka',
      signInToContinue: 'Logga in för att fortsätta lära',
      createAccount: 'Skapa konto',
      startLearning: 'Börja lära med animation',
      continueWithGoogle: 'Fortsätt med Google',
      signUpWithGoogle: 'Registrera dig med Google',
      fullName: 'Fullständigt namn',
      email: 'E-post',
      password: 'Lösenord',
      confirmPassword: 'Bekräfta lösenord',
      signInButton: 'Logga in',
      signUpButton: 'Skapa konto',
      signingIn: 'Loggar in...',
      creatingAccount: 'Skapar konto...',
      dontHaveAccount: 'Har du inget konto?',
      alreadyHaveAccount: 'Har du redan ett konto?',
      passwordRequirements: 'Minst 8 tecken med stora och små bokstäver och siffror',
      // Error messages
      passwordsNoMatch: 'Lösenorden matchar inte',
      passwordTooShort: 'Lösenordet måste vara minst 8 tecken',
      passwordRequirementsError: 'Lösenordet måste innehålla stora och små bokstäver samt siffror',
      googleSignInFailed: 'Google-inloggning misslyckades',
      googleSignUpFailed: 'Google-registrering misslyckades',
    },
	
	settings: {
      menuTitle: 'Inställningar',
      menuSubtitle: 'Profil och säkerhet',
      title: 'Kontoinställningar',
      subtitle: 'Hantera din profil och ditt konto',
      back: 'Tillbaka',
      memberSince: 'Medlem sedan',
      // Profile section
      profileSection: 'Profil',
      fullName: 'Fullt namn',
      language: 'Språk',
      saveChanges: 'Spara ändringar',
      saving: 'Sparar...',
      saved: 'Sparat!',
      // Password section
      passwordSection: 'Byt lösenord',
      currentPassword: 'Nuvarande lösenord',
      newPassword: 'Nytt lösenord',
      confirmPassword: 'Bekräfta nytt lösenord',
      updatePassword: 'Uppdatera lösenord',
      updating: 'Uppdaterar...',
      passwordUpdated: 'Lösenord uppdaterat!',
      passwordMismatch: 'Lösenorden matchar inte',
      passwordTooWeak: 'Minst 8 tecken: stor bokstav, liten bokstav och siffra',
      googleAccount: 'Google-konto — lösenordsbyte ej tillgängligt',
      // Danger zone
      dangerZone: 'Farozon',
      deleteAccount: 'Ta bort konto',
      deleteWarning: 'Detta raderar permanent ditt konto och all din data. Åtgärden kan inte ångras.',
      deleteConfirmLabel: 'Skriv DELETE för att bekräfta',
      deleteConfirmPlaceholder: 'Skriv DELETE här',
      deleteConfirmBtn: 'Ta bort mitt konto permanent',
      deleting: 'Tar bort...',
    },

	creditHistory: {
      // Menu
      menuTitle: 'Kredithistorik',
      menuSubtitle: 'Visa transaktionshistorik',
      
      // Modal header
      title: 'Kredithistorik',
      transactions: 'transaktioner',
      
      // Transaction types
      deduction: 'Videogenerering',
      reset: 'Daglig återställning',
      purchase: 'Kreditköp',
      bonus: 'Bonuskrediter',
      refund: 'Återbetalning',
      
      // Time formatting
      justNow: 'Just nu',
      minsAgo: 'm sedan',
      hoursAgo: 't sedan',
      daysAgo: 'd sedan',
      
      // Labels
      balance: 'Saldo',
      page: 'Sida',
      
      // Empty state
      noTransactions: 'Inga transaktioner ännu',
      noTransactionsDesc: 'Dina kredittransaktioner visas här',
    },

	publicGallery: {
      title: 'Gemenskapsgalleri',
      subtitle: 'Utforska offentliga skapelser från vår gemenskap',
      menuTitle: 'Gemenskapsgalleri',
      menuSubtitle: 'Utforska offentliga skapelser',
      publicVideos: 'offentliga videor',
      allSubjects: 'Alla ämnen',
      allLanguages: 'Alla språk',
      mostRecent: 'Senaste',
      mostPopular: 'Mest populära',
      oldest: 'Äldsta först',
      page: 'Sida',
      of: 'av',
      previous: 'Föregående',
      next: 'Nästa',
      today: 'Idag',
      yesterday: 'Igår',
      daysAgo: 'dagar sedan',
      weeksAgo: 'veckor sedan',
      noVideos: 'Inga offentliga videor ännu',
      noVideosDesc: 'Var den första att skapa och dela en video!',
      searchPlaceholder: 'Sök videor...',
      search: 'Sök',
      loading: 'Laddar videor...',
      video: 'video',
      videos: 'videor',
      general: 'Allmänt',
      questionImage: 'Uppgiftsbild',
	  creator: 'Skapare',
    uploaded: 'Uppladdad',
    views: 'Visningar',
    duration: 'Varaktighet',
    showDetails: 'Detaljer',
    hideDetails: 'Dölj',
    share: 'Dela',
    },
	videoCard: {
      // Actions
      share: 'Dela',
      delete: 'Ta bort',
      showInfo: 'Visa info',
      hideInfo: 'Dölj info',
      viewFullDetails: 'Visa alla detaljer',
	  transcript:'Ladda ner text',
      questionImage: 'Uppgiftsbild',
      viewQuestionImage: 'Visa uppgiftsbild',
      makePublic: 'Publicera i galleriet',
      makePrivate: 'Dölj från galleriet',
      public: 'Offentlig',
      
      // Labels
      language: 'Språk',
      quality: 'Kvalitet',
      subject: 'Ämne',
      created: 'Skapad',
      fileSize: 'Storlek',
      duration: 'Längd',
      prompt: 'Prompt',
      
      // Values
      untitled: 'Namnlös video',
      noSubject: 'Allmänt',
      unknown: 'Okänd',
      
      // Messages
      linkCopied: 'Videolänk kopierad till urklipp!',
      confirmDelete: 'Är du säker på att du vill ta bort denna video?',
      deleteError: 'Misslyckades ta bort video',
      noVideoSupport: 'Din webbläsare stöder inte videouppspelning.',
    },
	share: {
      title: 'Dela Video',
      directLink: 'Direkt Länk',
      directLinkDesc: 'Dela denna länk för att visa videon på AnimLearn',
      embedCode: 'Inbäddningskod',
      embedDesc: 'Bädda in denna video på din webbplats med AnimLearn-varumärke',
      preview: 'Förhandsvisning',
      advancedOptions: 'Avancerade Alternativ',
      minimalEmbed: 'Minimal Inbäddning (Ingen Sidfot)',
      responsiveEmbed: 'Responsiv Inbäddning (16:9)',
      feature1: 'Video spelas var som helst',
      feature2: 'AnimLearn-varumärke inkluderat',
      feature3: 'Responsiv och mobilvänlig',
    },
    // Prompt Input / Video Generation
    prompt: {		
		
		renderingVideo: "Renderar video, vänta...",
		pleaseWait: "Detta kan ta en stund...",
		
        // Duration
		duration: 'Varaktighet',
		quick: 'Snabb',
		standard: 'Standard',
		detailed: 'Detaljerad',
		comprehensive: 'Omfattande',
		indepth: 'Djupgående',
		
		// Settings
		quality: 'Kvalitet',
		fast: 'Snabb',
		recommended: 'Rekommenderad',
		high: 'Hög',
		best: 'Bäst',
		
		aspectRatio: 'Bildförhållande',
		landscape: 'Landskap',
		vertical: 'Vertikal',
		square: 'Kvadrat',
		portrait: 'Porträtt',
		
		voiceoverLanguage: 'Röstöver',
		finnish: 'Finska',
		english: 'Engelska',
		swedish: 'Svenska',
		
		estimatedRenderTime: 'Uppskattad renderingstid',
		
		// Tab titles and descriptions
		quickGenerateTitle: 'Snabb generering',
		quickGenerateDesc: 'Omedelbar AI-videogenerering - beskriv vad du vill animera och få din video på sekunder',
		
		aiGenerateTitle: 'AI-generering',
		aiGenerateDesc: 'Granska och redigera den AI-genererade koden innan du renderar din video',
		
		customCodeTitle: 'Anpassad kod',
		customCodeDesc: 'Skriv din egen Manim-kod med full kontroll över animationen',
		
		// Form labels
		whatToAnimate: 'Vad vill du animera?',
		describeAnimation: 'Beskriv din animation',
		sceneName: 'Scennamn',
		manimCode: 'Manim-kod',
		generatedCode: 'Genererad kod',
		
		// Placeholders
		quickPlaceholder: 'Exempel: Förklara jonbindning mellan natrium och klor...',
		aiPlaceholder: 'Exempel: Skapa en animation som visar jonbindning...',
		codePlaceholder: 'from manim import *\nfrom manim_voiceover import VoiceoverScene\n...',
		
		// Buttons
		generateVideo: '🚀 Generera video',
		generatingVideo: '🎬 Genererar video...',
		generateCode: '✨ Generera kod',
		generatingCode: '⚙️ Genererar kod...',
		renderVideo: '🎬 Rendera video',
		rendering: '🎬 Renderar...',
		backToEdit: 'Tillbaka till redigering',
		
		// Examples
		tryExamples: 'Prova dessa exempel',
		exampleWater: 'Förklara vattenmolekylens struktur',
		examplePH: 'Visa pH-skalan från 0 till 14',
		exampleIonic: 'Demonstrera jonbindning',
		exampleCovalent: 'Förklara kovalent bindning',
		exampleElectron: 'Visa elektronkonfiguration för syre',
		
		// Status
		scene: 'Scen',
		autoDetected: 'Automatiskt upptäckt',
		codeRequirement: 'Måste inkludera VoiceoverScene och alla nödvändiga importer',
		
		// Quota
		quotaReached: 'Daglig videogräns nådd',
		videosRemaining: 'video(r) kvar idag',
		generatedToday: 'Du har genererat',
		videosToday: 'videor idag',
		resetsAt: 'Återställs kl',
		
		// Service status
		serviceOffline: 'Renderingstjänsten är offline',
		
		// Errors
		generateVideoError: 'Misslyckades generera video',
		generateCodeError: 'Misslyckades generera kod',
		renderVideoError: 'Misslyckades rendera video',
    },

    // Video Details Modal
    videoDetails: {
      title: 'Videodetaljer',
      info: 'Info',
      promptTab: 'Prompt',
      code: 'Kod',
      sceneName: 'Scennamn',
      status: 'Status',
      quality: 'Kvalitet',
      language: 'Språk',
      created: 'Skapad',
      fileSize: 'Filstorlek',
      duration: 'Varaktighet',
      errorMessage: 'Felmeddelande',
      originalPrompt: 'Ursprunglig prompt',
      manimCode: 'Manim-kod',
      copyCode: 'Kopiera kod',
      openVideo: 'Öppna video',
      loadingDetails: 'Laddar detaljer...',
      videoNotFound: 'Video hittades inte',
      failedToLoad: 'Misslyckades att ladda detaljer',
      copiedToClipboard: 'Kopierat till urklipp!',
      // Status values
      pending: 'Väntande',
      processing: 'Bearbetas',
      completed: 'Klar',
      failed: 'Misslyckades',
    },

    // HomePage
	
	// What We Do Section
    whatWeDo: 'Vad gör AnimLearn?',
    whatWeDoSubtitle: 'Förvandla din examensförberedelse med PIXEL’s AI-drivna animerade lösningar',
    
    uploadProblem: 'Ladda upp ditt problem',
    uploadProblemDesc: 'Ta ett foto eller skriv din kemi-, fysik- eller matematikfråga från tidigare studentexamina',
    
    aiAnalyzes: 'PIXEL skapar lösning',
    aiAnalyzesDesc: 'AnilLearn genererar en detaljerad steg-för-steg-lösning med tydliga förklaringar',
    
    watchAnimation: 'Titta på animerad video',
    watchAnimationDesc: 'Lär dig visuellt med professionella animationer och röst på finska, svenska eller engelska',
    
    practiceSimilar: 'Öva liknande problem',
    practiceSimilarDesc: 'Generera variationer på olika svårighetsnivåer för att bemästra konceptet',
    
    // Key Results
    result1: 'Perfekt för studentexamen (YO-skrivningar)',
    result2: 'Steg-för-steg-lösningar du kan förstå',
    result3: 'Öva med AI-genererade liknande problem',
    result4: 'Spåra dina framsteg och granska tidigare lösningar',
	
    heroTitle: 'Lär dig visuellt, förstå djupt',
    heroDescription: 'Skapa fantastiska utbildningsanimationer för kemi, fysik och matematik. Perfekt för studenter som förbereder sig för studentexamen.',
	
	heroTrustStatement: 'AnimLearn är ett gratis lärandestödverktyg för studenter som förbereder sig för studentexamen. Använd det tillsammans med läroböcker och lärare.',
    
    // Transparency Section
    transparencyTitle: 'Vad AnimLearn är - och vad det inte är',
    transparencySubtitle: 'Vi är öppna om hur AnimLearn fungerar och vilka dess begränsningar är',
    whatWeAre: 'AnimLearn ÄR',
    whatWeAreNot: 'AnimLearn ÄR INTE',
    isItem1: 'Ett verktyg som visualiserar standardläroböckers och examens lösningar',
    isItem2: 'Utformat för att hjälpa studenter förstå varför stegen tas',
    isItem3: 'Fokuserat på fysik, kemi och matematik på gymnasie/studentexamensnivå',
    isItem4: 'Ett gratis lärandestödverktyg att använda tillsammans med läroböcker',
    isNotItem1: 'Inte en auktoritativ svarskontrollant',
    isNotItem2: 'Inte en ersättning för lärare eller läroböcker',
    isNotItem3: 'Inte garanterat att vara korrekt i varje fall',
    isNotItem4: 'Inte lämplig för avancerad kemisk syntes eller farliga förfaranden',
    
    // AI Limitations Section
    aiLimitationsTitle: 'AI-användning och begränsningar',
    aiLimitationsIntro: 'AnimLearn använder AI för att stödja lärande. Det är viktigt att förstå hur och när man ska lita på AI-genererat innehåll.',
    limitation1Title: 'Läroplansenligt innehåll',
    limitation1Desc: 'AI genererar förklaringar och animationer baserade på standardläroplaner, men det är inte alltid perfekt',
    limitation2Title: 'Möjliga fel',
    limitation2Desc: 'AI-utdata kan innehålla fel eller förenklingar. Kontrollera alltid svar med läroböcker eller lärare',
    limitation3Title: 'För begreppsförståelse',
    limitation3Desc: 'AnimLearn är avsett för begreppsförståelse, inte blind exekvering eller kopiering av svar',
    limitation4Title: 'Läraren är viktigast',
    limitation4Desc: 'Använd AnimLearn för att komplettera, inte ersätta, lärarvägledning och officiella material',
    verificationReminder: '💡 Verifiera alltid svar med läroböcker, lärare eller officiella examensmaterial innan du litar på dem i en tenta',
    
    // Curriculum Section
    curriculumTitle: 'I linje med finsk gymnasielä roplan',
    curriculumSubtitle: 'Innehållet är utformat för att stödja finska gymnasieelevers lärande och förberedelse för studentexamen',
    yoExamPrep: 'Förberedelse för studentexamen',
    yoExamPrepDesc: 'Innehållet fokuserar på ämnen och problemtyper som förekommer i studentexamen',
    lukioAligned: 'Gymnasieläroplansanpassad',
    lukioAlignedDesc: 'Ämnesområden motsvarar finska gymnasiets fysik-, kemi- och matematikkurser',
    standardTopics: 'Standardämnen och teori',
    standardTopicsDesc: 'Fokuserar på teori, visualisering och förståelse av examensstilsresonemang',
    
    // Safety Notice
    safetyTitle: 'Viktig säkerhetsanmärkning (särskilt om kemi)',
    safetyDescription: 'AnimLearn tillhandahåller INTE experimentella eller syntesinstruktioner. Undviker laboratorienivå eller verkliga kemiska procedurguider. Betonar teori, visualisering och examensstilsresonemang. Försök aldrig utföra kemiska experiment baserat på AnimLearns förklaringar.',
    
    // Footer Disclaimer
    footerDisclaimerTitle: '📋 Viktig anmärkning för elever',
    footerDisclaimerText: 'AnimLearn är ett lärandestödverktyg. AI-genererat innehåll bör alltid verifieras med läroböcker, lärare eller officiella läroplansmaterial. Använd AnimLearn för aktivt lärande, inte passiv kopiering av svar.',
	
    continueWithGoogle: 'Fortsätt med Google',
    signUpWithEmail: 'Registrera dig med e-post',
    goToDashboard: 'Gå till instrumentpanelen',

    // Featured Section
    chemistry: 'Kemi',
    physics: 'Fysik',
    mathematics: 'Matematik',

    // Features
    whyAnimLearn: 'Varför AnimLearn?',
    aiPowered: 'AI-driven generering',
    aiPoweredDesc: 'Beskriv ditt koncept och vår AI skapar vackra animationer omedelbart',
    examFocused: 'Examensfokuserat innehåll',
    examFocusedDesc: 'Anpassat till finsk studentexamens läroplan',
    multiLanguage: 'Flerspråkigt stöd',
    multiLanguageDesc: 'Tillgängligt på finska, engelska och svenska',
    fastEasy: 'Snabbt och enkelt',
    fastEasyDesc: 'Generera utbildningsvideor på sekunder, inte timmar',
    downloadShare: 'Ladda ner och dela',
    downloadShareDesc: 'Exportera videor och dela med klasskamrater',
    customizable: 'Anpassningsbar',
    customizableDesc: 'Redigera kod och justera animationer efter dina behov',

    // How It Works
    howItWorks: 'Hur det fungerar',
    step1Title: 'Beskriv ditt koncept',
    step1Desc: 'Skriv vad du vill lära dig: "Visa vattenmolekylbildning"',
    step2Title: 'AI genererar animation',
    step2Desc: 'Vår AI skapar professionell utbildningsanimation med röstöver',
    step3Title: 'Titta och lär',
    step3Desc: 'Spela, ladda ner eller dela din personliga inlärningsvideo',

    // Subjects
    subjectsWeCover: 'Ämnen vi täcker',
    chemistryTopics: {
      molecular: 'Molekylära strukturer',
      reactions: 'Kemiska reaktioner',
      ph: 'pH och syror/baser',
      electro: 'Elektrokemi',
    },
    physicsTopics: {
      motion: 'Rörelse och krafter',
      energy: 'Energitransformationer',
      waves: 'Vågor och optik',
      electricity: 'Elektricitet',
    },
    mathTopics: {
      functions: 'Funktioner och grafer',
      geometry: 'Geometri',
      calculus: 'Kalkyl',
      probability: 'Sannolikhet',
    },

    // Meet the Team Section
    team: {
      title: 'Möt vårt team',
      subtitle: 'Byggt av lärare och elever för nästa generation finska studenter.',
      founder1Role: 'Medgrundare & VD',
      founder1Bio: 'Passionerat engagerad i att göra kvalitativ STEM-utbildning tillgänglig genom kraften hos AI och animation. Tror att varje student förtjänar att visualisera komplexa begrepp tydligt.',
      founder2Role: 'Medgrundare & produktchef',
      founder2Bio: 'Som student själv tillför Neha ett autentiskt elevperspektiv till AnimLearns design. Hon säkerställer att varje funktion verkligen hjälper elever att förbereda sig för studentexamen.',
      linkedIn: 'Anslut på LinkedIn',
    },

    // CTA Section
    readyToLearn: 'Redo att lära med animation?',
    joinStudents: 'Gå med studenter över hela Finland som använder AnimLearn för att klara sina examina',
    startLearningFree: 'Börja lära gratis',

    // Footer
    learnWithAnimation: 'Lär med animation',
    product: 'Produkt',
    features: 'Funktioner',
    subjects: 'Ämnen',
    support: 'Support',
    allRightsReserved: '2026 AnimLearn. Alla rättigheter förbehållna.',

    // All Videos Page
    allVideos: 'Alla videor',
    totalVideos: 'totalt antal videor',
    loadingVideos: 'Laddar videor...',
    noVideosYet: 'Inga videor ännu',
    noVideosDesc: 'Skapa din första animation för att komma igång!',
    createVideo: 'Skapa video',
    previous: 'Föregående',
    next: 'Nästa',
    failedToLoad: 'Misslyckades att ladda videor',

    // Pricing Plans
    pricing: {
      chooseYourPlan: 'Välj din plan',
      planSubtitle: 'Välj den perfekta planen för din läranderesa',
      mostPopular: 'Mest populär',
      currentPlan: 'Nuvarande plan',
      getStarted: 'Kom igång',
      choosePlan: 'Välj plan',
      alreadyFree: 'Alltid gratis',
      allPlansInclude: 'Alla planer inkluderar tillgång till vårt utbildningsinnehållsbibliotek',
      cancelAnytime: 'Avbryt när som helst. Inga dolda avgifter.',
      perMonth: '/mån',
      free: 'Gratis',
      changePlan: 'Ändra plan',
      selectNewPlan: 'Välj en ny plan för att uppgradera eller nedgradera',
      changeNote: 'Ändringar träder i kraft omedelbart. Proportionella avgifter kan tillkomma.',

      // Credit system
      creditSystem: '1 kredit = upp till 30 sekunder video',
      firstWeek: '1:a veckan efter anslutning',
      creditsReset: 'Krediter återställs månadsvis',
      whatsIncluded: 'Vad som ingår',
      bestFor: 'Bäst för',
      credits: 'krediter',
      oneTimePurchase: 'Engångs',

      // Free Plan
      freeTagline: 'Prova AnimLearn med grundläggande funktioner',
      freeInitialCredits: '4 krediter (första 7 dagarna)',
      freeOngoingCredits: '2 krediter per dag',
      freeCreditsNote: '2 videor á 1 min per dag första veckan, sedan 1 video per dag',
      freeBest1: 'Förstagångsanvändare',
      freeBest2: 'Studenter som testar koncept',
      freeBest3: 'Snabba förhandsvisningar',

      // Hobby Plan
      hobbyTagline: 'Perfekt för privatpersoner och lärare',
      hobbyMonthlyCredits: '200 krediter / månad',
      hobbyDaily: 'Upp till 10 videor per dag',
      hobbyBest1: 'Lärare',
      hobbyBest2: 'YouTube-skapare',
      hobbyBest3: 'Regelbundna innehållsskapare',

      // Pro Plan
      proTagline: 'Byggd för avancerade användare och institutioner',
      proMonthlyCredits: '800 krediter / månad',
      proDaily: 'Upp till 50 videor per dag',
      proBest1: 'Kursskapare',
      proBest2: 'EdTech-företag',
      proBest3: 'Team och institutioner',

      // Buy Credits
      creditsPlan: 'Köp krediter',
      creditsTagline: 'Ingen prenumeration krävs',
      creditExplanation: '1 kredit = upp till 30 sekunder video',
      roundingNote: 'Krediter rundas upp baserat på videolängd',
      creditPacks: 'Kreditpaket',
      creditsNeverExpire: 'Krediter upphör aldrig',
      creditsAnyPlan: 'Kan användas på vilken plan som helst',
      creditsOccasional: 'Idealisk för tillfällig användning',

      // Important Notes
      importantNotes: 'Viktiga noteringar',
      longerVideosNote: 'Längre videor använder fler krediter.',
      monthlyResetNote: 'Månatliga prenumerationskrediter återställs varje faktureringscykel.',
      oneTimeNote: 'Engångskrediter kan användas när som helst.',

      // Plans (kept in Swedish)
      freePlan: 'Gratis plan',
      freeVideos: 'Upp till 2–3 videor per dag',
      free720p: '720p upplösning',
      freeVoice: 'En standardröst',
      freeLength: 'Maximal videolängd: upp till 30 sekunder',
      freeQueue: 'Långsammare renderingskö',
      freeWatermark: 'Vattenstämpel inkluderad',
      freeLinks: 'Offentliga videolänkar',

      hobbyPlan: 'Hobbyplan',
      hobbyVideos: 'Upp till 10 videor per dag',
      hobby1080p: '1080p (Full HD) upplösning',
      hobbyVoice: 'Välj en röst från tillgänglig röstlista',
      hobbyLength: 'Maximal videolängd: upp till 2 minuter',
      hobbyRendering: 'Snabbare rendering',
      hobbyNoWatermark: 'Ingen vattenstämpel',
      hobbyPrivate: 'Privat videolagring',

      proPlan: 'Pro-plan',
      proVideos: 'Upp till 50 videor per dag',
      pro1080p: '1080p (Full HD) upplösning',
      proVoiceCloning: 'Röstkloning',
      proVoiceList: 'Välj en röst från tillgänglig röstlista',
      proLength: 'Maximal videolängd: upp till 5 minuter',
      proPriority: 'Prioriterad rendering',
      proBatch: 'Batchvideogenerering',
      proAPI: 'API-åtkomst',
      proBranding: 'Anpassad varumärkesprofilering',
    },
    studio: {
      menuTitle: 'Lärcentrum',
      menuSubtitle: 'Kurser, uppgifter och övning',
      back: 'Tillbaka',
      cancel: 'Avbryt',
      save: 'Spara',
      delete: 'Ta bort',
      edit: 'Redigera',
      publish: 'Publicera',
      loading: 'Laddar...',
      roleTitle: 'Vilken är din roll?',
      roleTeacher: 'Lärare',
      roleStudent: 'Elev',
      roleTeacherDesc: 'Skapa kurser och uppgifter',
      roleStudentDesc: 'Gå med i en kurs och öva',
      teacher: {
        dashboard: 'Lärarens kontrollpanel',
        myCourses: 'Mina kurser',
        assignments: 'Uppgifter',
        classes: 'Klasser',
        analytics: 'Analys',
        addCourse: 'Lägg till kurs',
        uploadSyllabus: 'Ladda upp kursplan',
        courseTitle: 'Kursnamn',
        courseDescription: 'Beskrivning',
        language: 'Språk',
        uploadPdf: 'Ladda upp PDF',
        dragDrop: 'Dra och släpp PDF här, eller klicka för att välja',
        startCreating: 'Börja skapa',
        extractConcepts: 'Extrahera begrepp',
        generateVideo: 'Skapa video',
        generateQuestions: 'Skapa frågor med AI',
        addQuestion: 'Lägg till fråga',
        approve: 'Godkänn',
        approved: 'Godkänd',
        questionType: 'Frågetyp',
        multipleChoice: 'Flervalsfråga',
        openEnded: 'Öppen fråga',
        numeric: 'Numerisk',
        questionText: 'Frågetext',
        options: 'Alternativ',
        correctAnswer: 'Rätt svar',
        modelAnswer: 'Modellsvar',
        rubric: 'Bedömningskriterier',
        difficulty: 'Svårighetsgrad',
        bloomLevel: 'Blooms taxonominivå',
        createAssignment: 'Skapa uppgift',
        assignmentTitle: 'Uppgiftsnamn',
        selectCourse: 'Välj kurs',
        selectQuestions: 'Välj frågor',
        timeLimit: 'Tidsgräns (minuter)',
        dueDate: 'Inlämningsdatum',
        showAnswers: 'Visa svar efter inlämning',
        allowRetry: 'Tillåt återförsök',
        inviteCode: 'Inbjudningskod',
        className: 'Klassnamn',
        createClass: 'Skapa klass',
        copyCode: 'Kopiera kod',
        students: 'Elever',
        submissionCount: 'Inlämningar',
        avgScore: 'Genomsnitt',
        exportCsv: 'Exportera CSV',
        heatmap: 'Inlärningskarta',
        struggling: 'Behöver hjälp',
        processing: 'Bearbetar...',
        ready: 'Klar',
        concepts: 'Begrepp',
        selectConcept: 'Välj ett begrepp från listan',
        reExtract: 'Extrahera om',
        clickExtract: 'Klicka "Extrahera begrepp" för att börja',
        processingWait: 'Väntar på PDF-bearbetning...',
        videoRendering: 'Video renderas...',
        questions: 'Frågor',
        noQuestionsYet: 'Inga frågor ännu. Generera med AI eller lägg till manuellt.',
        explanation: 'Förklaring',
        generatedVideo: 'Genererad video',
        linkedVideos: 'Länkade videor',
        pickVideo: 'Välj video från biblioteket',
        noVideosInLibrary: 'Inga färdiga videor i biblioteket',
        addFromLibrary: 'Lägg till från biblioteket',
        addToConceptBtn: 'Lägg till',
        editAssignment: 'Redigera uppgift',
        assignmentType: 'Typ',
        assignmentTypeAssignment: 'Uppgift',
        assignmentTypeTest: 'Test',
        noLimit: 'Ingen gräns',
        noApprovedQuestions: 'Inga godkända frågor hittades. Godkänn frågor i kursredigeraren först.',
        saveChanges: 'Spara ändringar',
        selected: 'valda',
        results: 'Resultat',
        student: 'Elev',
        score: 'Poäng',
        attempt: 'Försök',
        timeCol: 'Tid',
        submittedAt: 'Inlämnad',
        viewDetails: 'Detaljer',
        hide: 'Dölj',
        aiFeedback: 'AI-feedback',
        noSubmissionsYet: 'Inga inlämningar än',
        masteryHeatmap: 'Elev × Begrepp — Behärskning',
        noStudentsYet: 'Inga elever registrerade än',
        strugglingStudents: 'Elever som behöver hjälp',
        noAssignments: 'Inga uppgifter än',
        createFirstAssignment: 'Skapa din första uppgift från godkända frågor',
        dashboardTitle: 'Lärarens kontrollpanel',
        submissions: 'Inlämningar',
        pending: 'Väntar',
        editQuestion: 'Redigera fråga',
        cancel: 'Avbryt',
        saveQuestion: 'Spara fråga',
        openCourse: 'Öppna kurs',
        noCoursesTeacherTitle: 'Inga kurser än',
        noCoursesTeacherDesc: 'Ladda upp en kursplan som PDF för att skapa din första kurs',
        statusReady: 'Klar',
        statusProcessing: 'Bearbetar',
        statusError: 'Fel',
        videoComprehension: 'Videokomprehensionsbetyg',
        reactionGotIt: 'Förstod',
        reactionMostly: 'Till stor del',
        reactionNotQuite: 'Inte riktigt',
        reactionLost: 'Förlorad',
        ratings: 'betyg',
        rating: 'betyg',
        viewStudents: 'Elever',
        hideStudents: 'Dölj',
        noStudentsEnrolled: 'Inga elever ännu. Dela inbjudningskoden ovan.',
        noClasses: 'Inga klasser än',
        createClassDesc: 'Skapa en klass och dela inbjudningskoden med elever',
        studentName: 'Namn',
        email: 'E-post',
        enrolledAt: 'Registrerad',
        published: 'Publicerad',
        transcript: 'Manus',
        regenerate: 'Generera om',
        addAnotherVideo: 'Lägg till en video till',
        primaryVideo: 'Primär video',
        additionalVideos: 'Ytterligare videor',
        renderingVideo: 'Video renderas… detta tar 1–2 minuter',
        noVideoYet: 'Ingen video ännu. Så här fungerar det:',
        videoStep1: 'AI skriver ett manus för det här begreppet',
        videoStep2: 'Läs, redigera eller justera manuset',
        videoStep3: 'Klicka på Generera — videon renderas på ca 1 minut',
        previewTranscriptBtn: 'Förhandsgranska manus och generera video',
        starting: 'Startar…',
        reviewTranscript: 'Granska manus',
        aiWritingTranscript: 'AI skriver manuset…',
        editor: 'Redigerare',
        preview: 'Förhandsvisning',
        hidePreview: 'Dölj förhandsvisning',
        wordsMin: 'ord · ~{min} min video',
        selectTextHint: 'Markera text → Förbättra med AI · Placera markör → Lägg till exempel',
        improveSelection: 'Förbättra markering:',
        improvePlaceholder: 'ex. förenkla för elever, utöka med mer detalj…',
        improving: 'Förbättrar…',
        improve: 'Förbättra',
        addExampleAbout: 'Lägg till exempel om:',
        adding: 'Lägger till…',
        add: 'Lägg till',
        addExample: 'Lägg till exempel',
        startingRender: 'Startar rendering…',
        unapprove: 'Ta bort godkännande',
        extraVideoLabel: 'Vad ska den här videon specifikt täcka?',
        extraVideoPlaceholder: 'T.ex. "Visa ett räkneexempel med siffror"\n"Förklara formelns härledning steg för steg"\n"Fokusera på vanliga misstag elever gör"',
        extraVideoHint: 'Var specifik — det här berättar för AI exakt vilken vinkel den extra videon ska ta.',
        generating: 'Genererar…',
        scannedPdfWarning: 'Skannad PDF hittades. Textextraktionen kan vara ofullständig eller felaktig. För bästa resultat, ladda upp en textbaserad (digitalt skapad) PDF.',
        detectedLanguage: 'PDF-språk identifierat',
        detectedLanguageSuffix: 'Begrepp extraheras på detta språk.',
        pageRange: 'Sidor',
        pageFrom: 'Från',
        pageTo: 'Till',
        exercises: 'Övningsuppgifter',
        loadExercises: 'Ladda uppgifter',
        noExercises: 'Inga övningsuppgifter hittades för det här begreppet i kursplanen.',
        pageLabel: 's.',
        viewPdf: 'Visa PDF',
        hidePdf: 'Dölj PDF',
        noPdfUploaded: 'Ingen kursplan-PDF har laddats upp för den här kursen.',
        selectTextPrompt: 'Markera text för att fråga undervisningsassistenten',
        selectRegionPrompt: 'Dra för att markera en formel eller ett diagram',
        askTeachingAssistant: 'Fråga undervisningsassistenten',
        chatPlaceholder: 'Fråga vad som helst om att undervisa den här kursen — videor, uppgifter, strategier.',
        starterTeach: 'Hur undervisar jag det här ämnet steg för steg?',
        starterQuiz: 'Skapa ett quiz för mina elever',
        starterMisconceptions: 'Vilka missuppfattningar kommer eleverna ha?',
        actionVideo: 'Skapa video',
        actionTeach: 'Hur undervisar jag detta?',
        actionMisconceptions: 'Elevers missuppfattningar',
        actionExamples: 'Lösningsexempel',
        actionAssignment: 'Skapa uppgift',
        actionQuiz: 'Snabbquiz',
        teachingAssistant: 'Undervisningsassistent',
        askFollowUp: 'Ställ en följdfråga…',
        saveDraft: 'Spara som utkast',
        drafts: 'Utkast',
        noDrafts: 'Inga utkast ännu. Markera text eller ett område i PDF:en för att börja.',
        draftTypeVideo: 'Video',
        draftTypeTeach: 'Undervisningsanteckningar',
        draftTypeMisconceptions: 'Missuppfattningar',
        draftTypeExamples: 'Exempel',
        draftTypeAssignment: 'Uppgift',
        draftTypeQuiz: 'Quiz',
        assignToConcept: 'Koppla till begrepp',
        assigned: 'Kopplad',
        unassigned: 'Okopplad',
        discard: 'Kassera',
        addToConceptVideo: 'Lägg till begrepp',
        pushToAssignment: 'Skapa uppgift',
        pickConceptFirst: 'Välj ett begrepp först',
        creatingQuestions: 'Skapar frågor…',
        questionsCreated: 'Frågor skapade!',
        videoQueued: 'Video i kö',
        generatingVideo: 'Skapar video…',
        genQ: {
          title: 'Generera frågor med AI',
          questionTypes: 'Frågetyper',
          typeMultiple: 'Flervalsfråga',
          typeNumeric: 'Beräkning',
          typeOpen: 'Öppen fråga',
          typeTrueFalse: 'Sant / Falskt',
          count: 'Antal',
          difficulty: 'Svårighetsgrad',
          easy: 'Lätt',
          mixed: 'Blandad',
          hard: 'Svår',
          sampleLabel: 'Stilexempel',
          optional: 'valfritt',
          samplePlaceholder: 'Klistra in 1–2 egna tentafrågor — AI matchar stil, djup och format…',
          generate: 'Generera frågor',
        },
        assignmentDetails: 'Uppgiftsdetaljer',
        assignmentTitlePlaceholder: 'T.ex. Kapitel 3 Quiz',
        assignTo: 'Tilldela till',
        allStudents: 'Alla',
        specificStudents: 'Specifika elever',
        addStudents: 'Lägg till elever…',
        addMore: 'Lägg till fler…',
        searchStudents: 'Sök efter namn eller e-post…',
        noStudentsMatch: 'Inga elever matchar sökningen',
        allAdded: 'Alla elever redan tillagda',
        studentSingular: 'elev',
        studentPlural: 'elever',
        done: 'Klar',
        attachments: 'Bilagor',
        addFile: 'Lägg till fil',
        uploading: 'Laddar upp…',
        setIndefinite: 'Rensa',
        available: 'tillgänglig',
        enrolledWillReceive: 'registrerade elever får detta',
        selectAtLeastOne: 'Välj minst en elev',
        assignmentCreated: 'Uppgift skapad',
        assignmentUpdated: 'Uppgift uppdaterad',
        assignmentPublished: 'Uppgift publicerad!',
        assignmentUnpublished: 'Uppgift avpublicerad.',
        uncategorised: 'Okategoriserad',
        assignmentsCount: 'uppgifter',
        live: 'live',
        unpublish: 'Avpublicera',
        newClass: 'Ny klassgrupp',
        classNamePlaceholder: 'T.ex. Fysik 2025',
        course: 'Kurs',
        classCreated: 'Klass skapad!',
        codeCopied: 'Inbjudningskod kopierad!',
        allStudentsBack: 'Alla elever',
        activityTab: 'Aktivitet',
        conversationsTab: 'Konversationer',
        masteryTab: 'Behärskning',
        aiChatsTab: 'AI-chattar',
        noActivity: 'Ingen aktivitet ännu.',
        submissionSingular: 'inlämning',
        submissionPlural: 'inlämningar',
        avgShort: 'snitt',
        noMessages: 'Inga meddelanden ännu.',
        msgShort: 'msg',
        replyPlaceholder: 'Svara eleven…',
        noMasteryData: 'Inga behärskningsdata ännu.',
        attemptSingular: 'försök',
        attemptPlural: 'försök',
        aiChatsDesc: 'Det här är AI-konversationer som eleven hade när hen studerade ditt kursinnehåll.',
        noAiSessions: 'Inga AI-chattsessioner ännu.',
        aiLabel: 'AI',
        studentLabel: 'Elev',
        noStudentsRoster: 'Inga elever ännu',
        studentsEnrollNote: 'Elever visas här när de går med i dina klasser.',
        newBadge: 'ny',
        masteryLabel: 'Behärskning',
        sessions: 'Sessioner',
        submittedCount: 'Inlämnad',
        practiceSessionsLabel: 'Övningssessioner',
      },
      upload: {
        title: 'Ladda upp kursplan',
        courseTitle: 'Kursnamn',
        courseTitlePlaceholder: 'ex. Grundläggande kemi',
        description: 'Beskrivning',
        descriptionPlaceholder: 'Valfri kursbeskrivning',
        language: 'Kursspråk',
        dropZoneTitle: 'Dra och släpp din kursplan-PDF',
        dropZoneSubtitle: 'eller klicka för att bläddra — endast PDF, max 20 MB',
        startProcessing: 'Ladda upp och bearbeta kursplan',
        processing: 'Bearbetar din kursplan...',
        processingNote: 'Detta kan ta 1–3 minuter beroende på PDF-storlek',
        pdfOnly: 'Ladda upp en PDF-fil',
        processingFailed: 'PDF-bearbetning misslyckades. Försök ladda upp igen.',
        timeout: 'Bearbetningen tog för lång tid. Försök igen.',
        selectFile: 'Välj en PDF-fil',
        enterTitle: 'Ange ett kursnamn',
      },
      student: {
        dashboard: 'Elevens kontrollpanel',
        myCourses: 'Mina kurser',
        joinCourse: 'Gå med i kurs',
        enterCode: 'Ange inbjudningskod',
        join: 'Gå med',
        conceptRoadmap: 'Inlärningsväg',
        watchVideo: 'Titta på video',
        practice: 'Öva',
        adaptivePractice: 'Adaptiv övning',
        adaptiveIntro: 'Baserat på dina resultat, här är riktade övningsfrågor för att stärka din förståelse.',
        masteryScore: 'Behärskningspoäng',
        assignments: 'Uppgifter',
        dueDate: 'Inlämningsdatum',
        submitted: 'Inlämnad',
        notStarted: 'Inte påbörjad',
        startAssignment: 'Starta uppgift',
        results: 'Resultat',
        questions: 'Frågor',
        minutes: 'Minuter',
        question: 'F',
        previous: 'Föregående',
        next: 'Nästa',
        submit: 'Lämna in',
        submitting: 'Lämnar in...',
        confirmSubmitTitle: 'Lämna in uppgift?',
        allAnswered: 'Alla frågor besvarade.',
        unanswered: 'frågor obesvarade.',
        excellent: 'Utmärkt!',
        goodJob: 'Bra jobbat!',
        keepPracticing2: 'Fortsätt öva!',
        tryAgain: 'Försök igen',
        questionBreakdown: 'Fråga för fråga',
        masteryUpdated: 'Behärskningspoäng uppdaterat!',
        enterNumber: 'Ange ditt svar...',
        writeAnswer: 'Skriv ditt svar här...',
        sessionNotFound: 'Session hittades inte. Starta en ny övningssession.',
        locked: 'Låst',
        prerequisiteHint: 'Slutför förutsättningsbegreppen först',
        videoProgress: 'Videoframsteg',
        keepPracticing: 'Fortsätt öva',
        dueSoon: 'Förfaller snart',
        completedAssignments: 'Slutförda uppgifter',
        submittedOn: 'Inlämnad',
        progress: 'Framsteg',
        dashboardTitle: 'Min Studio',
        enterInviteCode: 'Ange den 6-teckens inbjudningskod från din lärare',
        joinBtn: 'Gå med i kurs',
        invalidCode: 'Ogiltig inbjudningskod',
        welcome: 'Välkommen',
        welcomeDesc: 'Fortsätt lära dig och följ dina framsteg nedan',
        noCoursesTitle: 'Inga kurser ännu',
        noCoursesDesc: 'Gå med i en kurs med en inbjudningskod från din lärare',
        overallProgress: 'Framsteg',
        open: 'Öppna',
        joinAnotherCourse: 'Gå med i en annan kurs',
        courseProgress: 'Kursframsteg',
        concept: 'Begrepp',
        mastered: 'Behärskad',
        study: 'Studera',
        noConceptsYet: 'Begrepp förbereds av din lärare',
        due: 'Förfallodatum',
        stepWatch: 'Titta på video',
        stepPractice: 'Öva',
        stepAdaptive: 'Adaptiv',
        mastery: 'Behärskning',
        viewTranscript: 'Läs manus',
        transcript: 'Manus',
        transcriptLoading: 'Laddar manus…',
        transcriptNotAvailable: 'Manuset är inte tillgängligt ännu för den här videon.',
        watched: 'Sett',
        proceedToPractice: 'Gå till övning',
        videoNotReady: 'Video förbereds av din lärare',
        noAssignments: 'Inga uppgifter publicerade ännu för denna kurs',
        goToAdaptive: 'Adaptiv övning',
        adaptiveTitle: 'Adaptiv övning',
        adaptiveDesc: 'AI-genererade frågor riktade mot just dina kunskapsluckor',
        currentMastery: 'Nuvarande behärskning',
        startAdaptive: 'Starta adaptiv övning',
        concepts: 'begrepp',
        completeAssignmentFirst: 'Slutför en uppgift för att låsa upp adaptiv övning',
        generating: 'Genererar...',
        chatError: 'Det gick inte att hämta svar',
        askPixelAbout: 'Fråga AnimLearn Tutor om',
        haveQuestion: 'Har du en fråga om',
        haveQuestionSuffix: '? Fråga vad som helst — eller skriv "testa mig" för att öva!',
        askAboutPlaceholder: 'Fråga om',
        start: 'Börja',
        review: 'Granska',
        howWellDidYouUnderstand: 'Hur väl förstod du?',
        communityRating: 'Gemenskapens betyg',
        signInToRate: 'Logga in för att betygsätta',
        reactionGotIt: 'Förstod',
        reactionMostly: 'Till stor del',
        reactionNotQuite: 'Inte riktigt',
        reactionLost: 'Förlorad',
        quizTitle: 'Begreppstest',
        quizSubtitle: 'Testa dina kunskaper innan uppgifterna',
        noQuizQuestions: 'Läraren har inte lagt till övningsfrågor för detta begrepp ännu',
        quizSubmit: 'Kontrollera mina svar',
        quizSubmitting: 'Kontrollerar...',
        quizScore: 'Ditt resultat',
        quizMasteryUpdated: 'Behärskning uppdaterad',
        quizCorrect: 'Rätt',
        quizWrong: 'Fel',
        quizFeedback: 'Återkoppling',
        quizModelAnswer: 'Modellsvar',
        quizContinue: 'Fortsätt till adaptiv övning',
        quizRetry: 'Försök igen',
        quizAnswerPlaceholder: 'Skriv ditt svar...',
        assignmentsSection: 'Lärarens uppgifter',
        assignmentsSectionToggle: 'visa uppgifter',
        stepPracticeTab: 'Öva',
        practiceStart: 'Starta övning',
        practiceStartDesc: 'AI ställer 5 frågor en i taget och förklarar misstag.',
        practiceQuestion: 'Fråga',
        practiceOf: '/',
        practiceAnswerPlaceholder: 'Skriv ditt svar...',
        practiceSubmit: 'Skicka svar',
        practiceSubmitting: 'Kontrollerar...',
        practiceCorrect: 'Rätt! ✓',
        practiceWrong: 'Inte riktigt',
        practiceNext: 'Nästa fråga',
        practiceStop: 'Avsluta övning',
        practiceFinish: 'Slutför',
        practiceDoneTitle: 'Övning klar!',
        practiceScore: 'Ditt resultat',
        practiceMastery: 'Behärskning uppdaterad',
        practiceGoAssignments: 'Gå till uppgifter',
        practiceTryAgain: 'Öva igen',
        startTutor: 'Starta tutor',
        goToAssignments: 'Gå till uppgifter',
        flaggedQuestions: 'Markerad för granskning',
        autoFlagged: 'Automatiskt markerad (felaktigt svar)',
        unflagRevision: 'Ta bort markering',
        flaggedForRevision: 'Markerad för granskning',
        askTeacher: 'Fråga din lärare',
        askTeacherEmpty: 'Inga meddelanden ännu. Fråga läraren vad som helst om det här begreppet.',
        askTeacherPlaceholder: 'Skriv din fråga...',
        aiNotice: 'Dina konversationer med AI-tutorn kan granskas av din lärare för att säkerställa kvalitet och korrekt användning.',
        teacherFeedback: 'Lärarfeedback',
        dismiss: 'Stäng',
        studySpace: 'Studierum',
        history: 'Historik',
        uploadPdf: 'Ladda upp PDF',
        uploadPdfDesc: 'Ladda upp studiematerial och AI skapar inlärningskoncept',
        processing: 'Bearbetar...',
        ready: 'Klar',
        studyNow: 'Börja studera',
        noStudySets: 'Inga studiematerial ännu',
        noStudySetsDesc: 'Ladda upp en PDF för att komma igång',
        noHistory: 'Inga sessioner ännu',
        noHistoryDesc: 'Börja chatta med Pixel AI för att se din historik här',
        knowledgeLevel: 'Kunskapsnivå',
        beginner: 'Nybörjare',
        intermediate: 'Mellannivå',
        advanced: 'Avancerad',
        levelSaved: 'Nivå sparad!',
        studySetLabel: 'Studieset',
        backToSets: 'Tillbaka till studieseten',
        extractingConcepts: 'Extraherar koncept...',
        conceptsReady: 'Koncept klara!',
        deleteSet: 'Ta bort',
        uploadingPdf: 'Laddar upp...',
        newStudySet: 'Nytt studieset',
        studySetTitle: 'Namn på studieset',
        conceptsTab: 'Koncept',
        readTab: 'Läs',
        selectTextPrompt: 'Markera text i PDF:en för att fråga Pixel AI',
        selectRegionPrompt: 'Dra för att fånga en formel eller diagram',
        capturedRegion: 'Fångad region',
        askAboutSelection: 'Fråga om detta',
        readingSession: 'LäsSession',
        pdfTruncated: 'PDF är för lång – visar max (60 sidor / 60 000 tecken)',
        pdfTooLarge: 'PDF är för stor. Max storlek är 25 MB.',
        noTextContent: 'Ingen text tillgänglig från denna PDF',
        passageLabel: 'Valt stycke',
        viewHistory: 'Visa historik',
        closeTranscript: 'Stäng',
        msgCount: 'meddelanden',
        askFollowUp: 'Ställ en följdfråga…',
        continueChat: 'Fortsätt chatten',
        tutorBannerText: 'Få rikare förklaringar, videogenerering och full historik i AnimLearn Tutor.',
        openInTutor: 'Öppna i Tutor',
      },
    },
    homepage: {
      nav: {
        forWho: 'För vem',
        howItWorks: 'Hur det fungerar',
        features: 'Funktioner',
        seeItLive: 'Se live',
        team: 'Team',
        getStarted: 'Kom igång',
      },
      hero: {
        badge: 'AI-driven lärplattform',
        titleLine1: 'Där lärare',
        titleBuild: 'Bygger',
        titleLine2: 'elever',
        titleMaster: 'Bemästrar',
        titleLoggedIn: 'Där lärande blir levande',
        subtitle: 'Ladda upp din läroplan, skapa AI-animerade videolektioner, tilldela adaptiv träning — allt i en plattform byggd för moderna klassrum.',
        pill1: '📚 Läroplansanpassad',
        pill2: '🎬 AI-videolektioner',
        pill3: '🧠 Adaptiv träning',
        pill4: '🌍 3 språk',
        googleBtn: 'Fortsätt med Google',
        startBtn: 'Kom igång gratis',
        playSound: 'Spela med ljud',
        watchDemo: 'Se demo',
      },
      stats: {
        subjects: 'Ämnen täckta',
        videos: 'AI-videolektioner',
        problems: 'Adaptiva problem',
        languages: 'Språk',
        analytics: 'Realtidsanalys',
      },
      forWho: {
        titleNormal: 'Byggt för',
        titleHighlight: 'varje klassrumsroll',
        subtitle: 'Oavsett om du undervisar eller lär dig har AnimLearn en dedikerad arbetsyta för dig',
        teacherTitle: 'För lärare',
        teacherDesc: 'Bygg strukturerade kurser från din läroplan på minuter',
        teacherF1: 'Ladda upp läroplan PDF — AI extraherar koncept automatiskt',
        teacherF2: 'Skapa animerade videolektioner per koncept automatiskt',
        teacherF3: 'Skapa uppgifter med AI-genererade frågebanker',
        teacherF4: 'Spåra elevernas bemästrande med realtidsanalys',
        teacherF5: 'Se förståelsebetyg per video (grön/gul/röd)',
        teacherCta: 'Börja undervisa',
        studentTitle: 'För elever',
        studentDesc: 'Lär via video, öva med AI, bemästra varje koncept',
        studentF1: 'Anmäl dig till lärarskapade kurser med en enkel kod',
        studentF2: 'Titta på AI-animerade lektioner i din egen takt',
        studentF3: 'Öva med adaptiva AI-problem anpassade till din nivå',
        studentF4: 'Slutför uppgifter och få omedelbar AI-feedback',
        studentF5: 'Fråga AnimLearn Tutor vad som helst om konceptet — när som helst',
        studentCta: 'Börja lära',
      },
      hiw: {
        subtitle: 'Från läroplan till bemästrande — den kompletta läranderesans',
        step1Title: 'Läraren laddar upp läroplanen',
        step1Desc: 'Ladda upp en PDF och AI extraherar automatiskt koncept, bygger kursstruktur och föreslår videor.',
        step2Title: 'AI skapar videolektioner',
        step2Desc: 'Varje koncept får en professionell animerad video med röstöver — automatiskt eller lärargranskad.',
        step3Title: 'Elever lär och övar',
        step3Desc: 'Elever anmäler sig, tittar på videor, får AI-genererade adaptiva övningsuppgifter.',
        step4Title: 'Spåra och förbättra',
        step4Desc: 'Lärare ser bemästrandekartor, reaktionsbetyg och uppgiftspoäng. Elever ser sin framsteg.',
      },
      teacherFeatures: {
        label: '🎓 För lärare',
        titlePart1: 'Allt du behöver för att',
        titlePart2: 'bygga en komplett kurs',
        subtitle: 'Från läroplan till elevanalys — allt på ett ställe',
        f1Title: 'Läroplansimport',
        f1Desc: 'Ladda upp vilken PDF-läroplan som helst. AI läser den, extraherar koncept och bygger din kursstruktur.',
        f2Title: 'AI-videogenerering',
        f2Desc: 'Varje koncept får en animerad Manim-video med röstöver. Förhandsgranska transkript innan generering.',
        f3Title: 'Frågebank & uppgifter',
        f3Desc: 'AI genererar frågor på flera Blooms taxonominivåer. Bygg tidsbegränsade uppgifter för klasser.',
        f4Title: 'Elevanalys',
        f4Desc: 'Bemästrandekartor, förståelsereaktionsbetyg, uppgiftspoäng, varningar för kämpande elever.',
        f5Title: 'Klassgrupper',
        f5Desc: 'Skapa elevgrupper med inbjudningskoder. Varje grupp får tillgång till kursinnehåll och uppgifter.',
        f6Title: 'Flerspråkig',
        f6Desc: 'Generera videor på engelska, finska eller svenska. Nå varje elev på deras föredragna språk.',
      },
      studentFeatures: {
        label: '📖 För elever',
        titlePart1: 'Lär på det sätt',
        titlePart2: 'din hjärna älskar',
        subtitle: 'Visuell, interaktiv och adaptiv — lärande som faktiskt fastnar',
        f1Title: 'Titta och förstå',
        f1Desc: 'Animerade konceptvideor med röstöver bryter ner komplexa ämnen steg för steg.',
        f2Title: 'AnimLearn Tutor',
        f2Desc: 'Chatta med AnimLearn Tutor om vilket koncept som helst. Ladda upp bilder, ställ följdfrågor.',
        f3Title: 'Adaptiv träning',
        f3Desc: 'Problem som anpassar sig till din bemästrandenivå. Blir svårare när du förbättras.',
        f4Title: 'Läraruppgifter',
        f4Desc: 'Slutför tidsbegränsade uppgifter satta av din lärare. Få omedelbar AI-feedback på varje svar.',
        f5Title: 'Bemästrande spårning',
        f5Desc: 'Se din framsteg per koncept — stigande, stabil eller behöver arbete. Vet exakt var du ska fokusera.',
        f6Title: 'Betygsätt din förståelse',
        f6Desc: 'Efter varje video, tryck på en smiley för att berätta för din lärare hur väl du förstod.',
        masteryTitle: 'Din bemästran',
        masteryTopics: ['Fotosyntes', 'Celldelning', 'Genetik', 'Evolution'],
        reactionLabel: 'Hur väl förstod du videon?',
        adaptiveTitle: 'Adaptiv träning',
        adaptiveQuestion: 'Vilken roll har klorofyll i fotosyntesen?',
        adaptiveOptions: ['Absorberar ljus', 'Lagrar glukos', 'Transporterar vatten', 'Producerar syre'],
      },
      pixelAcademy: {
        badge: '🏫 För skolor och institutioner',
        title: 'Vi presenterar',
        brand: 'Learning Hub',
        desc: 'En dedikerad lärmiljö för lärare–elev-relationer. Lärare bygger kurser, elever anmäler sig — allt under din skolas varumärkade utrymme.',
        f1: 'Kurs- och läroplanshantering',
        f2: 'Klassgrupper och anmälningar',
        f3: 'Skolövergripande analys',
        f4: 'Läroplansanpassat innehåll',
        cta: 'Gå till Lärcentrum',
      },
      subjects: {
        title: '3 ämnen,',
        titleHighlight: 'oändliga koncept',
        subtitle: 'Täcker hela läroplanen från gymnasium till universitetsnivå',
        biology: 'Biologi',
        economics: 'Ekonomi',
        bioT1: 'Cellbiologi', bioT2: 'Genetik', bioT3: 'Evolution', bioT4: 'Ekologi',
        ecoT1: 'Mikroekonomi', ecoT2: 'Makroekonomi', ecoT3: 'Marknader', ecoT4: 'Finans',
      },
      cta: {
        badge: 'Gå med tusentals inlärare',
        title: 'Redo att förändra hur du undervisar och lär?',
        subtitle: 'Börja gratis idag. Inget kreditkort krävs.',
        googleBtn: 'Registrera dig med Google',
        primaryBtn: 'Kom igång gratis',
      },
      footer: {
        tagline: 'AI-animerat lärande för varje klassrum.',
        product: 'Produkt',
        support: 'Support',
        legal: 'Juridisk',
        privacyPolicy: 'Integritetspolicy',
        termsOfService: 'Användarvillkor',
        copyright: '© 2026 AnimLearn. Alla rättigheter förbehållna.',
        company: 'nordX Labs Oy',
        businessId: 'FO-nummer: 3615236-4',
      },
    },
  },

  en: {
    // Common
    loading: 'Loading...',
    error: 'Error',
    retry: 'Retry',
    back: 'Back',
    logout: 'Logout',
    signIn: 'Sign In',
    signUp: 'Sign Up',
    dashboard: 'Dashboard',
    close: 'Close',
    copy: 'Copy',
    or: 'or',

    // Header/Navigation
    myVideos: 'My Videos',

    // Dashboard
    createAnimation: 'Create Animation',
    createAnimationDesc: 'Generate educational videos for Chemistry, Physics, and Mathematics',
    recentVideos: 'Recent Videos',
    recentVideosDesc: 'Your latest creations',
    viewAllVideos: 'View All Videos',
    backToDashboard: 'Back to Dashboard',
	
	// Dashboard subtitle update
    dashboardSubtitle: 'Content Creator',
    
    // PIXEL AI Section
    pixelAI: {
      title: 'AnimLearn Tutor',
      subtitle: 'Your AI-powered tutor for problem solving and learning',
      menuTitle: 'AnimLearn Tutor',
      menuSubtitle: 'AI Tutor & Problem Solver',
      solverTitle: 'Ask PIXEL',
      solverSubtitle: 'Upload a problem or ask a question to get step-by-step solutions',
      historyTitle: 'Recent Questions',
      historySubtitle: 'Review your past interactions with AnimLearn Tutor',
	  transparencyText: 'AnimLearn Tutor assists with learning and problem-solving. Always verify solutions with textbooks, teachers, or official materials before relying on them for exams.',
      
    },
	
	contentCreator: {
      title: 'Content Creator',
      subtitle: 'Create educational videos with AI-powered animations for Chemistry, Physics, and Mathematics',
      menuTitle: 'Content Creator',
      menuSubtitle: 'Create animated videos',
      
      // Feature badges
      feature1: 'Animated Explanations',
      feature2: 'Multi-language Support',
      feature3: 'Fast Generation',
      
      // Responsibility notice
      responsibilityTitle: 'Create with Accuracy & Responsibility',
      responsibilityText: 'The quality of your video depends on the accuracy of your input. Please provide correct solutions and explanations. Our AI assists with visualization and animation, but you are responsible for ensuring the educational content is accurate. Students and educators rely on your due diligence.',
      privacyWarning: '⚠️ Never input personal information (names, health data, confidential info) into the system, especially for students under 18.',
      
      copyrightNotice: 'Copyright: You retain ownership of generated videos and may share them freely for educational purposes.',
      
      contentSafety: 'Content Safety: All generated content is monitored for age-appropriate material. However, please review videos before sharing with students.',
      
      matricExamFocus: '🎓 Optimized for Finnish, Swedish & English Matriculation Exams',
      
	  point1: 'Verify your solutions before generating',
      point2: 'Double-check formulas and calculations',
      point3: 'Review generated content for accuracy',
	  point4: 'Never input personal or confidential information', // NEW
      point5: 'You own the copyright - share freely for education', // NEW
    },
	
	// Featured Videos Section
    featuredVideos: {	
      title: 'Featured Educational Animations',
      subtitle: 'Explore amazing educational content created with AnimLearn',
      loading: 'Loading featured videos...',
      transcript: 'Transcript',
      communityGallery: {
        title: 'Discover More Amazing Creations',
        description: 'Browse hundreds of educational animations created by our community',
        button: 'Explore Community Gallery'
      },
      language: {
        fi: 'Finnish',
        en: 'English',
        sv: 'Swedish'
      }
    },
	
	videoLanguageModal: {
      title: 'Select Solution Language',
      subtitle: 'Choose the language for the solution',
      finnish: 'Finnish',
      swedish: 'Swedish',
      english: 'English',
      infoText: 'The solution will be generated in the selected language.',
      cancel: 'Cancel',
      solveProblem: 'Solve Problem'
    },
	
	questionHistory: {
	  title: 'Question History',
	  subtitle: 'Review your past questions and solutions',
	  backToProblemSolver: 'Back',
	  downloadAll: 'Download all',
	  
	  // Filters
	  subject: 'Subject',
	  allSubjects: 'All Subjects',
	  chemistry: 'Chemistry',
	  physics: 'Physics',
	  mathematics: 'Mathematics',
	  timeRange: 'Time Range',
	  last7Days: 'Last 7 days',
	  last30Days: 'Last 30 days',
	  last90Days: 'Last 90 days',
	  lastYear: 'Last year',
	  
	  // Question items
	  question: 'Question',
	  solution: 'Solution',
	  video: 'Educational Video',
	  transcript: 'Text Format',
	  
	  // Actions
	  solveAgain: 'Solve Again',
	  generateVideo: 'Generate Video',
	  generatePractice: 'Generate Practice',
	  viewPracticeProblems: 'View Practice Problems',
	  generatingVideo: 'Generating video...',
	  generatingPractice: 'Generating practice...',
	  
	  // Status
	  noQuestions: 'No questions yet',
	  noQuestionsDesc: 'Start by solving your first problem',
	  loading: 'Loading history...',

	  // Chat Sessions tab
	  chatSessions: 'Chat Sessions',
	  loadingSessions: 'Loading sessions...',
	  noSessions: 'No chat sessions yet. Start a conversation in AnimLearn Tutor!',
	  openPixelAI: 'Open AnimLearn Tutor',
	  untitledSession: 'Untitled session',
	  messagesCount: 'messages',
	  resume: 'Resume',
	  videoSolution: 'Video Solution',
	  downloadPDF: 'Download PDF',
	  generating: 'Generating...',
	  viewPractice: 'View Practice',
	  startSolving: 'Start Solving',
	  timePeriod: 'Time Period',
	  practice: 'Practice',

	  backToDashboard: 'Dashboard',
	  history: 'History',
	  
	  subjects: {
		chemistry: 'Chemistry',
		physics: 'Physics',
		mathematics: 'Mathematics'
	  },
	  
	  enterProblem: 'What problem can I help you solve?',
	  problemPlaceholder: 'Type your problem here...\n\nExample: Calculate the pH of a 0.1M HCl solution\n\nYou can also use LaTeX: $x^2 + 5x + 6 = 0$',
	  upload: 'Upload',
	  camera: 'Camera',
	  solve: 'Solve Problem',
	  solving: 'Solving...',
	  
	  yourQuestion: 'Your Question',
	  
	  educationalVideo: 'Educational Video',
	  newProblem: 'New Problem',
	  
	  createVideo: 'Create Video',
	  createVideoDesc: 'Generate animated explanation',
	  generatePracticeDesc: 'Get similar problems',
	  viewHistory: 'View History',
	  viewHistoryDesc: 'See all past questions',
	  videoReady: 'Video Ready!',
	  videoReadyDesc: 'Watch above or download',
	  
	  generatingPracticeDesc: 'Creating practice problems',
	  creatingVideo: 'Creating video...',
	  videoFailed: 'Video generation failed',
	  
	  practiceProblems: 'Practice Problems',
	  practiceSubtitle: 'Master this topic with similar problems',
	  solveProblem: 'Solve This',
	},
	
	modal: {
    solveProblem: 'Practice Problem',
    problem: 'Problem',
    showHint: 'Show Hint',
    hideHint: 'Hide Hint',
    yourSolution: 'Your Solution',
    writeSolution: 'Write your solution here...\n\nYou can use LaTeX: $x^2 + 5x + 6 = 0$',
    checkYourAnswer: 'Did you get it right?',
    correct: 'Correct',
    incorrect: 'Incorrect',
    showSolution: 'Show Complete Solution',
    hideSolution: 'Hide Complete Solution',
    showAnswer: 'Show Answer',
    hideAnswer: 'Hide Answer',
    modelAnswer: 'Model Answer',
    gradingCriteria: 'Grading Criteria',
    completeSolution: 'Complete Solution',
    cancel: 'Close',
    skipToNext: 'Skip',
    submitSolution: 'Submit',
    submitted: 'Submitted ✓',
    greatJob: 'Great job! Solution submitted.',
    keepPracticing: 'Keep practicing! Solution recorded.',
    movingToNext: 'Moving to next problem...',
    previousProblem: 'Previous problem',
    nextProblem: 'Next problem'
  },
	
	problemSolver: {
      // Header
      title: 'Problem Solver',
      subtitle: 'Learn and solve chemistry, physics & math with PIXEL',
      backToDashboard: 'Back',
      
      // Subjects
      subjects: {
        chemistry: 'Chemistry',
        physics: 'Physics',
        mathematics: 'Mathematics'
      },
      
      // Input
      inputLabel: 'Paste or type your problem:',
      inputPlaceholder: 'e.g: Calculate the pH when HCl concentration is 0.01 M',
      takePhoto: 'Take Photo',
      uploadImage: 'Upload Image',
      solveButton: 'Solve',
      solving: 'Solving...',
      
      // Solution
      solution: 'Solution',
      newProblem: 'New Problem',
      
      // Video Status
      videoStatus: {
        creating: 'Creating video...',
        queued: 'Video queued...',
        rendering: 'Video rendering...',
        ready: 'Video ready!',
        failed: 'Video creation failed'
      },
      watchVideo: 'Watch Video',
      
      // Next Steps
      nextSteps: 'What would you like to do next?',
      
      // Actions
      actions: {
        createVideo: 'Create Educational Video',
        createVideoDesc: 'Animated step-by-step explanation',
        
        moreProblems: 'Practice Problems',
        moreProblemsDesc: 'Get 3 similar problems',
        
        newProblem: 'New Problem',
        newProblemDesc: 'Solve another problem',
        
        saveNotes: 'Save to Notes',
        saveNotesDesc: 'Add to study notes',
        
        explainConcept: 'Explain Concept',
        explainConceptDesc: 'Learn the theory behind this',
        
        examTips: 'Exam Tips',
        examTipsDesc: 'Common mistakes to avoid'
      },
      
      // Similar Problems
      similarProblems: {
        title: 'Practice Problems',
        subtitle: 'Practice with these similar problems',
        solve: 'Solve',
        difficulty: {
          easy: 'Easy',
          medium: 'Medium',
          hard: 'Hard'
        }
      },
      
      // Errors
      errors: {
        emptyProblem: 'Please type or upload a problem first',
        solveFailed: 'Failed to create solution',
        networkError: 'Network error. Check your connection.'
      },
	  
	  welcomeGreeting: 'Hey there! I’m PIXEL 👋',
		welcomeReady: 'I help you learn and solve chemistry, physics, and math problems',
		welcomeFeature1: 'Clear step-by-step solutions you can follow',
		welcomeFeature2: 'Animated explanations for tricky concepts',
		welcomeFeature3: 'Practice with similar problems to build confidence',
		welcomeStart: 'How would you like to start?',
		typeQuestion: 'Type a Question',
		readyToHelp: 'Ready when you are',
		pixelAI: 'PIXEL',
		question: 'Your Question',
		animatedExplanation: 'Animated Explanation',
		videoStatusMessage: 'This usually takes 1–2 minutes',
		problemsGenerated: 'problems generated',
		analyzing: 'Thinking it through…',
		analyzingDesc: 'Breaking down your chemistry, physics, or math problem',
		selectSubject: 'Choose a Subject',
		enterQuestion: 'Enter your question',
		questionPlaceholder: 'Type your math, physics, or chemistry question here…',
		uploading: 'Uploading your question…',
		practiceReady: 'Practice is ready! 🎯',
		newChat: 'New chat',
		followUpPlaceholder: 'Ask a follow-up question…',
		chemistry: 'Chemistry',
		physics: 'Physics',
		mathematics: 'Mathematics',
		generatePractice: 'Generate Practice',
		generatingVideo: 'Generating video...',
		generatingPractice: 'Generating practice…',
		suggestionSolve: 'Walk me through solving a problem step by step',
		suggestionExplain: 'Explain a concept I\'m struggling with',
		suggestionVideo: 'Create an animated video explanation',
		suggestionPractice: 'Give me practice problems to build confidence',
    },

	pixel: {
      // Navigation
      aiTutor: 'AI Tutor Pixel',
      backToDashboard: 'Back to Dashboard',
      
      // Welcome / Onboarding
      welcome: '👋 Hi, I\'m **Pixel**.',
      welcomeDesc: 'I\'m here to help you learn in a way that actually makes sense.',
      
      // AnimLearn capabilities intro
      aboutAnimLearn: 'With the **AnimLearn** app, I can:',
      capability1: '📚 Explain difficult concepts clearly',
      capability2: '🎥 Create educational videos for better understanding',
      capability3: '🧠 Provide practice questions',
      capability4: '🎯 Help with exam preparation',
      capability5: '💡 Offer different depth levels in explanations',
      
      readyMessage: 'Before we start, tell me a bit about yourself 👇',
      
      // Onboarding questions
      onboarding: {
        step1Question: '📚 What are you interested in studying right now?',
        step1Options: ['Math', 'Chemistry', 'Physics', 'Biology', 'Computer Science', 'Just curious'],
        
        step2Question: '🎓 What best describes you?',
        step2Options: ['Middle school student', 'High school student', 'University student', 'Casual learner'],
        
        step3Question: '🎯 What do you want Pixel to help you with most?',
        step3Options: [
          'Understanding concepts',
          'Exam preparation',
          'Visual explanations',
          'Practice questions',
          'Confidence building'
        ],
        
        processing: 'Setting up your preferences...',
        allSet: '✅ **All set!**',
        preferencesSet: 'I\'ve set up your preferences. Now I can help you better.',
        readyToHelp: 'What would you like to learn today?',
      },
      
      // Chat interface
      chat: {
        placeholder: 'Type your question or paste your problem...',
        askQuestion: 'Ask a question',
        uploadImage: 'Upload image',
        takePhoto: 'Take photo',
        analyzing: 'Analyzing your question...',
        generating: 'Generating answer...',
      },
      
      // Action buttons (after answer)
      actions: {
        title: 'What would you like to do next?',
        diveDeeper: '🔍 Dive deeper',
        practice: '🧠 Practice questions',
        similar: '🔄 Similar question',
        createVideo: '🎥 Create educational video',
        askNew: '❓ Ask something else',
      },
      
      // Response templates
      responses: {
        dontUnderstand: 'That\'s completely okay — this part confuses a lot of people.',
        tryDifferent: 'Let\'s try a different way.',
        almostRight: 'You\'re close — your idea is good 👍',
        lookAtDetail: 'Let\'s look at one small detail together.',
        pauseMoment: 'Let\'s pause for a moment.',
        focusOne: 'We\'ll focus on just one idea.',
        whichHardest: 'Which part feels hardest right now?',
        notInstant: 'Learning isn\'t about getting it instantly — it\'s about making it click eventually.',
      },
      
      // Learning modes
      modes: {
        examMode: '🎓 Exam Mode',
        exploreMode: '🌱 Explore Mode',
        examActive: '🎓 **Exam Mode on**\nI\'ll keep things focused and exam-relevant.',
        exploreActive: '🌱 **Explore Mode on**\nLet\'s understand *why* this works.',
      },
      
      // Status messages
      status: {
        online: 'Online',
        thinking: 'Thinking...',
        typing: 'Typing...',
      },
      
      // Error messages
      errors: {
        failedToLoad: 'Failed to load response',
        tryAgain: 'Try again',
        networkError: 'Network error. Check your connection.',
      },
      
      // Pixel AI Welcome
		

    },

    // Authentication
    auth: {
      welcomeBack: 'Welcome Back',
      signInToContinue: 'Sign in to continue learning',
      createAccount: 'Create Account',
      startLearning: 'Start learning with animation',
      continueWithGoogle: 'Continue with Google',
      signUpWithGoogle: 'Sign Up with Google',
      fullName: 'Full Name',
      email: 'Email',
      password: 'Password',
      confirmPassword: 'Confirm Password',
      signInButton: 'Sign In',
      signUpButton: 'Create Account',
      signingIn: 'Signing in...',
      creatingAccount: 'Creating Account...',
      dontHaveAccount: "Don't have an account?",
      alreadyHaveAccount: 'Already have an account?',
      passwordRequirements: 'At least 8 characters with uppercase, lowercase, and number',
      // Error messages
      passwordsNoMatch: 'Passwords do not match',
      passwordTooShort: 'Password must be at least 8 characters',
      passwordRequirementsError: 'Password must contain uppercase, lowercase, and number',
      googleSignInFailed: 'Failed to initiate Google sign-in',
      googleSignUpFailed: 'Failed to initiate Google sign-up',
    },
	share: {
      title: 'Share Video',
      directLink: 'Direct Link',
      directLinkDesc: 'Share this link to view the video on AnimLearn',
      embedCode: 'Embed Code',
      embedDesc: 'Embed this video on your website with AnimLearn branding',
      preview: 'Preview',
      advancedOptions: 'Advanced Options',
      minimalEmbed: 'Minimal Embed (No Footer)',
      responsiveEmbed: 'Responsive Embed (16:9)',
      feature1: 'Video plays anywhere',
      feature2: 'AnimLearn branding included',
      feature3: 'Responsive and mobile-friendly',
    },
	videoCard: {
      // Actions
      share: 'Share',
      delete: 'Delete',
      showInfo: 'Show info',
      hideInfo: 'Hide info',
      viewFullDetails: 'View Full Details',
	  transcript:'Download transcript',
      questionImage: 'Question Image',
      viewQuestionImage: 'View question image',
      makePublic: 'Publish to gallery',
      makePrivate: 'Hide from gallery',
      public: 'Public',
      
      // Labels
      language: 'Language',
      quality: 'Quality',
      subject: 'Subject',
      created: 'Created',
      fileSize: 'Size',
      duration: 'Duration',
      prompt: 'Prompt',
      
      // Values
      untitled: 'Untitled Video',
      noSubject: 'General',
      unknown: 'Unknown',
      
      // Messages
      linkCopied: 'Video link copied to clipboard!',
      confirmDelete: 'Are you sure you want to delete this video?',
      deleteError: 'Failed to delete video',
      noVideoSupport: 'Your browser does not support the video tag.',
    },
	publicGallery: {
      title: 'Community Gallery',
      subtitle: 'Explore public creations from our community',
      menuTitle: 'Community Gallery',
      menuSubtitle: 'Explore public creations',
      publicVideos: 'public videos',
      allSubjects: 'All Subjects',
      allLanguages: 'All Languages',
      mostRecent: 'Most Recent',
      mostPopular: 'Most Popular',
      oldest: 'Oldest First',
      page: 'Page',
      of: 'of',
      previous: 'Previous',
      next: 'Next',
      today: 'Today',
      yesterday: 'Yesterday',
      daysAgo: 'days ago',
      weeksAgo: 'weeks ago',
      noVideos: 'No public videos yet',
      noVideosDesc: 'Be the first to create and share a video!',
      searchPlaceholder: 'Search videos...',
      search: 'Search',
      loading: 'Loading videos...',
      video: 'video',
      videos: 'videos',
      general: 'General',
      questionImage: 'Question Image',
	   creator: 'Creator',
		uploaded: 'Uploaded',
		views: 'Views',
		duration: 'Duration',
		showDetails: 'Details',
		hideDetails: 'Hide',
		share: 'Share',
    },

	settings: {
      menuTitle: 'Settings',
      menuSubtitle: 'Profile & security',
      title: 'Account Settings',
      subtitle: 'Manage your profile and account preferences',
      back: 'Back',
      memberSince: 'Member since',
      // Profile section
      profileSection: 'Profile',
      fullName: 'Full Name',
      language: 'Language',
      saveChanges: 'Save Changes',
      saving: 'Saving...',
      saved: 'Saved!',
      // Password section
      passwordSection: 'Change Password',
      currentPassword: 'Current Password',
      newPassword: 'New Password',
      confirmPassword: 'Confirm New Password',
      updatePassword: 'Update Password',
      updating: 'Updating...',
      passwordUpdated: 'Password updated successfully!',
      passwordMismatch: 'Passwords do not match',
      passwordTooWeak: 'Min 8 chars: uppercase, lowercase and number required',
      googleAccount: 'Google account — password change not available',
      // Danger zone
      dangerZone: 'Danger Zone',
      deleteAccount: 'Delete Account',
      deleteWarning: 'This permanently deletes your account and all your data. This cannot be undone.',
      deleteConfirmLabel: 'Type DELETE to confirm',
      deleteConfirmPlaceholder: 'Type DELETE here',
      deleteConfirmBtn: 'Permanently Delete My Account',
      deleting: 'Deleting...',
    },

	creditHistory: {
      // Menu
      menuTitle: 'Credit History',
      menuSubtitle: 'View transaction history',

      
      // Modal header
      title: 'Credit History',
      transactions: 'transactions',
      
      // Transaction types
      deduction: 'Video Generation',
      reset: 'Daily Reset',
      purchase: 'Credit Purchase',
      bonus: 'Bonus Credits',
      refund: 'Refund',
      
      // Time formatting
      justNow: 'Just now',
      minsAgo: 'm ago',
      hoursAgo: 'h ago',
      daysAgo: 'd ago',
      
      // Labels
      balance: 'Balance',
      page: 'Page',
      
      // Empty state
      noTransactions: 'No transactions yet',
      noTransactionsDesc: 'Your credit transactions will appear here',
    },

    // Prompt Input / Video Generation
    prompt: {
		
		
		renderingVideo: "Rendering video, please wait...",
		pleaseWait: "This may take a few moments...",
		
      // Duration
		duration: 'Duration',
		quick: 'Quick',
		standard: 'Standard',
		detailed: 'Detailed',
		comprehensive: 'Comprehensive',
		indepth: 'In-depth',
		
		// Settings
		quality: 'Quality',
		fast: 'Fast',
		recommended: 'Recommended',
		high: 'High',
		best: 'Best',
		
		aspectRatio: 'Aspect Ratio',
		landscape: 'Landscape',
		vertical: 'Vertical',
		square: 'Square',
		portrait: 'Portrait',
		
		voiceoverLanguage: 'Voiceover',
		finnish: 'Finnish',
		english: 'English',
		swedish: 'Swedish',
		
		estimatedRenderTime: 'Estimated render time',
		
		// Tab titles and descriptions
		quickGenerateTitle: 'Quick Generate',
		quickGenerateDesc: 'Instant AI video generation - describe what you want to animate and get your video in seconds',
		
		aiGenerateTitle: 'AI Generate',
		aiGenerateDesc: 'Review and edit the AI-generated code before rendering your video',
		
		customCodeTitle: 'Custom Code',
		customCodeDesc: 'Write your own Manim code with full control over the animation',
		
		// Form labels
		whatToAnimate: 'What do you want to animate?',
		describeAnimation: 'Describe your animation',
		sceneName: 'Scene Name',
		manimCode: 'Manim Code',
		generatedCode: 'Generated Code',
		
		// Placeholders
		quickPlaceholder: 'Example: Explain ionic bonding between sodium and chlorine...',
		aiPlaceholder: 'Example: Create an animation showing ionic bonding...',
		codePlaceholder: 'from manim import *\nfrom manim_voiceover import VoiceoverScene\n...',
		
		// Buttons
		generateVideo: '🚀 Generate Video',
		generatingVideo: '🎬 Generating Video...',
		generateCode: '✨ Generate Code',
		generatingCode: '⚙️ Generating Code...',
		renderVideo: '🎬 Render Video',
		rendering: '🎬 Rendering...',
		backToEdit: 'Back to Edit',
		
		// Examples
		tryExamples: 'Try these examples',
		exampleWater: 'Explain water molecule structure',
		examplePH: 'Show pH scale from 0 to 14',
		exampleIonic: 'Demonstrate ionic bonding',
		exampleCovalent: 'Explain covalent bonding',
		exampleElectron: 'Show electron configuration of oxygen',
		
		// Status
		scene: 'Scene',
		autoDetected: 'Auto-detected',
		codeRequirement: 'Must include VoiceoverScene and all required imports',
		
		// Quota
		quotaReached: 'Daily video limit reached',
		videosRemaining: 'video(s) remaining today',
		generatedToday: 'You\'ve generated',
		videosToday: 'videos today',
		resetsAt: 'Resets at',
		
		// Service status
		serviceOffline: 'Rendering service is offline',
		
		// Errors
		generateVideoError: 'Failed to generate video',
		generateCodeError: 'Failed to generate code',
		renderVideoError: 'Failed to render video',
    },

    // Video Details Modal
    videoDetails: {
      title: 'Video Details',
      info: 'Info',
      promptTab: 'Prompt',
      code: 'Code',
      sceneName: 'Scene Name',
      status: 'Status',
      quality: 'Quality',
      language: 'Language',
      created: 'Created',
      fileSize: 'File Size',
      duration: 'Duration',
      errorMessage: 'Error',
      originalPrompt: 'Original Prompt',
      manimCode: 'Manim Code',
      copyCode: 'Copy Code',
      openVideo: 'Open Video',
      loadingDetails: 'Loading details...',
      videoNotFound: 'Video not found',
      failedToLoad: 'Failed to load details',
      copiedToClipboard: 'Copied to clipboard!',
      // Status values
      pending: 'Pending',
      processing: 'Processing',
      completed: 'Completed',
      failed: 'Failed',
    },

    // HomePage
	
	// What We Do Section
    whatWeDo: 'What AnimLearn Does',
    whatWeDoSubtitle: 'Transform your exam preparation with PIXEL’s AI-powered animated solutions',
    
    uploadProblem: 'Upload Your Problem',
    uploadProblemDesc: 'Take a photo or type your Chemistry, Physics, or Math question from past exam papers',
    
    aiAnalyzes: 'PIXEL Creates Solution',
    aiAnalyzesDesc: 'AnimLearn generates a detailed step-by-step solution with clear explanations',
    
    watchAnimation: 'Watch Animated Video',
    watchAnimationDesc: 'Learn visually with professional animations and voiceover in Finnish, Swedish, or English',
    
    practiceSimilar: 'Practice Similar Problems',
    practiceSimilarDesc: 'Generate variations at different difficulty levels to master the concept',
    
    // Key Results
    result1: 'Perfect for Matriculation Exams (YO-kirjoitukset)',
    result2: 'Step-by-step solutions you can understand',
    result3: 'Practice with AI-generated similar problems',
    result4: 'Track your progress and review past solutions',
	
    heroTitle: 'Learn Visually, Understand Deeply',
    heroDescription: 'Create stunning educational animations for Chemistry, Physics, and Mathematics. Perfect for students preparing for matriculation exams.',
	
	heroTrustStatement: 'AnimLearn is a free learning support tool for students preparing for matriculation exams. Use it alongside textbooks and teachers.',
    
    // Transparency Section
    transparencyTitle: 'What AnimLearn Is - and Is Not',
    transparencySubtitle: 'We are transparent about how AnimLearn works and what its limitations are',
    whatWeAre: 'AnimLearn IS',
    whatWeAreNot: 'AnimLearn IS NOT',
    isItem1: 'A tool that visualizes standard textbook and exam-level solutions',
    isItem2: 'Designed to help students understand why steps are taken',
    isItem3: 'Focused on Physics, Chemistry, and Mathematics at high school/matriculation exam level',
    isItem4: 'A free learning support tool to be used alongside textbooks',
    isNotItem1: 'Not an authoritative answer checker',
    isNotItem2: 'Not a replacement for teachers or textbooks',
    isNotItem3: 'Not guaranteed to be correct in every case',
    isNotItem4: 'Not suitable for advanced chemical synthesis or unsafe procedures',
    
    // AI Limitations Section
    aiLimitationsTitle: 'AI Usage & Limitations',
    aiLimitationsIntro: 'AnimLearn uses AI to support learning. It is important to understand how and when to trust AI-generated content.',
    limitation1Title: 'Curriculum-aligned content',
    limitation1Desc: 'AI generates explanations and animations based on standard curricula, but it is not always perfect',
    limitation2Title: 'Possible errors',
    limitation2Desc: 'AI outputs may contain errors or simplifications. Always verify answers with textbooks or teachers',
    limitation3Title: 'For concept understanding',
    limitation3Desc: 'AnimLearn is intended for concept understanding, not blind execution or copying answers',
    limitation4Title: 'Teacher is most important',
    limitation4Desc: 'Use AnimLearn to supplement, not replace, teacher guidance and official materials',
    verificationReminder: '💡 Always verify answers with textbooks, teachers, or official exam materials before trusting them in an exam',
    
    // Curriculum Section
    curriculumTitle: 'Aligned with Finnish High School Curriculum',
    curriculumSubtitle: 'Content is designed to support Finnish high school students learning and matriculation exam preparation',
    yoExamPrep: 'Matriculation Exam Preparation',
    yoExamPrepDesc: 'Content focuses on topics and problem types that appear in matriculation exams',
    lukioAligned: 'High School Curriculum Aligned',
    lukioAlignedDesc: 'Subject areas correspond to Finnish high school physics, chemistry, and mathematics courses',
    standardTopics: 'Standard topics and theory',
    standardTopicsDesc: 'Focuses on theory, visualization, and understanding exam-style reasoning',
    
    // Safety Notice
    safetyTitle: 'Important Safety Notice (Especially for Chemistry)',
    safetyDescription: 'AnimLearn does NOT provide experimental or synthesis instructions. Avoids laboratory-level or real-world chemical procedure guidance. Emphasizes theory, visualization, and exam-style reasoning only. Never attempt to perform chemical experiments based on AnimLearn explanations.',
    
    // Footer Disclaimer
    footerDisclaimerTitle: '📋 Important Notice for Learners',
    footerDisclaimerText: 'AnimLearn is a learning support tool. AI-generated content should always be verified with textbooks, teachers, or official curriculum materials. Use AnimLearn for active learning, not passive copying of answers.',
	
	
    continueWithGoogle: 'Continue with Google',
    signUpWithEmail: 'Sign Up with Email',
    goToDashboard: 'Go to Dashboard',

    // Featured Section
    chemistry: 'Chemistry',
    physics: 'Physics',
    mathematics: 'Mathematics',

    // Features
    whyAnimLearn: 'Why AnimLearn?',
    aiPowered: 'AI-Powered Generation',
    aiPoweredDesc: 'Describe your concept, and our AI creates beautiful animations instantly',
    examFocused: 'Exam-Focused Content',
    examFocusedDesc: 'Aligned with Finnish matriculation exam curriculum',
    multiLanguage: 'Multi-Language Support',
    multiLanguageDesc: 'Available in Finnish, English, and Swedish',
    fastEasy: 'Fast & Easy',
    fastEasyDesc: 'Generate educational videos in seconds, not hours',
    downloadShare: 'Download & Share',
    downloadShareDesc: 'Export videos and share with classmates',
    customizable: 'Customizable',
    customizableDesc: 'Edit code and tweak animations to your needs',

    // How It Works
    howItWorks: 'How It Works',
    step1Title: 'Describe Your Concept',
    step1Desc: 'Type what you want to learn: "Show water molecule formation"',
    step2Title: 'AI Generates Animation',
    step2Desc: 'Our AI creates professional educational animation with voiceover',
    step3Title: 'Watch & Learn',
    step3Desc: 'Play, download, or share your personalized learning video',

    // Subjects
    subjectsWeCover: 'Subjects We Cover',
    chemistryTopics: {
      molecular: 'Molecular structures',
      reactions: 'Chemical reactions',
      ph: 'pH and acids/bases',
      electro: 'Electrochemistry',
    },
    physicsTopics: {
      motion: 'Motion and forces',
      energy: 'Energy transformations',
      waves: 'Waves and optics',
      electricity: 'Electricity',
    },
    mathTopics: {
      functions: 'Functions and graphs',
      geometry: 'Geometry',
      calculus: 'Calculus',
      probability: 'Probability',
    },

    // Meet the Team Section
    team: {
      title: 'Meet the Team',
      subtitle: 'Built by educators and learners, for the next generation of Finnish students.',
      founder1Role: 'Co-Founder & CEO',
      founder1Bio: 'Passionate about making quality STEM education accessible through the power of AI and animation. Believes that every student deserves to visualize complex concepts clearly.',
      founder2Role: 'Co-Founder & Chief Product Officer',
      founder2Bio: 'A student herself, Neha brings authentic learner perspective to AnimLearn\'s design. She ensures every feature genuinely helps students prepare for matriculation exams.',
      linkedIn: 'Connect on LinkedIn',
    },

    // CTA Section
    readyToLearn: 'Ready to Learn with Animation?',
    joinStudents: 'Join students across Finland using AnimLearn to ace their exams',
    startLearningFree: 'Start Learning Free',

    // Footer
    learnWithAnimation: 'Learn with Animation',
    product: 'Product',
    features: 'Features',
    subjects: 'Subjects',
    support: 'Support',
    allRightsReserved: '2026 AnimLearn. All rights reserved.',

    // All Videos Page
    allVideos: 'All Videos',
    totalVideos: 'total videos',
    loadingVideos: 'Loading videos...',
    noVideosYet: 'No videos yet',
    noVideosDesc: 'Create your first animation to get started!',
    createVideo: 'Create Video',
    previous: 'Previous',
    next: 'Next',
    failedToLoad: 'Failed to load videos',

    // Pricing Plans
    pricing: {
      chooseYourPlan: 'Choose Your Plan',
      planSubtitle: 'Select the perfect plan for your learning journey',
      mostPopular: 'Most Popular',
      currentPlan: 'Current Plan',
      getStarted: 'Get Started',
      choosePlan: 'Choose Plan',
      alreadyFree: 'Always Free',
      allPlansInclude: 'All plans include access to our educational content library',
      cancelAnytime: 'Cancel anytime. No hidden fees.',
      perMonth: '/month',
      free: 'Free',
      changePlan: 'Change Your Plan',
      selectNewPlan: 'Select a new plan to upgrade or downgrade',
      changeNote: 'Changes will take effect immediately. Prorated charges may apply.',

      // Free Plan
      freePlan: 'Free Plan',
      freeVideos: 'Up to 2–3 videos per day',
      free720p: '720p resolution',
      freeVoice: 'One default voice',
      freeLength: 'Maximum video length: up to 30 seconds',
      freeQueue: 'Slower rendering queue',
      freeWatermark: 'Watermark included',
      freeLinks: 'Public video links',

      // Hobby Plan
      hobbyPlan: 'Hobby Plan',
      hobbyVideos: 'Up to 10 videos per day',
      hobby1080p: '1080p (Full HD) resolution',
      hobbyVoice: 'Choose a voice from the available voice list',
      hobbyLength: 'Maximum video length: up to 2 minutes',
      hobbyRendering: 'Faster rendering',
      hobbyNoWatermark: 'No watermark',
      hobbyPrivate: 'Private video storage',

      // Pro Plan
      proPlan: 'Pro Plan',
      proVideos: 'Up to 50 videos per day',
      pro1080p: '1080p (Full HD) resolution',
      proVoiceCloning: 'Voice cloning',
      proVoiceList: 'Choose a voice from the available voice list',
      proLength: 'Maximum video length: up to 5 minutes',
      proPriority: 'Priority rendering',
      proBatch: 'Batch video generation',
      proAPI: 'API access',
      proBranding: 'Custom branding',
    },
    studio: {
      menuTitle: 'Learning Hub',
      menuSubtitle: 'Courses, Assignments & Practice',
      back: 'Back',
      cancel: 'Cancel',
      save: 'Save',
      delete: 'Delete',
      edit: 'Edit',
      publish: 'Publish',
      loading: 'Loading...',
      roleTitle: 'What is your role?',
      roleTeacher: 'Teacher',
      roleStudent: 'Student',
      roleTeacherDesc: 'Create courses and assignments',
      roleStudentDesc: 'Join a course and practice',
      teacher: {
        dashboard: 'Teacher Dashboard',
        myCourses: 'My Courses',
        assignments: 'Assignments',
        classes: 'Classes',
        analytics: 'Analytics',
        addCourse: 'Add Course',
        uploadSyllabus: 'Upload Syllabus',
        courseTitle: 'Course Title',
        courseDescription: 'Description',
        language: 'Language',
        uploadPdf: 'Upload PDF',
        dragDrop: 'Drag & drop PDF here, or click to select',
        startCreating: 'Start Creating',
        extractConcepts: 'Extract Concepts',
        generateVideo: 'Generate Video',
        generateQuestions: 'Generate Questions with AI',
        addQuestion: 'Add Question',
        approve: 'Approve',
        approved: 'Approved',
        questionType: 'Question Type',
        multipleChoice: 'Multiple Choice',
        openEnded: 'Open Ended',
        numeric: 'Numeric',
        questionText: 'Question Text',
        options: 'Options',
        correctAnswer: 'Correct Answer',
        modelAnswer: 'Model Answer',
        rubric: 'Grading Rubric',
        difficulty: 'Difficulty',
        bloomLevel: "Bloom's Taxonomy Level",
        createAssignment: 'Create Assignment',
        assignmentTitle: 'Assignment Title',
        selectCourse: 'Select Course',
        selectQuestions: 'Select Questions',
        timeLimit: 'Time Limit (minutes)',
        dueDate: 'Due Date',
        showAnswers: 'Show answers after submission',
        allowRetry: 'Allow multiple attempts',
        inviteCode: 'Invite Code',
        className: 'Class Name',
        createClass: 'Create Class',
        copyCode: 'Copy Code',
        students: 'Students',
        submissionCount: 'Submissions',
        avgScore: 'Avg Score',
        exportCsv: 'Export CSV',
        heatmap: 'Learning Heatmap',
        struggling: 'Struggling Students',
        processing: 'Processing...',
        ready: 'Ready',
        concepts: 'Concepts',
        selectConcept: 'Select a concept from the list',
        reExtract: 'Re-extract',
        clickExtract: 'Click "Extract Concepts" to begin',
        processingWait: 'Waiting for PDF processing...',
        videoRendering: 'Video rendering...',
        questions: 'Questions',
        noQuestionsYet: 'No questions yet. Generate with AI or add manually.',
        explanation: 'Explanation',
        generatedVideo: 'Generated Video',
        linkedVideos: 'Linked Videos',
        pickVideo: 'Pick a Video from Your Library',
        noVideosInLibrary: 'No completed videos found in your library',
        addFromLibrary: 'Add from Library',
        addToConceptBtn: 'Add',
        editAssignment: 'Edit Assignment',
        assignmentType: 'Type',
        assignmentTypeAssignment: 'Assignment',
        assignmentTypeTest: 'Test',
        noLimit: 'No limit',
        noApprovedQuestions: 'No approved questions found. Approve questions in the Course Editor first.',
        saveChanges: 'Save Changes',
        selected: 'selected',
        results: 'Results',
        student: 'Student',
        score: 'Score',
        attempt: 'Attempt',
        timeCol: 'Time',
        submittedAt: 'Submitted',
        viewDetails: 'Details',
        hide: 'Hide',
        aiFeedback: 'AI Feedback',
        noSubmissionsYet: 'No submissions yet',
        masteryHeatmap: 'Student × Concept Mastery',
        noStudentsYet: 'No students enrolled yet',
        strugglingStudents: 'Students Needing Attention',
        noAssignments: 'No assignments yet',
        createFirstAssignment: 'Create your first assignment from approved questions',
        dashboardTitle: 'Teacher Dashboard',
        submissions: 'Submissions',
        pending: 'Pending',
        editQuestion: 'Edit Question',
        cancel: 'Cancel',
        saveQuestion: 'Save Question',
        openCourse: 'Open Course',
        noCoursesTeacherTitle: 'No courses yet',
        noCoursesTeacherDesc: 'Upload a syllabus PDF to create your first course',
        statusReady: 'Ready',
        statusProcessing: 'Processing',
        statusError: 'Error',
        videoComprehension: 'Video Comprehension Ratings',
        reactionGotIt: 'Got it',
        reactionMostly: 'Mostly',
        reactionNotQuite: 'Not quite',
        reactionLost: 'Lost',
        ratings: 'ratings',
        rating: 'rating',
        viewStudents: 'Students',
        hideStudents: 'Hide',
        noStudentsEnrolled: 'No students enrolled yet. Share the invite code above.',
        noClasses: 'No classes yet',
        createClassDesc: 'Create a class and share the invite code with students',
        studentName: 'Name',
        email: 'Email',
        enrolledAt: 'Enrolled',
        published: 'Published',
        transcript: 'Transcript',
        regenerate: 'Regenerate',
        addAnotherVideo: 'Add Another Video',
        primaryVideo: 'Primary Video',
        additionalVideos: 'Additional Videos',
        renderingVideo: 'Rendering primary video… this takes 1–2 minutes',
        noVideoYet: 'No video yet. Here\'s how it works:',
        videoStep1: 'AI writes a transcript/synopsis for this concept',
        videoStep2: 'You read, edit, or adjust the transcript',
        videoStep3: 'Click Generate — video renders in ~1 min',
        previewTranscriptBtn: 'Preview Transcript & Generate Video',
        starting: 'Starting…',
        reviewTranscript: 'Review Transcript',
        aiWritingTranscript: 'AI is writing the transcript…',
        editor: 'Editor',
        preview: 'Preview',
        hidePreview: 'Hide preview',
        wordsMin: 'words · ~{min} min video',
        selectTextHint: 'Select text → Improve with AI · Place cursor → Add Example',
        improveSelection: 'Improve selection:',
        improvePlaceholder: 'e.g. simplify for students, expand with more detail…',
        improving: 'Improving…',
        improve: 'Improve',
        addExampleAbout: 'Add example about:',
        adding: 'Adding…',
        add: 'Add',
        addExample: 'Add Example',
        startingRender: 'Starting render…',
        unapprove: 'Unapprove',
        extraVideoLabel: 'What should this video specifically cover?',
        extraVideoPlaceholder: 'e.g. "Show a worked example with numbers"\n"Explain the formula derivation step by step"\n"Focus on common mistakes students make"',
        extraVideoHint: 'Be specific — this tells AI exactly what angle to take for this additional video.',
        generating: 'Generating…',
        scannedPdfWarning: 'Scanned PDF detected. Text extraction may be incomplete or inaccurate. For best results, upload a text-based (digitally created) PDF.',
        detectedLanguage: 'PDF language detected',
        detectedLanguageSuffix: 'Concepts will be extracted in this language.',
        pageRange: 'Pages',
        pageFrom: 'From',
        pageTo: 'To',
        exercises: 'Practice Exercises',
        loadExercises: 'Load exercises',
        noExercises: 'No exercises found for this concept in the syllabus.',
        pageLabel: 'p.',
        viewPdf: 'View PDF',
        hidePdf: 'Hide PDF',
        noPdfUploaded: 'No syllabus PDF uploaded for this course.',
        selectTextPrompt: 'Select text to ask the teaching assistant',
        selectRegionPrompt: 'Drag to capture a formula or diagram',
        askTeachingAssistant: 'Ask teaching assistant',
        chatPlaceholder: 'Ask me anything about teaching this course — videos, assignments, teaching strategies.',
        starterTeach: 'How do I teach this topic step by step?',
        starterQuiz: 'Create a quiz for my students',
        starterMisconceptions: 'What misconceptions will students have?',
        actionVideo: 'Generate video',
        actionTeach: 'How do I teach this?',
        actionMisconceptions: 'Student misconceptions',
        actionExamples: 'Worked examples',
        actionAssignment: 'Create assignment',
        actionQuiz: 'Quick quiz',
        teachingAssistant: 'Teaching Assistant',
        askFollowUp: 'Ask a follow-up…',
        saveDraft: 'Save to Drafts',
        drafts: 'Drafts',
        noDrafts: 'No drafts yet. Select text or a region from the PDF to start.',
        draftTypeVideo: 'Video',
        draftTypeTeach: 'Teaching Notes',
        draftTypeMisconceptions: 'Misconceptions',
        draftTypeExamples: 'Examples',
        draftTypeAssignment: 'Assignment',
        draftTypeQuiz: 'Quiz',
        assignToConcept: 'Assign to concept',
        assigned: 'Assigned',
        unassigned: 'Unassigned',
        discard: 'Discard',
        addToConceptVideo: 'Add to concept',
        pushToAssignment: 'Push to assignment',
        pickConceptFirst: 'Pick a concept first',
        creatingQuestions: 'Creating questions…',
        questionsCreated: 'Questions created!',
        videoQueued: 'Video queued',
        generatingVideo: 'Generating video…',
        genQ: {
          title: 'Generate Questions with AI',
          questionTypes: 'Question types',
          typeMultiple: 'Multiple choice',
          typeNumeric: 'Numeric / calculation',
          typeOpen: 'Open-ended',
          typeTrueFalse: 'True / False',
          count: 'How many',
          difficulty: 'Difficulty',
          easy: 'Easy',
          mixed: 'Mixed',
          hard: 'Hard',
          sampleLabel: 'Style example',
          optional: 'optional',
          samplePlaceholder: 'Paste 1–2 of your own exam questions — AI will match the style, depth, and format…',
          generate: 'Generate',
        },
        assignmentDetails: 'Assignment Details',
        assignmentTitlePlaceholder: 'e.g. Chapter 3 Quiz',
        assignTo: 'Assign To',
        allStudents: 'Everyone',
        specificStudents: 'Specific students',
        addStudents: 'Add students…',
        addMore: 'Add more…',
        searchStudents: 'Search by name or email…',
        noStudentsMatch: 'No students match your search',
        allAdded: 'All students already added',
        studentSingular: 'student',
        studentPlural: 'students',
        done: 'Done',
        attachments: 'Attachments',
        addFile: 'Add File',
        uploading: 'Uploading…',
        setIndefinite: 'Clear',
        available: 'available',
        enrolledWillReceive: 'enrolled students will receive this',
        selectAtLeastOne: 'Select at least one student',
        assignmentCreated: 'Assignment created',
        assignmentUpdated: 'Assignment updated',
        assignmentPublished: 'Assignment published!',
        assignmentUnpublished: 'Assignment unpublished.',
        uncategorised: 'Uncategorised',
        assignmentsCount: 'assignments',
        live: 'live',
        unpublish: 'Unpublish',
        newClass: 'New Class Group',
        classNamePlaceholder: 'e.g. Physics 2025',
        course: 'Course',
        classCreated: 'Class created!',
        codeCopied: 'Invite code copied!',
        allStudentsBack: 'All students',
        activityTab: 'Activity',
        conversationsTab: 'Conversations',
        masteryTab: 'Mastery',
        aiChatsTab: 'AI Chats',
        noActivity: 'No activity yet.',
        submissionSingular: 'submission',
        submissionPlural: 'submissions',
        avgShort: 'avg',
        noMessages: 'No messages yet.',
        msgShort: 'msg',
        replyPlaceholder: 'Reply to student…',
        noMasteryData: 'No mastery data yet.',
        attemptSingular: 'attempt',
        attemptPlural: 'attempts',
        aiChatsDesc: 'These are AI conversations this student had while studying your course content.',
        noAiSessions: 'No AI chat sessions yet.',
        aiLabel: 'AI',
        studentLabel: 'Student',
        noStudentsRoster: 'No students yet',
        studentsEnrollNote: 'Students will appear here once they enrol in your classes.',
        newBadge: 'new',
        masteryLabel: 'Mastery',
        sessions: 'Sessions',
        submittedCount: 'Submitted',
        practiceSessionsLabel: 'Practice Sessions',
      },
      upload: {
        title: 'Upload Syllabus',
        courseTitle: 'Course Title',
        courseTitlePlaceholder: 'e.g. Chemistry Fundamentals',
        description: 'Description',
        descriptionPlaceholder: 'Optional course description',
        language: 'Course Language',
        dropZoneTitle: 'Drag & drop your syllabus PDF',
        dropZoneSubtitle: 'or click to browse — PDF only, max 20 MB',
        startProcessing: 'Upload & Process Syllabus',
        processing: 'Processing your syllabus...',
        processingNote: 'This may take 1–3 minutes depending on PDF size',
        pdfOnly: 'Please upload a PDF file',
        processingFailed: 'PDF processing failed. Try uploading again.',
        timeout: 'Processing timed out. Please try again.',
        selectFile: 'Please select a PDF file',
        enterTitle: 'Please enter a course title',
      },
      student: {
        dashboard: 'Student Dashboard',
        myCourses: 'My Courses',
        joinCourse: 'Join Course',
        enterCode: 'Enter invite code',
        join: 'Join',
        conceptRoadmap: 'Learning Roadmap',
        watchVideo: 'Watch Video',
        practice: 'Practice',
        adaptivePractice: 'Adaptive Practice',
        adaptiveIntro: 'Based on your results, here are targeted practice questions to strengthen your understanding.',
        masteryScore: 'Mastery Score',
        assignments: 'Assignments',
        dueDate: 'Due Date',
        submitted: 'Submitted',
        notStarted: 'Not Started',
        startAssignment: 'Start Assignment',
        results: 'Results',
        questions: 'Questions',
        minutes: 'Minutes',
        question: 'Q',
        previous: 'Previous',
        next: 'Next',
        submit: 'Submit',
        submitting: 'Submitting...',
        confirmSubmitTitle: 'Submit Assignment?',
        allAnswered: 'All questions answered.',
        unanswered: 'question(s) unanswered.',
        excellent: 'Excellent!',
        goodJob: 'Good work!',
        keepPracticing2: 'Keep practicing!',
        tryAgain: 'Try Again',
        questionBreakdown: 'Question Breakdown',
        masteryUpdated: 'Mastery score updated!',
        enterNumber: 'Enter your answer...',
        writeAnswer: 'Write your answer here...',
        sessionNotFound: 'Session not found. Please start a new practice session.',
        locked: 'Locked',
        prerequisiteHint: 'Complete prerequisite concepts first',
        videoProgress: 'Video Progress',
        keepPracticing: 'Keep Practicing',
        dueSoon: 'Due Soon',
        completedAssignments: 'Completed Assignments',
        submittedOn: 'Submitted',
        progress: 'Progress',
        dashboardTitle: 'My Studio',
        enterInviteCode: 'Enter the 6-character invite code from your teacher',
        joinBtn: 'Join Course',
        invalidCode: 'Invalid invite code',
        welcome: 'Welcome',
        welcomeDesc: 'Keep learning and track your progress below',
        noCoursesTitle: 'No courses yet',
        noCoursesDesc: 'Join a course using an invite code from your teacher',
        overallProgress: 'Progress',
        open: 'Open',
        joinAnotherCourse: 'Join Another Course',
        courseProgress: 'Course Progress',
        concept: 'Concept',
        mastered: 'Mastered',
        study: 'Study',
        noConceptsYet: 'Concepts are being prepared by your teacher',
        due: 'Due',
        stepWatch: 'Watch Video',
        stepPractice: 'Practice',
        stepAdaptive: 'Adaptive',
        mastery: 'Mastery',
        viewTranscript: 'Read Transcript',
        transcript: 'Transcript',
        transcriptLoading: 'Loading transcript…',
        transcriptNotAvailable: 'Transcript is not yet available for this video.',
        watched: 'Watched',
        proceedToPractice: 'Proceed to Practice',
        videoNotReady: 'Video is being prepared by your teacher',
        noAssignments: 'No assignments published yet for this course',
        goToAdaptive: 'Adaptive Practice',
        adaptiveTitle: 'Adaptive Practice',
        adaptiveDesc: 'AI-generated questions targeting your specific knowledge gaps',
        currentMastery: 'Current mastery',
        startAdaptive: 'Start Adaptive Practice',
        concepts: 'concepts',
        completeAssignmentFirst: 'Complete an assignment to unlock adaptive practice',
        generating: 'Generating...',
        chatError: 'Failed to get response',
        askPixelAbout: 'Ask AnimLearn Tutor about',
        haveQuestion: 'Have a question about',
        haveQuestionSuffix: '? Ask me anything — or say "test me" to practice!',
        askAboutPlaceholder: 'Ask about',
        start: 'Start',
        review: 'Review',
        howWellDidYouUnderstand: 'How well did you understand?',
        communityRating: 'Community rating',
        signInToRate: 'Sign in to rate',
        reactionGotIt: 'Got it!',
        reactionMostly: 'Mostly got it',
        reactionNotQuite: 'Not quite',
        reactionLost: 'Lost',
        quizTitle: 'Concept Quiz',
        quizSubtitle: 'Test your understanding before assignments',
        noQuizQuestions: 'Your teacher has not added practice questions for this concept yet',
        quizSubmit: 'Check My Answers',
        quizSubmitting: 'Checking...',
        quizScore: 'Your Score',
        quizMasteryUpdated: 'Mastery updated',
        quizCorrect: 'Correct',
        quizWrong: 'Incorrect',
        quizFeedback: 'Feedback',
        quizModelAnswer: 'Model Answer',
        quizContinue: 'Continue to Adaptive Practice',
        quizRetry: 'Try Again',
        quizAnswerPlaceholder: 'Type your answer...',
        assignmentsSection: 'Teacher Assignments',
        assignmentsSectionToggle: 'show assignments',
        stepPracticeTab: 'Practice',
        practiceStart: 'Start Practice',
        practiceStartDesc: 'AI asks you 5 questions one at a time and explains any mistakes.',
        practiceQuestion: 'Question',
        practiceOf: '/',
        practiceAnswerPlaceholder: 'Type your answer...',
        practiceSubmit: 'Submit Answer',
        practiceSubmitting: 'Checking...',
        practiceCorrect: 'Correct! ✓',
        practiceWrong: 'Not quite',
        practiceNext: 'Next Question',
        practiceStop: 'Stop Practice',
        practiceFinish: 'Finish',
        practiceDoneTitle: 'Practice Complete!',
        practiceScore: 'Your Score',
        practiceMastery: 'Mastery updated',
        practiceGoAssignments: 'Go to Assignments',
        practiceTryAgain: 'Practice Again',
        startTutor: 'Start tutor',
        goToAssignments: 'Go to Assignments',
        flaggedQuestions: 'Flagged for Revision',
        autoFlagged: 'Auto-flagged (wrong answer)',
        unflagRevision: 'Remove flag',
        flaggedForRevision: 'Flagged for revision',
        askTeacher: 'Ask your teacher',
        askTeacherEmpty: 'No messages yet. Ask your teacher anything about this concept.',
        askTeacherPlaceholder: 'Type your question...',
        aiNotice: 'Your conversations with the AI tutor may be reviewed by your teacher to ensure quality and appropriate use.',
        teacherFeedback: 'Teacher Feedback',
        dismiss: 'Dismiss',
        studySpace: 'Study Space',
        history: 'History',
        uploadPdf: 'Upload PDF',
        uploadPdfDesc: 'Upload study material and AI will create learning concepts from it',
        processing: 'Processing...',
        ready: 'Ready',
        studyNow: 'Study Now',
        noStudySets: 'No study materials yet',
        noStudySetsDesc: 'Upload a PDF to get started',
        noHistory: 'No sessions yet',
        noHistoryDesc: 'Start chatting with Pixel AI to see your history here',
        knowledgeLevel: 'Knowledge Level',
        beginner: 'Beginner',
        intermediate: 'Intermediate',
        advanced: 'Advanced',
        levelSaved: 'Level saved!',
        studySetLabel: 'Study Set',
        backToSets: 'Back to Study Sets',
        extractingConcepts: 'Extracting concepts...',
        conceptsReady: 'Concepts ready!',
        deleteSet: 'Delete',
        uploadingPdf: 'Uploading...',
        newStudySet: 'New Study Set',
        studySetTitle: 'Study set name',
        conceptsTab: 'Concepts',
        readTab: 'Read',
        selectTextPrompt: 'Select any text in the PDF to ask Pixel AI about it',
        selectRegionPrompt: 'Drag to capture a formula or diagram',
        capturedRegion: 'Captured region',
        askAboutSelection: 'Ask about this',
        readingSession: 'Reading Session',
        pdfTruncated: 'PDF is too long — showing first 60 pages / 60,000 characters',
        pdfTooLarge: 'PDF is too large. Maximum size is 25 MB.',
        noTextContent: 'No text available from this PDF',
        passageLabel: 'Selected passage',
        viewHistory: 'View history',
        closeTranscript: 'Close',
        msgCount: 'messages',
        askFollowUp: 'Ask a follow-up…',
        continueChat: 'Continue Chat',
        tutorBannerText: 'Get richer explanations, video generation and full history in AnimLearn Tutor.',
        openInTutor: 'Open in Tutor',
      },
    },
    homepage: {
      nav: {
        forWho: 'For Who',
        howItWorks: 'How It Works',
        features: 'Features',
        seeItLive: 'See It Live',
        team: 'Team',
        getStarted: 'Get Started',
      },
      hero: {
        badge: 'AI-Powered Learning Platform',
        titleLine1: 'Where Teachers',
        titleBuild: 'Build',
        titleLine2: 'Students',
        titleMaster: 'Master',
        titleLoggedIn: 'Where Learning Comes Alive',
        subtitle: 'Upload your syllabus, auto-generate AI animated video lessons, assign adaptive practice — all in one platform built for modern classrooms.',
        pill1: '📚 Syllabus-Aligned',
        pill2: '🎬 AI Video Lessons',
        pill3: '🧠 Adaptive Practice',
        pill4: '🌍 3 Languages',
        googleBtn: 'Continue with Google',
        startBtn: 'Get Started Free',
        playSound: 'Play with Sound',
        watchDemo: 'Watch Demo',
      },
      stats: {
        subjects: 'Subjects Covered',
        videos: 'AI Video Lessons',
        problems: 'Adaptive Problems',
        languages: 'Languages',
        analytics: 'Progress Analytics',
      },
      forWho: {
        titleNormal: 'Built for',
        titleHighlight: 'Every Classroom Role',
        subtitle: 'Whether you teach or learn, AnimLearn has a dedicated workspace for you',
        teacherTitle: 'For Teachers',
        teacherDesc: 'Build structured courses from your syllabus in minutes',
        teacherF1: 'Upload syllabus PDF — AI extracts concepts automatically',
        teacherF2: 'Auto-generate animated video lessons per concept',
        teacherF3: 'Create assignments with AI-generated question banks',
        teacherF4: 'Track student mastery with real-time analytics',
        teacherF5: 'See comprehension ratings per video (green/yellow/red)',
        teacherCta: 'Start Teaching',
        studentTitle: 'For Students',
        studentDesc: 'Learn through video, practice with AI, master every concept',
        studentF1: 'Enroll in teacher-created courses with a simple code',
        studentF2: 'Watch AI animated lessons at your own pace',
        studentF3: 'Practice with adaptive AI problems tailored to your level',
        studentF4: 'Complete assignments and get instant AI feedback',
        studentF5: 'Ask AnimLearn Tutor anything about the concept — anytime',
        studentCta: 'Start Learning',
      },
      hiw: {
        subtitle: 'From syllabus to mastery — the complete learning journey',
        step1Title: 'Teacher Uploads Syllabus',
        step1Desc: 'Upload a PDF and AI automatically extracts concepts, builds course structure, and suggests videos.',
        step2Title: 'AI Generates Video Lessons',
        step2Desc: 'Each concept gets a professional animated video with voiceover — auto-generated or teacher-reviewed.',
        step3Title: 'Students Learn & Practice',
        step3Desc: 'Students enroll, watch videos, get AI-generated adaptive practice questions at their mastery level.',
        step4Title: 'Track & Improve',
        step4Desc: 'Teachers see mastery heatmaps, reaction ratings, and assignment scores. Students see their progress.',
      },
      teacherFeatures: {
        label: '🎓 For Teachers',
        titlePart1: 'Everything You Need to',
        titlePart2: 'Build a Complete Course',
        subtitle: 'From syllabus to student analytics — all in one place',
        f1Title: 'Syllabus Import',
        f1Desc: 'Upload any PDF syllabus. AI reads it, extracts concepts, and builds your course structure automatically.',
        f2Title: 'AI Video Generation',
        f2Desc: 'Each concept gets an animated Manim video with voiceover. Preview transcripts before generating.',
        f3Title: 'Question Bank & Assignments',
        f3Desc: "AI generates questions at multiple Bloom's taxonomy levels. Build timed assignments and publish to classes.",
        f4Title: 'Student Analytics',
        f4Desc: 'Mastery heatmaps, comprehension reaction ratings (😄🙂😕😟), submission scores, struggling student alerts.',
        f5Title: 'Class Groups',
        f5Desc: 'Create student cohorts with invite codes. Each group gets access to course content and assignments.',
        f6Title: 'Multi-Language',
        f6Desc: 'Generate videos in English, Finnish, or Swedish. Reach every student in their preferred language.',
      },
      studentFeatures: {
        label: '📖 For Students',
        titlePart1: 'Learn the Way',
        titlePart2: 'Your Brain Loves',
        subtitle: 'Visual, interactive, and adaptive — learning that actually sticks',
        f1Title: 'Watch & Understand',
        f1Desc: 'Animated concept videos with voiceover break down complex topics step by step.',
        f2Title: 'AnimLearn Tutor',
        f2Desc: 'Chat with AnimLearn Tutor about any concept. Upload images, ask follow-ups — always in context.',
        f3Title: 'Adaptive Practice',
        f3Desc: 'Problems that adjust to your mastery level. Get harder as you improve, easier when you struggle.',
        f4Title: 'Teacher Assignments',
        f4Desc: 'Complete timed assignments set by your teacher. Get instant AI feedback on every answer.',
        f5Title: 'Mastery Tracking',
        f5Desc: 'See your progress per concept — trending up, steady, or needs work. Know exactly where to focus.',
        f6Title: 'Rate Your Understanding',
        f6Desc: 'After each video, tap a smiley to tell your teacher how well you understood it.',
        masteryTitle: 'Your Mastery',
        masteryTopics: ['Photosynthesis', 'Cell Division', 'Genetics', 'Evolution'],
        reactionLabel: 'How did you find this video?',
        adaptiveTitle: 'Adaptive Practice',
        adaptiveQuestion: 'What is the role of chlorophyll in photosynthesis?',
        adaptiveOptions: ['Absorb light energy', 'Store glucose', 'Transport water', 'Produce oxygen'],
      },
      pixelAcademy: {
        badge: '🏫 For Schools & Institutions',
        title: 'Introducing',
        brand: 'Learning Hub',
        desc: 'A dedicated learning environment for teacher–student relationships. Teachers build courses, students enroll — all under your school\'s branded space.',
        f1: 'Course & Syllabus Management',
        f2: 'Class Groups & Enrollment',
        f3: 'School-wide Analytics',
        f4: 'Curriculum-Aligned Content',
        cta: 'Go to Learning Hub',
      },
      subjects: {
        title: '3 Subjects,',
        titleHighlight: 'Endless Concepts',
        subtitle: 'Covering the full curriculum from high school to university level',
        biology: 'Biology',
        economics: 'Economics',
        bioT1: 'Cell Biology', bioT2: 'Genetics', bioT3: 'Evolution', bioT4: 'Ecology',
        ecoT1: 'Microeconomics', ecoT2: 'Macroeconomics', ecoT3: 'Markets', ecoT4: 'Finance',
      },
      cta: {
        badge: 'Join Thousands of Learners',
        title: 'Ready to Transform How You Teach & Learn?',
        subtitle: 'Start free today. No credit card required.',
        googleBtn: 'Sign up with Google',
        primaryBtn: 'Get Started Free',
      },
      footer: {
        tagline: 'AI-powered animated learning for every classroom.',
        product: 'Product',
        support: 'Support',
        legal: 'Legal',
        privacyPolicy: 'Privacy Policy',
        termsOfService: 'Terms of Service',
        copyright: '© 2026 AnimLearn. All rights reserved.',
        company: 'nordX Labs Oy',
        businessId: 'Business ID: 3615236-4',
      },
    },
  },
};


// Add these to your existing translations object under the 'prompt' section

export const exampleTasks = {
  fi: {
    sectionTitle: 'Esimerkkitehtävät (YO-lukiotason)',
    disclaimer: 'AnimLearn hyödyntää tekoälyä selitysten ja animaatioiden luomiseen. Sisältö on tarkoitettu oppimisen tueksi ja voi sisältää yksinkertaistuksia tai virheitä. Tarkista asiat aina oppimateriaalista tai opettajalta.',
    
    chemistry: {
      title: '🧪 Kemia',
      task: 'Galvaaninen kenno: Magnesiumelektrodi on magnesiumsulfaattiliuoksessa ja kuparielektrodi kuparisulfaattiliuoksessa.\n\n1. Kumpi elektrodi toimii anodina ja kumpi katodina?\n2. Mihin suuntaan elektronit liikkuvat ulkoisessa piirissä?\n3. Selitä vastauksesi metallien taipumuksen perusteella luovuttaa tai vastaanottaa elektroneja.'
    },
    
    physics: {
      title: '⚛️ Fysiikka',
      task: 'Kela on asetettu nopeasti muuttuvan magneettikentän lähelle. Kelan päät on kytketty vastukseen.\n\nSelitä, miksi vastuksessa syntyy vaihtovirta magneettikentän muuttuessa. Perustele sähkömagneettisen induktion avulla.'
    },
    
    mathematics: {
      title: '📐 Matematiikka',
      task: 'Ratkaise epäyhtälö:\n(x − 2)(x + 4) > 0\n\nNäytä päättelysi ja merkitse ratkaisu lukusuoralle.'
    }
  },
  
  en: {
    sectionTitle: 'Example Study Tasks (Matriculation Exam Level)',
    disclaimer: 'AnimLearn uses AI to generate explanations and animations. The content is intended as a study aid and may contain simplifications or errors. Always verify with your course material or teacher.',
    
    chemistry: {
      title: '🧪 Chemistry',
      task: 'Galvanic cell: A magnesium electrode is in magnesium sulfate solution and a copper electrode is in copper sulfate solution.\n\n1. Which electrode acts as the anode and which as the cathode?\n2. In which direction do electrons flow in the external circuit?\n3. Explain your answer based on the relative tendency of metals to lose or gain electrons.'
    },
    
    physics: {
      title: '⚛️ Physics',
      task: 'A coil is placed near a rapidly changing magnetic field. The ends of the coil are connected to a resistor.\n\nExplain why an alternating voltage appears across the resistor when the magnetic field changes. Base your explanation on electromagnetic induction.'
    },
    
    mathematics: {
      title: '📐 Mathematics',
      task: 'Solve the inequality:\n(x − 2)(x + 4) > 0\n\nShow your reasoning and indicate the solution on a number line.'
    }
  },
  
  sv: {
    sectionTitle: 'Exempeluppgifter (studentexamensnivå)',
    disclaimer: 'AnimLearn använder AI för att skapa förklaringar och animationer. Innehållet är avsett som studiestöd och kan innehålla förenklingar eller fel. Kontrollera alltid med läromedel eller lärare.',
    
    chemistry: {
      title: '🧪 Kemi',
      task: 'Galvaniskt element: En magnesiumelektrod är i magnesiumsulfatlösning och en kopparelektrod är i kopparsulfatlösning.\n\n1. Vilken elektrod fungerar som anod och vilken som katod?\n2. I vilken riktning rör sig elektroner i den yttre kretsen?\n3. Förklara ditt svar baserat på metallernas relativa benägenhet att förlora eller ta emot elektroner.'
    },
    
    physics: {
      title: '⚛️ Fysik',
      task: 'En spole placeras nära ett snabbt föränderligt magnetfält. Spolens ändar är kopplade till ett motstånd.\n\nFörklara varför en växelspänning uppstår över motståndet när magnetfältet förändras. Basera din förklaring på elektromagnetisk induktion.'
    },
    
    mathematics: {
      title: '📐 Matematik',
      task: 'Lös olikheten:\n(x − 2)(x + 4) > 0\n\nVisa ditt resonemang och markera lösningen på en tallinje.'
    }
  }
};

export const getTranslation = (language, key) => {
  const keys = key.split('.');
  let value = translations[language];
  for (const k of keys) {
    value = value?.[k];
  }
  return value ?? key;
};